let bodyClassList,
    IS_HOME,
    IS_LIST,
    IS_CAMP,
    IS_SEARCH,
    IS_PROD,
    IS_CART,
    //IS_CHECKOUT_AUTH,
    IS_THANKYOU,
    IS_MONTHLY_CAMP_ACTIVE = false;

if (typeof IS_CHECKOUT_AUTH === 'undefined') {
    IS_CHECKOUT_AUTH = false;
}
if (typeof IS_CHECKOUT_PAGE === 'undefined') {
    IS_CHECKOUT_PAGE = false;
}
if (typeof GRUPO_MERCADO === "undefined") {
    GRUPO_MERCADO = false;
}


$(function () {
    bodyClassList = document.body.classList;
    IS_HOME = bodyClassList.contains('new-home');
    IS_LIST = bodyClassList.contains('is-list');
    IS_CAMP = bodyClassList.contains('campaign');
    IS_SEARCH = bodyClassList.contains('search');
    IS_PROD = bodyClassList.contains('is-product');
    IS_CART = bodyClassList.contains('checkout');
    IS_THANKYOU = bodyClassList.contains('thankyou-page');
    IS_MONTHLY_CAMP_ACTIVE = bodyClassList.contains('monthly-campaign'); // Monthly Campaign active

    // blockAffiliates(); // deprecated?

    if ($_GET('logout')) {
        UserInfo.clear();
    }
    if ($_GET('slm')) {
        showModalLogin();
    }

    initDataUrlEvents();
    initBannersDatalayer();
    initLazyLoad();
    initCustomCheckbox();
    handleSearchEngine();
    initSwiper();
    initCountDown();
    initCopyCodeButtons();
    initPetTips();
    initBackToTopButton();

    disableRadioAutocomplete();

    if (!MOBILE) {
        // DESKTOP
        const positionToShowHeaderFloat = IS_PROD ? 1200 : 650;
        const sortAndViewElement = document.querySelector('.refine-bar__sort-and-view');

        window.addEventListener('scroll', function () {
            handleScrollDesktop(
                { positionToShowHeaderFloat, headerFloatOffset: 150 },
                { sortAndViewElement, sortAndViewOffset: 20}
            );
        }, { passive: true });

        $('.main-categories > ul > li, .nav-item').each(function () {
            const idCat = $(this).attr('id_category');
            const catInfo = $(this).find('.main-categories-hover, .new-main-nav-hover');
            const emptyWrapper = $(this).find('.empty-wrapper');
            var theWrapper = (SHOP_ID == 1 || SHOP_ID == 10) ? emptyWrapper : catInfo;
            if (catInfo.length > 0 && idCat) {
                var loadingImg = getLoadingImg('20');
                var divLoading = $('<div />').addClass('loading-menu').append(loadingImg);
                $(theWrapper).append(divLoading);
            }

            $(this).hover(function (e) {
                e.stopPropagation();
                var self = this;
                $(this).find('.new-loading-icon').addClass('is-active');
                if ($('.dropdown-toggle.is-open')) modalClose();
                //TODO: Do a nice fix for brand menu.
                //The DOM is giant and takes time to load on some computers
                //Now we check if attribute rel is present to apply a 0 delay for setTimeout.
                $(this).data("timer", setTimeout(function () {
                    $(self).addClass('hover');
                }, $(this).is("[rel]") ? 0 : 100));

                if (idCat) {
                    loadHoverCategories(catInfo, idCat);
                }

                var overlay = (SHOP_ID == 1 || SHOP_ID == 10) ? $(this).find('.full-overlay') : $(this).find('.nav-item-overlay');
                if (overlay.length) {
                    overlay.hover(function (e) {
                        e.stopPropagation();
                        clearTimeout($(self).data("timer"));
                        var navItem = $(this).closest('.nav-item');
                        navItem.removeClass('hover');
                    })
                }

            }, function (e) {
                e.stopPropagation();
                clearTimeout($(this).data("timer"));
                $(this).removeClass('hover');
                $(this).find('.new-loading-icon').removeClass('is-active');
            });
        });

        /* Countries and languages dropdowns */
        var modalCloseKey = function (event) {
            var keyCode = window.event ? window.event.keyCode : event.which;
            if (keyCode === 27) modalClose();
        };

        var modalClose = function () {
            $('.dropdown-container:visible').slideUp(200);
            $('.overlay-countries-languages:visible').fadeOut(300);
            $('.dropdown.is-open').removeClass('is-open');
            removeEvent(document, "keydown", modalCloseKey);
        };

        $(".dropdown-toggle").click(function () {
            let dropdowns = $('.dropdown');
            let dropdownContainers = $('.dropdown-container');
            let thisDropdownContainer = $(this).next('.dropdown-container');
            let overlay = $('#overlay-countries-languages');
            let input = $('#js-dropdown__input');

            overlay.fadeIn(200);

            if (thisDropdownContainer.is(':hidden')) { // Will be shown
                dropdownContainers.hide(); // hide all dropdowns containers
                dropdowns.removeClass('is-open'); // reset class is-open

                $(this).parent('.dropdown').addClass('is-open');
                addEvent(document, 'keydown', modalCloseKey);

                if ($(this).attr('id') == 'top-countries') {
                    setTimeout(function () {
                        input.focus().select(); // focus and select text input for usability
                    }, 200);
                }
            } else {
                $(this).parent('.dropdown').removeClass('is-open');
                removeEvent(document, 'keydown', modalCloseKey);
                overlay.fadeOut(200);
            }

            $(this).next(".dropdown-container").slideToggle(120);
        });

        $('#overlay-countries-languages').click(modalClose);


        // Load brands asynchronously at Brands menu
        if ($('#js-open-brands-menu').length) {
            $('#js-open-brands-menu').one('mouseenter', function () {
                $('#js-load-brands-menu').load('/modules/cache/topMenuBrands', function () {
                    $('#brands-list-menu').scroll(function () {
                        $('#brands-list-menu ul').each(function () {
                            var letter = $(this).attr('data-brand-letter');
                            var offsetTop = $(this).prev('span').offset().top - ($(this).prev('span').parent().offset().top + 60);

                            if (offsetTop > -15 && offsetTop < 15) {
                                $('.alphabet-list').find('li').removeClass('is-active');
                                $('.alphabet-list').find('li[rel="' + letter + '"]').addClass('is-active');
                                return false;
                            }
                        });
                    });
                });
            });
        }

    } else {
        // MOBILE

        // HyDrawer Lateral Sliding Panel
        if (!bodyClassList.contains("new-checkout")) { // Don't load HyDrawer in checkout
            if (typeof hyDrawer === "object" && hyDrawer.HyDrawer) {
                initHyDrawer();
            } else {
                const retries = setInterval(function () {
                    if (typeof hyDrawer === "object" && hyDrawer.HyDrawer) {
                        initHyDrawer();
                        clearInterval(retries);
                    }
                }, 400);
            }

            // Slinky MultiLevel Navigation Menu
            $('#panel-left-nav-mobile').ready(function () {
                const slinky = $('#panel-left-nav-mobile').slinky();
            });
        }

        const mobileNavHeader = document.getElementById("nav-container"); // Mobile Main Nav - TOP Bar
        if (mobileNavHeader) {
            const bottomFilters = document.getElementById("filters-bottom-bar");
            const listFilters = document.getElementById("list-filters--wrapper");
            const upDiffLimit = 30;
            const downDiffLimit = 60;
            const downTopLimit = 40;

            handleMobileHeaderOnScroll(
                { bottomFilters, listFilters, upDiffLimit, downDiffLimit, downTopLimit }
            );

            // Mobile Brands menu
            if ($('#js-open-brands-menu').length) {
                var brandsLoaded = false;
                const toggleBrandList = () => {
                    $('.brand-title').on('touchstart', function (e) {
                        const letter = e.target.innerText;
                        let letterSpan = e.target;

                        document.querySelector('#js-brands-search-input').blur();

                        //Add transition to ul
                        $('ul.brands-list[data-brand-letter=' + letter + ']').fadeToggle();
                        $('ul.brands-list[data-brand-letter!=' + letter + ']').fadeOut();
                        //Add class visible to ul
                        $('ul.brands-list[data-brand-letter=' + letter + ']').toggleClass('visible');
                        $('ul.brands-list[data-brand-letter!=' + letter + ']').removeClass('visible');
                        //Add class active to span
                        $(letterSpan).toggleClass('active');
                        $('.brand-title[data-letter!=' + letter + ']').removeClass('active');
                    });
                }
                const resetBrandList = () => {
                    $('.brands-list.visible').hide();
                    $('.brands-list.visible').removeClass('visible');
                    $('.brand-title.active').removeClass('active');
                }

                $('#js-open-brands-menu').on('touchstart', function () {
                    if (!brandsLoaded) {
                        // Load brands asynchronously at Brands menu
                        $('#js-load-brands-menu').load('/modules/cache/topMenuBrands', function () {
                            toggleBrandList();
                            brandsLoaded = true;
                        });
                    } else {
                        resetBrandList();
                    }
                    document.querySelector('#js-brands-search-input').focus();
                });
            }
        }

        //Ripple effect --> function at bottom of the file.
        //$(document).on('click', '[href="#"]', function(e) { e.preventDefault(); })
        window.rippler = $.ripple('.main-items, button, a, .button-light, .custom-ripple, .tab-item', {
            debug: false,    // Turn Ripple.js logging on/off
            on: 'mousedown', // The event to trigger a ripple effect
            opacity: .3,     // The opacity of the ripple
            color: "auto",   // Set the background color. If set to "auto", it will use the text color
            multi: false,     // Allow multiple ripples per element
            duration: 0.3,   // The duration of the ripple

            // Filter function for modifying the speed of the ripple
            rate: function (pxPerSecond) {
                return pxPerSecond;
            },
            easing: 'ease-out' // The CSS3 easing function of the ripple);
        });
        /* $.ripple('.prod__box--action', {
            color: '#dd4b3b',
        }); */
    }



    /* DataLayer Impression */
    initDataLayer();

    /* DataLayer Click */
    initDataLayerClickEvents();

    if (getCookie('has_cart')) {
        ShopCart.refreshCartHeader();
    }

    /* our shops landings */
    if (typeof IS_OUR_SHOPS != 'undefined' && IS_OUR_SHOPS) {
        setActiveRegionShopUrl();
    }

    /* MIS-3243: New EU cookie consent with cookiebot */
    if (GRUPO_MERCADO == 'ROW' && getCookie('cookieSaved') != 'shown') {
        $('#cookieBar').show();
        $('#cookieBar').click(function (e) {
            if (e.target.tagName != 'A')
                $('#cookieBar').hide();
        });
        setCookie('cookieSaved', 'shown', 365);
    }

    /* Auto initialize expandable box */
    $("[data-toggle=expandable-box]").expandableBox();

    /* Auto initialize tab panels */
    new TabPanel();


    /* MIS-887 -- Add REORDER (recompra, rebuy) Slide @ Home Banner -- Prepend reorder slide when user has URL REORDER (logged & ) */
    var urlReorder = $('#reorderURL').attr('href'); /* get URL from reorder button href */
    if (urlReorder && !IS_MONTHLY_CAMP_ACTIVE && IS_HOME) {
        var bannerLang = ['es', 'en', 'de', 'fr', 'it', 'pt'];
        (bannerLang.indexOf(CODE_LANG) > -1) ? bannerLang = CODE_LANG : bannerLang = 'en'; //if eval of bannerLang.indexOf() is higher than -1 (0, 1, 2...)  ==>  true = CODE_LANG is in array!

        if (MOBILE) {
            var divMobile = $('#reorder-banner-mobile');
            if (divMobile.length > 0)
                divMobile.html('<a href="' + urlReorder + '" dl-banner="reorder" dl-category="Home reorder" dl-label="reorder home mobile" dl-value="reorder"> <img class="w100 mt15" src="' + STATIC_URL + 'media/' + SHOP_ID + '/banners/reorder_' + bannerLang + '_mobile.jpg"> </a>');
        } else {
            var homeSwiper = $('#mainBanner').data('_swiperobj_');
            if (homeSwiper) { // Missing banner for Petness
                homeSwiper.prependSlide('<a class="swiper-slide" href="' + urlReorder + '" dl-banner="reorder" dl-category="Home Large" dl-label="reorder home slide" dl-value="reorder"> <img src="' + STATIC_URL + 'media/' + SHOP_ID + '/banners/reorder_' + bannerLang + '.jpg"> </a>');
                homeSwiper.update();
                homeSwiper.updateSlides();
                homeSwiper.slideTo(0, 0, false);
            }
        }
    }
    /* END MIS-887 */

    // addMiscotaBanner();

    /*Auto initialize Vertical Sticky*/
    $(".vertical-sticky").each(function () {
        new VerticalSticky(this);
    });

    $('.tooltip-toggle').click(function (event) {
        event.stopPropagation();
    });

    initSmoothScrollEvents();

    //Initialize remove buttons
    $(".remove-trigger").on("click", function () {
        //Delete the closest .removable
        $(this).closest(".removable").remove();
    });

    //Hide HappyPopup with cookie
    $(".happy-popup .expandable-box--trigger").on("click", function () {
        setCookie("hh_popup", "shown", $(this).closest(".happy-popup").hasClass('is-open'));
    });

    if (typeof user_has_autoship == 'undefined' || user_has_autoship == false) {
        $(".add-to-autoship").remove();
        $(".autoship-list--wrapper").remove();
    }

    initNumberSelectors();

    // MIS-3934 - Check geo ip para redireccionar desde .com a pais correcto
    // Arrancamos sin activar GeoIP
    /*
    if (SHOP_ID == 1 && IS_HOME && COUNTRY == 223) {
        geoIpCheck();
    }
    */

    if (!MOBILE) {
        $('#js-dropdown__input').keyup(function () {
            lookupCountries(this);
        });
        $('.filter-option a').click(function (e) {
            $(this).parent('li').toggleClass('checked');
        });
    }
});

/**
 * Show or hide the mobile sticky header based on scroll direction
 * @param bottomFilters
 * @param listFilters
 * @param upDiffLimit
 * @param downDiffLimit
 * @param downTopLimit
 */
function handleMobileHeaderOnScroll({ bottomFilters, listFilters, upDiffLimit, downDiffLimit, downTopLimit }) {
    let newScrollPosition;
    let lastScrollPosition = window.scrollY;
    let scrollDiff = 0;
    let topBarVisible = true;
    let listFilterButtonsInViewport = true;

    window.addEventListener('scroll', function () {
        if (bottomFilters && listFilters) {
            listFilterButtonsInViewport = isInViewport(listFilters, {
                offsetTop: -10, offsetBottom: 0, onlyFullyVisible: false, belowViewportAsVisible: true
            });
            if (!listFilterButtonsInViewport) {
                bottomFilters.classList.add('show-bar');
                bottomFilters.classList.remove('hide-bar');
            } else {
                bottomFilters.classList.remove('show-bar');
                bottomFilters.classList.add('hide-bar');
            }
        }

        let diff;
        newScrollPosition = window.scrollY;
        // Scrolling down
        if (newScrollPosition > lastScrollPosition) {
            if (scrollDiff > 0) {
                scrollDiff = 0;
            }
            if (Math.abs(scrollDiff) <= downDiffLimit) {
                diff = lastScrollPosition - newScrollPosition;
                scrollDiff += diff;
                if (topBarVisible && newScrollPosition > downTopLimit && Math.abs(scrollDiff) > downDiffLimit) {
                    bodyClassList.remove("nav-slideDown");
                    bodyClassList.add("nav-slideUp");
                    topBarVisible = false;
                }
            }
        // Scrolling up
        } else if (newScrollPosition < lastScrollPosition) {
            if (scrollDiff < 0) {
                scrollDiff = 0;
            }
            if (scrollDiff <= upDiffLimit) {
                diff = lastScrollPosition - newScrollPosition;
                scrollDiff += diff;
                if (!topBarVisible && scrollDiff > upDiffLimit) {
                    bodyClassList.remove("nav-slideUp");
                    bodyClassList.add("nav-slideDown");
                    topBarVisible = true;
                }
            }
        }
        lastScrollPosition = newScrollPosition;
    }, { passive: true });
}


function handleScrollDesktop(
    { positionToShowHeaderFloat, headerFloatOffset = 400 },
    { sortAndViewElement, sortAndViewOffset = 20 }
) {
    const currentScrollY = window.scrollY;
    if (currentScrollY > positionToShowHeaderFloat) {
        document.body.classList.add('header-float');
    } else if (currentScrollY + headerFloatOffset < positionToShowHeaderFloat) {
        document.body.classList.remove('header-float');
    }

    if (sortAndViewElement) {
        const sortAndViewPosition = sortAndViewElement.parentElement.getBoundingClientRect().top + window.scrollY;
        if (currentScrollY > sortAndViewPosition - sortAndViewOffset) {
            sortAndViewElement.classList.add('fixed');
        } else {
            sortAndViewElement.classList.remove('fixed');
        }
    }
}


function setPreferedLang(el) {
    const preferedLang = $(el).attr('dl-code-lang');
    const idCountry = $(el).attr('dl-id-country');
    if (preferedLang && idCountry == 204) {
        setCookie('setPreferedLang', preferedLang, 365);
    }
}


//MIS-3934 - Arrancamos sin activar GeoIP
/*
function geoIpCheck(){
    const MAIN_COUNTRIES_LANG = ['es', 'fr', 'it', 'pt', 'de'];  // cualquier otro idioma irá a 'en' por defecto

    const interval = setInterval(function (){
        if (geoip2) {
            clearInterval(interval);

            geoip2.country(function (v) {
                const isoCode = v.country.iso_code;
                const lang = MAIN_COUNTRIES_LANG.find(l => l == isoCode.toLowerCase()) || 'en';
                const countryName = v.country.names[lang] ? v.country.names[lang] : v.country.names['en'];

                if (CODE_COUNTRY != isoCode) {
                    // Set por defecto vacio, si no se encuentra ninguna url, mejor no enseñar el popup
                    var newUrl = false;

                    $('head link').each(function() {
                        const rel  =  $(this).attr('rel');
                        if (rel == "alternate") {
                            const hreflang =  $(this).attr('hreflang');
                            if (hreflang.includes("-" + isoCode)) {
                                newUrl = $(this).attr('href');
                            }
                        }
                    });

                    if (newUrl) {
                        const question = __("select_country_title_" + lang);
                        const small_text = __("select_country_text1_" + lang + " %s", countryName);
                        const ext_content = __("select_country_text2_" + lang + " %s", countryName);
                        const ext_content2 = __("select_country_thanks_" + lang);
                        const confirm_tag = __("select_country_button_" + lang + " %s", countryName);

                        $.post('/modules/user/loadContentModal', {
                            template: 'geo-ip-location-modal',
                            question: question,
                            small_text : small_text,
                            ext_content: ext_content,
                            ext_content2: ext_content2,
                            confirm_tag: confirm_tag
                        }, function (result) {
                            contentModal(result);
                            $('.data-wrapper').parent().children().addClass('geo-location');
                            $('#confirm-action').click(function() {
                                document.location.href = newUrl;
                            });
                        });
                    }
                }
            }, function (e) {
              //  console.error("geoip2 Error", e);
            })
        }
    }, 250);
}
*/

function initNumberSelectors() {
    var click_func = function (ev) {
        var $this = $(this);
        var step = $this.is(".decrement-button") ? -1 : 1;
        var $input = $this.siblings("input");

        var min = $input.attr("min");
        var max = $input.attr("max");

        var new_value = Number($input.val()) + step;
        if (min && new_value < min) new_value = min;
        if (max && new_value > max) new_value = max;

        $input.val(new_value > 0 ? new_value : 1);
        $input.trigger("change");
    };
    //Input number increment and decrement buttons.
    $(".number-selector:not(.initialized)").off("click", ".decrement-button, .increment-button", click_func).on("click", ".decrement-button, .increment-button", click_func).addClass("initialized");
}

function showModalLogin(next = null) {
    PopUpLoginReg.getInstance().show(undefined, undefined, undefined, next);
}

function GoogleLogin() {
}

GoogleLogin.init = function () {
    var $glogin = $('[rel="g-login"]');
    if ($glogin.length == 0) return false;

    if (typeof GG_CID == 'undefined') return false;
    if (typeof gapi == 'undefined') {
        setTimeout(GoogleLogin.init, 500);
        return false;
    } // Try again
    gapi.load('auth2', function () {
        // Retrieve the singleton for the GoogleAuth library and set up the client.
        auth2 = gapi.auth2.init({
            client_id: GG_CID,
        });

        $glogin.each(function () {
            auth2.attachClickHandler(this, {}, GoogleLogin.login);
            addEvent(this, 'click', function () {
                pushDatalayer('eventGA', 'Login', 'Click', 'Google', 1, 1);
                UserInfo.clear();
            });
        });
    });
    GoogleLogin.init = function () {
    };
};

GoogleLogin.login = function (googleUser) {
    var token = googleUser.getAuthResponse().id_token;

    $('[rel="g-login"]').html(getLoadingImg('30'));
    $.post('/scripts/google-callback.php', {
        token: token
    }, function (data) {
        if (data.code == 300) {
            popUpSocialConditions(data.email, data.first_name, data.social);
            $('#login-form input[name="next"]').val('/user/?tab=interests');
        } else if (data.code == 200) {
            pushDatalayer('eventGA', 'Login', 'Success', 'Google', 1, 1);
            UserInfo.clear();
            location.reload();
        } else {
            pushDatalayer('eventGA', 'Login', 'Error', data.response, 1, 1);
        }
    }, 'json');
};

function FacebookLogin() {
}

FacebookLogin.init = function (fn) {
    var $fblogin = $('[rel="fb-login"]');
    if ($fblogin.length == 0) return false;
    $fblogin.click(function () {
        FB.login(function (response) {
            FB.getLoginStatus(function (response) { // Check again, on windows close response says is connected
                if (response.status === 'connected') {
                    $('[rel="fb-login"]').html(getLoadingImg('30'));
                    $.post('/scripts/fb-callback.php', {
                        token: response.authResponse.accessToken
                    }, function (data) {
                        if (data.code == 300) {
                            popUpSocialConditions(data.email, data.first_name, data.social);
                            $('#login-form input[name="next"]').val('/user/?tab=interests');
                        } else if (data.code == 200) {
                            pushDatalayer('eventGA', 'Login', 'Success', 'Google', 1, 1);
                            UserInfo.clear();
                            location.reload();
                        } else {
                            pushDatalayer('eventGA', 'Login', 'Error', data.response, 1, 1);
                        }
                    }, 'json');
                } else {
                    pushDatalayer('eventGA', 'Login', 'Error', 'Facebook not connected', 1, 1);
                }
            });
        }, {scope: 'public_profile,email'});
    });
    FacebookLogin.init = function () {
    };
};

function loadHoverCategories(catInfo, idCat) {
    if (catInfo.data('loading')) return false;
    catInfo.data('loading', true);
    catInfo.load('/modules/shop/printCategoryInfo/' + idCat, function () {
        if (SHOP_ID == 9) { //Exclude VTY & New MIS now
            catInfo.find('.category.hover, .category > .sub-categories > a.hover').removeClass('hover');
            catInfo.find('.category:first').addClass('hover');
            catInfo.find('.category, .category > .sub-categories > a, .new-main-nav-hover--categories > li').hover(function (e) {
                $(this).addClass('hover');
            }, function (e) {
                $(this).removeClass('hover');
            });
        }

        catInfo.find('[datalayer="datalayer"]').click(function (e) {
            e.preventDefault();
            var category = $(this).attr('dl-category');
            var action = $(this).attr('dl-action');
            var label = $(this).attr('dl-label');
            var event = $(this).attr('dl-event');
            var interaction = $(this).attr('dl-interaction');
            var value = $(this).attr('dl-value');
            if (!event) event = 'eventGA';
            if (!interaction) interaction = 1;
            if (!value) value = 1;

            var url = false;
            if ($(this).attr('href')) url = $(this).attr('href');
            else if ($(this).attr('data-url')) url = $(this).attr('data-url');

            pushDatalayer(event, category, action, label, value, interaction, url);
        });
        window.lazyLoadInstance.update();
        catInfo.closest('.nav-item').addClass('processed');
    });
}

function lookupCountries(input) {
    var text = input.value.trim();
    $('#list-countries li').show();
    if (text) {
        $('#list-countries li').filter(function () {
            var regexp = RegExp(text, 'i');
            return !regexp.test($(this).text());
        }).hide();
    }
}

function toogleClasses(elem, activeClass, inactiveClass) {
    if ($(elem).hasClass(activeClass)) {
        $(elem).removeClass(activeClass);
        $(elem).addClass(inactiveClass);
    } else {
        $(elem).addClass(activeClass);
        $(elem).removeClass(inactiveClass);
    }
}


function pushDatalayer(eventGA, category, action, label, value, interaction, url) {
    var e = window.event;
    if (window['google_tag_manager']) {
        var fn = null;
        if (url) {
            if (checkMetaKey(e)) // We can open the new tab before GTM
                openurl(url, e);
            else
                fn = function () {
                    openurl(url, e);
                };
        }
        window.dataLayer.push({
            'event': eventGA,
            'eventCategory': category,
            'eventAction': action,
            'eventLabel': label,
            'eventValue': value,
            'eventInteraction': interaction,
            'eventCallback': function (containerId) {
                containerId == GTM_ID && fn && fn();
            },
            'eventTimeout': 1000
        });
    } else {
        if (url) openurl(url, e);
    }
}


function openurl(url, event) {
    if (!url) {
        return;
    }
    const openInNewTab = event && (event.metaKey || event.ctrlKey);
    if (openInNewTab) {
        window.open(url, '_blank');
    } else {
        window.location.assign(url);
    }
}

function checkMetaKey(e) {
    return e && (/^mac/i.test(navigator.platform) ? e.metaKey : e.ctrlKey);
}

function doSearch(form) {
    form.q.value = trim(form.q.value);
    if (form.q.value.length > 0) {
        var query = form.q.value;
        $(form).find("input[type=submit]").attr('disabled', 'disabled');
        pushDatalayer('eventGA', 'Nav', 'Search', query, 1, 1);
        return true;
    } else return false;
}

function getAddItemTrigger(position, element) {
    return position === 'new-list-crossSelling' || position === false
        ? getTriggerName(element)
        : position;

    function getTriggerName(element) {
        return element
            ? element.closest('.add-item-trigger--wrapper').dataset.triggerWrapper
            : 'indefinido';
    }
}

function addItemPopupFicha(elem, ref) {
    var parentDiv = $(elem).parent();
    parentDiv.find('.added_product_button').css('display', 'block');
    parentDiv.find('.add_product_button').css('display', 'none');
    parentDiv.addClass('added_product');

    ShopCart.setShowCart(true);
    ShopCart.addItem(ref, 1, ShopCart.refreshCartHeader, getAddItemTrigger('popup-ficha'));
}

function delItemPopupFicha(elem, ref) {
    var parentDiv = $(elem).parent();
    parentDiv.find('.added_product_button').css('display', 'none');
    parentDiv.find('.add_product_button').css('display', 'block');
    parentDiv.removeClass('added_product');

    ShopCart.setShowCart(true);
    ShopCart.delItem(ref, 1, ShopCart.refreshCartHeader, getAddItemTrigger('popup-ficha'));
}

function initLazyLoad() {
    window.lazyLoadInstance = new LazyLoad({
        data_src: 'original', threshold: 460, appear: function () {
            $(this).trigger('appear');
        }
    });
}

function initSwiper(context) {
    if (typeof context == 'undefined' || !context) context = document;
    /* Swiper slider data mapper - To set slider options directly in html with data- tags */
    // Documentación original --> http://swiperjs.com
    var data_mapper = {
        slidesPerView: "slides_per_view",              // Número de slides (columnas) vistos a la vez dentro de un wrapper.
        slidesPerColumn: "slides_per_column",          // Número de filas de slides.
        slidesPerGroup: "slides_per_group",            // Número de slides que se desplazan a la vez.
        spaceBetween: "space_between",                 // Distancia en px entre slides.
        autoHeight: "auto_height",                     // Height Auto for swiper-wrapper.
        direction: "direction",                        // Option: vertical -- Default: horizontal.
        freeMode: "free_mode",                         // Boolean: Slide libre sin snap.
        grabCursor: "grab_cursor",                     // Boolean: Mostrar Icono Mano en cursor.
        mousewheel: "mousewheel",                      // Boolean: Activa la rueda del mouse.
        loop: "loop",                                  // Boolean: Loop infinito.
        speed: "speed",                                // Velocidad de la transicion en ms.
        effect: "effect",                              // Efecto transicion. Opciones: fade, cube, flip, coverflow -- Default: slide.
        slidesOffsetBefore: "slides_offset_before",    // Espacio en px antes primer slide.
        slidesOffsetAfter: "slides_offset_after",      // Espacio en px después último slide.
        lazy: "lazy",                                  // Carga diferida. Consultar documentacion.
        loadOnTransitionStart: "load_on_transition_start", // Empieza la carga diferida de la siguiente imagen al empezar la transición de la actual, en lugar de al finalizarla. Boolean. Default is false.
        loadPrevNextAmount: "load_prev_next_amount",   // Precarga una determinada cantidad de prev/next imagenes
        autoplay: "autoplay",                          // Boolean: Deafult is false. Autoplay. Options: autoplay_delay: time in ms
        freeModeSticky: "free_mode_sticky",            // Boolean. Default is false. Enable Free Mode (without snap)
        freeModeMomentum: "free_mode_momentum",        // Boolean. Default is true. Slide keep moving after release.
        observer: "observer",                          // Boolean. Default is false. Set to true to enable Mutation Observer on Swiper and its elements. In this case Swiper will be updated (reinitialized) each time if you change its style (like hide/show) or modify its child elements (like adding/removing slides)
        observeParents: "observe_parents",             // Boolean. Default is false. Set to true if you also need to watch Mutations for Swiper parent elements
        slidesPerColumnFill: "slides_per_column_fill", // String. Default is 'column'. Options: 'column' / 'row'. Defines how slides should fill rows, by column or by row
        dynamicBullets: "dynamic_bullets",             // Boolean. Default is false
        dynamicMainBullets: "dynamic_main_bullets",    // Number. Define the initial number of visible bullets for DynamicBullets type
    };

    function tryContextSelector(selector) {
        var elements;
        //Test for childrens
        if ((elements = $(selector, this)).length > 0)
            return elements;

        //Test for siblings
        if ((elements = $(this).siblings(selector)).length > 0)
            return elements;

        //Test for parents
        if ((elements = $(this).closest(selector)).length > 0)
            return elements;

        //If not found, return general selector
        return $(selector);
    }

    $(".swiper-container:not(.custom-swiper)", context).each(function () {
        var data_props = $(this).data();

        var params = {
            scrollbar: {
                el: data_props.scrollbar_selector || tryContextSelector.call(this, ".swiper-scrollbar")
            },
            pagination: {
                el: tryContextSelector.call(this, '.swiper-pagination'),
                clickable: true,
                dynamicBullets: data_props.dynamic_bullets || false,
                dynamicMainBullets: data_props.dynamic_main_bullets || 1,
            },
            navigation: {
                nextEl: data_props.button_next || tryContextSelector.call(this, '.swiper-button-next'),
                prevEl: data_props.button_prev || tryContextSelector.call(this, '.swiper-button-prev'),
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
        };

        // Extract params
        for (let prop in data_mapper) {
            let data_name = data_mapper[prop];
            if (data_props.hasOwnProperty(data_name))
                params[prop] = data_props[data_name];
        }

        //Special params
        if (!data_props.hasOwnProperty("scrollbar") || data_props.scrollbar == false) delete params.scrollbar;
        if (data_props.hasOwnProperty("pagination") && data_props.pagination == false) delete params.pagination;
        if (data_props.hasOwnProperty("navigation") && data_props.navigation == false) delete params.navigation;
        if (data_props.hasOwnProperty("keyboard") && data_props.navigation == false) delete params.keyboard;
        if (data_props.hasOwnProperty("autoplay_delay") && data_props.autoplay_delay) params['autoplay'] = {'delay': data_props.autoplay_delay};

        var swiper = new Swiper(this, params);
        if (data_props.hasOwnProperty('save') && data_props['save'])
            $(this).data('_swiperobj_', swiper);
    });
}

function ShopCart(dom) {
    this.dom = $(dom);
    this.showCart = false;
}

ShopCart.getShowCart = function () {
    return this.showCart;
}

ShopCart.setShowCart = function (bool = true) {
    this.showCart = bool;
}

ShopCart.addItems = function (form) {
    // TODO: Quitar el if y su modal cuando pase coronavirus
    if ([7, 16, 19, 22, 24, 32, 40, 59, 93, 116, 142, 143, 165, 178, 179, 205, 207, 216, 231, 235, 176].includes(parseInt(COUNTRY, 10))) {
        if (contentModalActive != "COVID-19") contentModal(__('denied_buy'), "COVID-19");
        return false;
    }
    for (var idx = 0; idx < form.elements.length; ++idx) {
        var elem = form.elements[idx];
        if (elem.name && elem.value > 0) {
            if (/^nostock_([^\]]+)$/.test(elem.name)) {
                noStockPopUp(/^nostock_([^\]]+)$/.exec(elem.name)[1]);
                return false;
            }
            var results = /^quan\[([^\]]+)\]$/.exec(elem.name);
            if (results) {
                var ref = results[1];
                var quantity = elem.value;
                ShopCart.addItem(ref, quantity);
            }
        }
    }
    ShopCart.refreshCartHeader();
    return false;
}


var addingItem = false;
ShopCart.addItem = function (ref, quantity = 1, fn, addItemTrigger) {
    // TODO: Quitar el if y su modal cuando pase coronavirus
    if ([7, 16, 19, 22, 24, 32, 40, 59, 93, 116, 142, 143, 165, 178, 179, 205, 207, 216, 231, 235, 176].includes(parseInt(COUNTRY, 10))) {
        if (contentModalActive != "COVID-19") {
            contentModal(__('denied_buy'), "COVID-19");
        }
        return false;
    }

    if (addingItem) {
        return;
    }
    addingItem = true;

    if (fn === undefined) {
        fn = () => document.location.href = '/checkout';
    } else if (fn == false) {
        fn = () => document.location.reload();
    }

    var matches = /^2x(.+)$/.exec(ref);
    var matchesPromo = /^promo-([0-9]+)-(.+)$/.exec(ref);

    if (matches) {
        ref = matches[1];
        Promo.addDoblePack(ref, quantity, fn);
    } else if (matchesPromo) {
        var id_promo = matchesPromo[1];
        Promo.addPromoPack(id_promo, quantity, fn);
    } else {
        if (quantity > 0) {
            pushAddToCartEventToDataLayer(ref, 'add', quantity, addItemTrigger); //Google Analytic Ecommerce Enhanced: Add product to cart.
        } else {
            pushAddToCartEventToDataLayer(ref, 'remove', quantity, addItemTrigger); //Google Analytic Ecommerce Enhanced: Remove product from cart.
        }

        $.post('/cart/addItemCart',
            {ref: ref, quantity: quantity},
            fn, 'json');
    }
    addingItem = false;
}

ShopCart.setItem = function (ref, quantity, fn) {
    fn = function () {
        document.location.reload();
    };
    $.post('/cart/setQuantityCart',
        {ref: ref, quantity: quantity},
        fn, 'json');
}

let delItemProcess = false;

ShopCart.delItem = function (ref, quantity, reload = false, addItemTrigger = null, element = null) {
    if (delItemProcess) {
        return;
    }
    delItemProcess = true;
    if (element) {
        const cartItem = element.closest('.js-cart-product');
        if (cartItem) {
            cartItem.remove();
        }
    }
    pushAddToCartEventToDataLayer(ref, 'remove', quantity, addItemTrigger); //Google Analytic Ecommerce Enhanced: Remove product from cart.

    $.post('/cart/delItemCart',
        {ref: ref},
        function () {
            $('#item-' + ref).fadeOut(function () {
                $(this).remove()
            });
            if (reload) {
                document.location.reload();
            } else {
                ShopCart.updateCart(true);
            }
            delItemProcess = false;
        },
        'json'
    );
}

ShopCart.addPack = function (idPack, quantity, fn) {
    if (quantity === undefined)
        quantity = 1;
    if (fn === undefined) {
        fn = function () {
            document.location.href = '/checkout';
        };
    }
    $.post('/cart/addPackCart',
        {idOffer: idPack, quantity: quantity},
        fn, 'json');
}

ShopCart.delPack = function (idPack) {
    $.post('/cart/delPackCart', {idOffer: idPack});
}

async function getRegionText(form) {
    if (form.region) {
        return form.region.value;
    } else {
        return form.querySelector('.ship-region li.is-selected').dataset.value;
    }
}

ShopCart.updateCart = function (info, basicInfo, reload = true, loadPage, resolve = undefined) {
    var payMethod = $('input[name="payment-method"]:checked').val();
    var customAddressSelected = document.querySelector('input[name="show_saved_address"]')?.value === '0';
    var region = null;
    var postalCode = null;

    if (customAddressSelected) {
        region = $("#process-purchase [name='region']").val().toLowerCase();
        postalCode = $("#process-purchase [name='postcode']").val();
    } else {
        let savedAddress = getDataFromSelectedSavedAddress();
        region = savedAddress ? savedAddress.region.toLowerCase() : null;
        postalCode = savedAddress ? savedAddress.postalcode : null;
    }

    var delayProducts = [];
    var subtotal = 0;
    var carrier_selected = $('input[name="carrier_selected"]').val();
    var carrierPriceSelected = $('dd.ship-method.selectedShipping .shippingMethodPrice').text();
    var carrierTextSelected = $('dd.ship-method.selectedShipping .shippingMethodSchedule .extra-text').text();
    const referer = IS_CHECKOUT_AUTH || IS_THANKYOU ? 'auth' : false;

    if (info == true) {
        if ($('.checkout--resume, .checkout-resume--content').length) {
            var loading = resumeLoadingCheckout();
        }

        $.post('/cart/getInfoCart',
            {checkRegion: 1, region, postalCode, payMethod, loadPage, referer},
            function (result) {
                info = result;

                // MIS-2435: COVID. Spring & springplus ship limitations.
                if (info.limited_carrier == true) {
                    $('.checkout-special-msg').css("display", "flex");
                } else {
                    $('.checkout-special-msg').css("display", "none");
                }
                $('#finantial-price').html(info.finantial_price_text);

                info.free
                    ? $('#finantial-price').addClass('free')
                    : $('#finantial-price').removeClass('free');

                if (typeof info.financial_discount !== 'undefined' && info.financial_discount !== null) {
                    $('#financial-discount-row').show();
                    $('#financial-cost-text').html(info.financial_cost_text);
                    $('#finantial-disc-text').html(info.financial_discount_text);
                    $('#finantial-disc-subtitle').html(info.finantial_discount_subtitle);
                } else {
                    $('#financial-discount-row').hide();
                }
                $('#finantial_final_cost').html(info.finantial_price_text);

                if (typeof info.yoga_warranty_price !== 'undefined' && info.yoga_warranty_price !== null) {
                    $('#yoga-price').html(info.yoga_warranty_price);
                }

                if (typeof info.list_carriers !== 'undefined' && info.list_carriers !== null) {
                    for (var key = 0; key < info.list_carriers.length; ++key) {
                        var carrier = info.list_carriers[key];
                        $('.newCarrierLogo.' + carrier.carrier_logo).parent("label").children(".shippingMethodPrice").val(carrier.shipping_price_text);
                        $('.newCarrierLogo.' + carrier.carrier_logo).parent("label").children(".shippingMethodPrice").html(carrier.shipping_price_text);
                    }
                }

                if (info.donation >= 0) {
                    $('#donationSelect').val(info.donation);
                    $('#donationValue').val(info.donation);
                }

                if (info.items.length == 0 && document.location.href.indexOf('checkout') != -1)
                    document.location.href = '/';

                for (var key in info) {
                    $('#' + key).val(info[key]);
                    $('#' + key).html(info[key]);
                    $('[rel="' + key + '"]').val(info[key]);
                    $('[rel="' + key + '"]').html(info[key]);
                }
                let expressShow = false;
                let standardShow = false;
                let expressCarrier = {};
                let standardCarrier = {};
                $.each(info.list_carriers, function (i, val) {
                    if (info.list_carriers[i].type && info.list_carriers[i].type.match(/-express/g)) {
                        expressShow = true;
                        expressCarrier = info.list_carriers[i];
                        $('#shipping_price_express_text').html(info.list_carriers[i].shipping_price_text);
                        $('#ship-method-express').attr('price', info.list_carriers[i].shipping_price);
                        $('.express-shipping').find("input:radio[name=carrier]").attr("price", info.list_carriers[i].shipping_price);
                        $('.express-shipping').find("input:radio[name=carrier]").val(info.list_carriers[i].type);
                    }

                    if (info.list_carriers[i].type && info.list_carriers[i].type.match(/-standard/g)) {
                        standardShow = true;
                        standardCarrier = info.list_carriers[i];
                        $('#shipping_price_standard_text').html(info.list_carriers[i].shipping_price_text);
                        $('#ship-method-standard').attr('price', info.list_carriers[i].shipping_price);
                        $('.standard-shipping').find("input:radio[name=carrier]").attr("price", info.list_carriers[i].shipping_price);
                        $('.standard-shipping').find("input:radio[name=carrier]").val(info.list_carriers[i].type);
                    }
                });

                if (IS_CHECKOUT_AUTH && (SHOP_ID == 1 && COUNTRY == 195 || SHOP_ID == 10 && COUNTRY == 171)) {
                    if (expressShow) {
                        addExpressCarrier(expressCarrier);
                        $('.express-shipping').show();
                    } else {
                        $('.express-shipping').hide();
                        if ($('.express-shipping').hasClass('selectedShipping')) {
                            $('.express-shipping').removeClass('selectedShipping');
                            $('.standard-shipping').addClass('selectedShipping');
                            $('input[name="carrier_selected"]').val(standardCarrier.type);
                        }
                        if (!$('#date-express').hasClass('disabled')) {
                            $('#date-express').addClass('disabled');
                        }
                    }

                    if (standardShow) {
                        $('.standard-shipping').show();
                        if ($('.standard-shipping').hasClass('selectedShipping')) {
                            $('input[name="carrier_selected"]').val(standardCarrier.type);
                        }
                    } else {
                        $('.standard-shipping').hide();
                    }

                    if (expressCarrier) {
                        if (document.getElementById('date-express0')) {
                            document.getElementById('date-express0').value = expressCarrier.express_date;
                            document.getElementById('date-express0').innerText = expressCarrier.extra_text;
                        }
                        if (document.getElementById('date-express1')) {
                            document.getElementById('date-express1').value = expressCarrier.express_date1;
                            document.getElementById('date-express1').innerText = expressCarrier.extra_text1;
                        }
                        if (document.getElementById('date-express2')) {
                            document.getElementById('date-express2').value = expressCarrier.express_date2;
                            document.getElementById('date-express2').innerText = expressCarrier.extra_text2;
                        }
                    }

                    if (info.hasGreenShipping && info.carrier && info.carrier.match(/paackrange/g)) {
                        if (document.getElementById('green-shipping')) {
                            document.getElementById('green-shipping').addClassName('is-visible');
                        }
                    } else {
                        if (document.getElementById('green-shipping')) {
                            document.getElementById('green-shipping').removeClassName('is-visible');
                        }
                    }

                    if (info.list_carriers_delivery_personalizado && info.list_carriers_delivery_personalizado.length > 0) {
                        addCustomShip(info);
                        $('#custom-ship').show();
                    } else {
                        $('#custom-ship').hide();
                        if ($('#custom-ship').hasClass('active')) {
                            $('#custom-ship').removeClass('active');
                            $('.standard-shipping').addClass('selectedShipping');
                            $('input[name="carrier_selected"]').val(standardCarrier.type);
                        }
                    }

                    if (SHOP_ID === '10' && COUNTRY === '171') {
                        const carriersPickWrapper = document.querySelector('#carriers-pick');
                        const allCarriersDelivery = document.querySelectorAll('#carriers-delivery .ship-method');
                        const VASPSAB_POSTAL_CODES = {
                            'codes': [2600, 2700, 2800, 4700],
                            'ranges': [
                                [1000, 1999],
                                [4000, 4400]
                            ]
                        };
                        let showVaspMar = postalCode
                            ? postalCode.startsWith('9')
                            : /açores|madeira/i.test(region);
                        let showVaspSab = postalCode
                            ? isInRangeOrValidCode(postalCode, VASPSAB_POSTAL_CODES)
                            : /porto|lisboa/i.test(region);
                        let $vaspMar = document.querySelector('#vaspmar');
                        let $vaspSab = document.querySelector('#vaspsab');

                        let updateSelected = false;
                        if (region || postalCode) {
                            if (exist($vaspMar)) {
                                if (showVaspMar) {
                                    hideAllCarriers();
                                    _show($vaspMar);
                                    updateSelected = true;
                                } else if (isVisible($vaspMar)) {
                                    showAllCarriers();
                                    _hide($vaspMar);
                                    updateSelected = true;
                                }
                            }
                            if (exist($vaspSab)) {
                                if (showVaspSab) {
                                    _show($vaspSab);
                                } else if (isVisible($vaspSab)) {
                                    _hide($vaspSab);
                                    updateSelected = true;
                                }
                            }
                        } else {
                            [$vaspMar, $vaspSab].forEach(carrier => {
                                if (exist(carrier) && isVisible(carrier)) {
                                    _hide(carrier);
                                    updateSelected = true;
                                }
                            });
                        }
                        if (updateSelected) {
                            selectFirstVisibleCarrier();
                        }


                        function hideAllCarriers() {
                            Array.from(allCarriersDelivery).forEach(carrier => {
                                _hide(carrier);
                            });
                            _hide(carriersPickWrapper);
                        }

                        function showAllCarriers() {
                            Array.from(allCarriersDelivery).forEach(carrier => {
                                _show(carrier);
                            });
                            _show(carriersPickWrapper);
                        }

                        function selectFirstVisibleCarrier() {
                            const $visibleCarriers = Array.from(document.querySelectorAll('#carriers-delivery .ship-method')).filter(carrier => isVisible(carrier));
                            if ($visibleCarriers.length) {
                                $visibleCarriers[0].querySelector('label').click();
                            }
                        }
                    }
                }


                if (IS_CHECKOUT_AUTH && (SHOP_ID == 1 && COUNTRY == 195 || SHOP_ID == 10 && COUNTRY == 171)
                    && (carrier_selected == 'puntopack' || carrier_selected == 'GLSRelais' || carrier_selected == 'retailMSK' || carrier_selected == 'DPDPickup'
                        || carrier_selected == 'ctt_pickup' || carrier_selected == 'chronopost_pickup')) {
                    let existsCarrier = false;
                    $.each(info.list_carriers, function (i, val) {
                        if (info.list_carriers[i].type && info.list_carriers[i].type == carrier_selected) {
                            existsCarrier = true;
                        }
                    });
                    if (existsCarrier) {
                        $('input[name="carrier_selected"]').val(carrier_selected);
                        $('[rel="shipping_price_text"]').html(carrierPriceSelected);
                        $('#carrier-text').text(carrierTextSelected);
                    } else {
                        $('input[name="carrier_selected"]').val(info.carrier);
                        $('[rel="shipping_price_text"]').html(info.carrier_price);
                        $('#carrier-text').text(info.carrier_text);
                    }
                } else {
                    $('#carrier-shipping-price').text(info.carrier_price);
                    $('#carrier-text').text(info.carrier_text);
                }
                /*if (checkoutWithCarriers && COUNTRY == 195 && $('dd.ship-method.selectedShipping input').val() && $('dd.ship-method.selectedShipping input').val().match(/-express/g)) {
                    $('#date-express').val($('#date-express').val());
                    $('#carrier-text').text($('#date-express option:selected').text());
                }*/


                if (basicInfo != true) {
                    var listItems = $.map($('[id^="item-"]'), function (val) {
                        return val.id;
                    });
                    for (var key = 0; key < info.items.length; ++key) {
                        var ref = info.items[key].sp_ref ? info.items[key].sp_ref : info.items[key].ref;
                        subtotal = info.subtotal;
                        if ($('#item-' + ref).length < 1 && reload) { // If new product in Cart
                            document.location.reload();
                            return;
                        }

                        for (var name in info.items[key]) {
                            $('#' + name + '\\[' + ref + '\\]').val(info.items[key][name]);
                            $('#' + name + '\\[' + ref + '\\]').html(info.items[key][name]);

                            if (MOBILE) {
                                if (info.items[key]['quantity'] == 1) {
                                    $('#arrowDown\\[' + ref + '\\]').hide();
                                    $('#delItem\\[' + ref + '\\]').css('display', 'flex');
                                } else {
                                    $('#arrowDown\\[' + ref + '\\]').css('display', 'flex');
                                    $('#delItem\\[' + ref + '\\]').hide();
                                }
                            }
                        }

                        $('#item-' + ref).find('.deliverProdCart').find('.value').html(info.items[key].shipping_date);

                        if (info.items[key].no_more_stock)
                            $('#no_more_stock_' + ref).show();
                        else
                            $('#no_more_stock_' + ref).hide();


                        // if (info.items[key].removable) {
                        //     $('#item-' + ref + ' [rel="deleteButton"]').removeClass('visually-hidden');
                        //     console.log('removable');
                        // }  else {
                        //     $('#item-' + ref + ' [rel="deleteButton"]').addClass('visually-hidden');
                        //     console.log('no removable');
                        // }

                        if ($('#max_units\\[' + ref + '\\]').length > 0) {
                            if ($('#max_units\\[' + ref + '\\]').val() <= info.items[key]['quantity']) {
                                if (!MOBILE)
                                    $('#arrowUp\\[' + ref + '\\]').hide();
                                else
                                    $('#arrowUp\\[' + ref + '\\] img').css({opacity: 0.1})
                            } else {
                                if (!MOBILE)
                                    $('#arrowUp\\[' + ref + '\\]').show();
                                else
                                    $('#arrowUp\\[' + ref + '\\] img').css({opacity: 1});
                            }
                        }

                        var idx = listItems.indexOf("item-" + ref);
                        if (idx > -1) listItems.splice(idx, 1);

                        if ($('body.chekout') && info.items[key]['is_delay_prod'] == true) {
                            delayProducts.push({"ref": ref, "price": info.items[key].price});
                        }
                    }

                    if (parseFloat(info.total_price_without_discounts) === parseFloat(info.total_price)) {
                        $('#total_price_text_without_discounts').empty();
                        $('#total_price_text_without_discounts').hide();
                    } else {
                        $('#total_price_text_without_discounts').text(info.total_price_text_without_discounts);
                        $('#total_price_text_without_discounts').show();
                    }

                    if (listItems.length > 0 && reload) { // If missing product in Cart
                        document.location.reload();
                        return;
                    }
                    for (var key in info.points) {
                        $('#' + key).val(info.points[key]);
                        $('#' + key).html(info.points[key]);
                    }
                    for (var key in info.coupon) {
                        $('#' + key).val(info.coupon[key]);
                        if (key == 'discountU' || key == 'discUText' || key == 'discountT' || key == 'discTText') {
                            $('#' + key).html('-' + info.coupon[key]);
                        } else {
                            $('#' + key).html(info.coupon[key]);
                        }
                    }

                    var promosDiv = $('#promoSnacksDiv');
                    if (promosDiv.length > 0) {
                        if (info.total_price >= 60)
                            promosDiv.removeClass('noActive');
                        else {
                            promosDiv.find('input:checkbox:checked').attr({checked: false}).change();
                            promosDiv.addClass('noActive');
                        }
                    }

                    var hasFreeShipping = false;
                    var carrierSelected = false;
                    for (var key in info.list_carriers) {
                        var carrier = info.list_carriers[key];
                        var show_carrier = carrier.show_carrier;
                        if (show_carrier) {
                            $('#ship-method-' + carrier.type).parents('.ship-method-item').show();
                        } else {
                            $('#ship-method-' + carrier.type).parents('.ship-method-item').hide();
                        }
                        $('#shipping_price_' + carrier.type + '_text').html(carrier.shipping_price_text);
                        $('input[value="' + carrier.type + '"]').attr('price', carrier.shipping_price);

                        if (carrier.shipping_price == 0) {
                            hasFreeShipping = true;
                        }

                        $('input[value="' + carrier.type + '"]').attr('resume_delivery', carrier.resume_text);

                        if (((COUNTRY == 73 && carrier.type == "puntopack") || (carrier.type != 'puntopack' && carrier.type != 'retailMSK' && carrier.type != 'DPDPickup' && carrier.type != 'GLSRelais') || (SHOP_ID == 12 && carrier.type != 'GLSRelais')) && !carrierSelected) { // new best shippment
                            carrierSelected = true;
                        }

                        // MIS-2051: Canviar el texto del courier cuando NO hay envío express. Done in MIS-1781.
                        if (SHOP_ID == 12 && (carrier.type == 'glsfr' || carrier.type == 'chronopostdomicilie')) {
                            $('#shipping_price_' + carrier.type + '_text').closest('.ship-method').find('.shippingMethodSchedule').html(__('checkout_envio_seur_express'));
                        }
                    }

                    var $freeClaim = $('.checkout-freeship-claim');
                    var $freeMsg = $('.fs-progress--message');
                    var $progBar = $('.fs-progress--bar-front');

                    $freeClaim.toggle(!hasFreeShipping);
                    $progBar.width(info.free_shipping_percentage + "%");

                    if (info.free_shipping_pending) {
                        $freeMsg.html(__('left_to_freeshipping', info.free_shipping_pending)).removeClass('free');
                    } else {
                        $freeMsg.html(__('free_shipping_reached')).addClass('free');
                    }

                    var coupon = info.coupon;
                    if (coupon) {
                        $('#coupon_discount_text').html('-' + coupon.discTText);
                    }
                }

                if ($('.checkout--resume').length > 0) {
                    $(loading).remove();
                }
                if (IS_CART && delayProducts.length > 0) {
                    ShopCart.setDelayProdsMsg(delayProducts, subtotal);
                }
                if (IS_CHECKOUT_AUTH && (SHOP_ID == 1 && COUNTRY == 195)) {
                    addExtraCostPaackToCarrier();
                }
                // console.log('3. ShopCart.updateCartInfo end @ ShopCart.updateCart');

                if (resolve !== undefined) {
                    resolve()
                } else if (reload) {
                    document.location.reload();
                }
            },
            'json'
        );
    }
};

ShopCart.updateAutoshipMessages = function (messages) {
    const $acceptMsg = document.getElementById('js-autoship-accept-msg');
    const $receiveMsg = document.getElementById('js-autoship-receive-msg');
    const $discountMsg = document.getElementById('js-autoship-discount-msg');
    if (typeof messages === 'object' && $acceptMsg) {
        $acceptMsg.innerHTML = messages.autoship_accept_msg;
        $receiveMsg.innerHTML = messages.autoship_receive_msg;
        $discountMsg.innerHTML = messages.autoship_discount_msg;
    }
}


/* Use to change the color of the progress bar according to the pending amount for "Free Shipping" */
ShopCart.setProgressBarColor = function (info) {
    var $bar = $('.fs-progress--bar-front');

    if (info.free_shipping_percentage <= 50) {
        $bar.removeClass('orange green').addClass('red');
    } else if (info.free_shipping_percentage >= 51 && info.free_shipping_percentage <= 99) {
        $bar.removeClass('red green').addClass('orange');
    } else if (info.free_shipping_percentage > 99) {
        $bar.removeClass('red orange').addClass('green');
    }
    //console.log(info.free_shipping_percentage);
}

ShopCart.selectedCarrier = function (carrier) {
    var selected_carrier = $('.shippingMethodCheckout').find('.selectedShipping').find('input').val();
    if (selected_carrier != carrier.type) {
        $('.shippingMethodCheckout').find('dd').removeClass('selectedShipping');
        /* Only for petness and MISCOTA, select with click shipping options */
        $('input[value="' + carrier.type + '"]').closest('dd').find("label").click();
    }
    $('#date_delivery_text').html(carrier.resume_text);
}

ShopCart.refreshCartHeader = function () {
    const $counter = MOBILE ? $('.cart-items') : $('.cart-counter');
    if ($counter.length == 0) {
        return false;
    }

    if (MOBILE) {
        $.post('/modules/cart/printCartHeader',
            function (result) {
                $counter.html(result.n_items);
                $('#drawerRight .hy-drawer-content').html(result.cart_opened);
                if (parseInt(result.n_items) > 0) {
                    $('#header .cart').removeClass("is-empty").addClass("is-full");
                } else {
                    $('#header .cart').addClass("is-empty").removeClass("is-full");
                }
            },
            'json'
        );
    } else {
        $.post('/modules/cart/printCartHeader',
            function (result) {
                $counter.html(result.n_items);
                $('#cartOpened').html(result.cart_opened);

                const $cartModule = $('.cart-module');
                if (parseInt(result.n_items) > 0) {
                    $cartModule.removeClass('empty');
                    $(".click_checkout").click(function () {
                        document.location.href = '/checkout';
                    });
                }

                if (ShopCart.getShowCart()) {
                    ShopCart.showCartHeader();
                }
            },
            'json'
        );
    }
}

ShopCart.showCartHeader = function (time = 3000) {
    if (!MOBILE) {
        const $floatingCart = document.querySelector('#js-cart-module');
        $floatingCart.classList.add('hover', 'delay');
        const timer = setTimeout(function () {
            $floatingCart.classList.remove('hover', 'delay');
            clearTimeout(timer);
        }, time);
    }
}


ShopCart.setDelayProdsMsg = function (delayProds, subtotal) {
    var $msg = document.querySelectorAll('.delay-prod-msg');
    for (let i = 0; i < delayProds.length; i++) {
        let el = delayProds[i];
        var showMsg = (el.price / subtotal) < 0.25;
        showMsg ? $msg[i].classList.remove('v-hidden') : $msg[i].classList.add('v-hidden');
    }
}

function Promo() {
}

Promo.selectPromo = function (ref, input) {
    var action = input.checked ? 'add' : 'del';
    $.post('/promos/' + action + 'PromoCarrito',
        {ref: ref},
        function (result) {
            if (!result)
                input.checked = !input.checked;
        },
        'json');
}

Promo.addDoblePack = function (ref, quantity, fn) {
    if (typeof quantity == 'undefined') quantity = 1;
    $.post('/promos/addDoblePack', {ref: ref, quantity: quantity}, fn, 'json');
}

Promo.addPromoPack = function (id_promo, quantity, fn) {
    $.post('/promos/addPromoPack', {id_promo: id_promo, quantity: quantity}, fn, 'json');
}

Promo.addSpecialLimitedOffer = function (ref) {
    $.post('/promos/addSpecialLimitedOffer', {ref: ref}, function () {
        document.location.href = '/checkout';
    });
}

Promo.getSelectedRef = function (form) {
    var elem = $(form).find('input:radio:checked[name^="quan"]').get(0);
    if (!elem) return false;
    var name = elem.name;
    var results = /^quan\[([^\]]+)\]$/.exec(name);
    var ref = results ? results[1] : false;
    return ref;
};

var addingMultiPack = false;
Promo.addMultiPack = function (form, idProduct, ref, addItemTrigger = 'producto-ficha') {
    if (addingMultiPack) return;
    addingMultiPack = true;

    addItemTrigger = getAddItemTrigger(addItemTrigger);

    if (ref === undefined) {
        var elem = $(form).find('input:radio:checked[name^="quan"]').get(0);
        ref = Promo.getSelectedRef(form);
    }
    var is_food = $('#is_food').val();
    var showPopupPromo = is_food == 1 && !MOBILE && SHOP_ID == 1;

    if (ref) {
        var COMB = __COMBS[ref];
        var quantity = elem ? elem.value : 1;
        var multipack = 1;
        if ($(form.multiuds).filter(":checked").val()) {
            multipack = $(form.multiuds).filter(":checked").val();
        } else if ($('#product-quantity-mp').val()) {
            multipack = $('#product-quantity-mp').val();
        }
        if (!COMB.show_mp) {
            quantity = multipack;
            multipack = 1;
        }
        pushAddToCartEventToDataLayer(ref, 'add', quantity * multipack, addItemTrigger); //Google Analytic Ecommerce Enhanced: Add product to cart.

        var loadingDiv = ContentLoading();

        //Offer dog/cat products popup
        $.post('/promos/addMultiPack',
            {
                idProduct: idProduct,
                ref: ref,
                quantity: quantity,
                multipack: multipack,
                CART: 0
            },
            function () {
                loadingDiv.remove();
                ShopCart.setShowCart(true);
                ShopCart.refreshCartHeader();
                addingMultiPack = false;

                if (MOBILE) {
                    popUpAddtocart();
                } else {
                    addToCartAnimation('#prod-big-imgs .swiper-slide-active > img');
                    if (showPopupPromo) {
                        let timer = setTimeout(() => {
                            FichaPromoPopup.getInstance(form).show();
                            clearTimeout(timer);
                        }, 2500);
                    }
                }
            }
        );
    }

    addingMultiPack = false;
    return false;
}

function getDataFromSelectedSavedAddress() {
    let allSavedAddress = document.querySelectorAll('.saved-shipping-address .saved-address');
    let selectedAddress = allSavedAddress.length
        ? Array.from(allSavedAddress).filter(address => address.querySelector('input[type="radio"]').checked)
        : null;

    if (!selectedAddress) {
        return null;
    }

    return {
        'postalcode': selectedAddress[0].dataset.postalcode,
        'region': selectedAddress[0].dataset.region,
    }
}

function checkPasswordLength(form, errorClass, minLength = 7) {
    var errorPass = true;
    var _error = __('enter_at_least_n_chars', minLength);
    var pass = $(form).find('input[type="password"]').first();
    for (var idx = 0; idx < pass.length; ++idx) {
        var input = $(pass[idx]);
        if (input.attr('name') !== 'old_pass' && (input.val().length < minLength)) {
            $(input).change();
            if (errorClass === 'validation-wrong') {
                $(input).closest('div[class^="single-"]').addClass(errorClass);
                $(input).after($('<span class="input-validation" input-ko />'));
                //$('#register-errors').append('<p>'+__('password_error_match')+'</p>');
                $('#register-errors').append('<p>' + _error + '</p>');
            } else if (errorClass === 'span.errorSpan') {
                $(input).addClass(INPUT_KO);
                var errorSpan = $(input).closest('td').find('span.errorSpan');
                if (errorSpan.length > 0) errorSpan.text(_error);
            } else if (errorClass === 'login-ko-message') {
                var orig_text = $(form).find('button').text();
                $('#login-ko-message').text(_error);
                $('#login-ko-message').show();
                $(form).find('button').text(orig_text);
                $(input).addClass(INPUT_KO);
            } else if (errorClass === 'errorPassword') {
                $(input).addClass(INPUT_KO);
                $('#errorPassword td:nth-child(2) span').text(_error);
                $('#errorPassword').show();
            } else {

            }
            errorPass = false;
        }
    }

    return errorPass;
}

function addToCartAnimation(photo, widthMultiplier = 1) {
    var prodImgClone = $(photo).clone();
    var scrollTop = $(window).scrollTop();
    var prodImgWidth = $(photo).outerWidth() * widthMultiplier;
    var prodImgHeight = $(photo).outerHeight() * widthMultiplier;
    var prodImgWidth_half = prodImgWidth / 2;
    var posImgLeft_def = $(photo).offset().left - (prodImgWidth - $(photo).outerWidth()) / 2;
    var posImgTop = $(photo).offset().top;
    var posImgTop_def = (posImgTop - scrollTop) - (prodImgHeight - $(photo).outerHeight()) / 2;
    var posCartLeft_def = $('.click_checkout').offset().left;
    var posCartTop = $('.click_checkout').offset().top;
    var posCartTop_def = (posCartTop - scrollTop);
    var offsetCustom = 26;
    var offset2CartLeft = (posCartLeft_def - posImgLeft_def - prodImgWidth_half + offsetCustom);
    var offset2CartTop = (posCartTop_def - posImgTop_def - prodImgWidth_half);

    $('head').append('<style type="text/css">  @keyframes flytocart-animation-inline {0%{opacity: 0; transform: translate3d(0,0,0) scale(.3); box-shadow: 0 0 80px rgba(0,0,0,1)} 15%{opacity: 1; transform: translate3d(0,0,0) scale(1.2); box-shadow: 0 100px 140px -20px rgba(0,0,0,.3)} 22%{opacity: 1; transform: translate3d(0,0,0) scale(1.15); box-shadow: 0 100px 140px -20px rgba(0,0,0,.3)} 45%{opacity: 1; transform: translate3d(0,0,0) scale(1.15); box-shadow: 0 100px 140px -20px rgba(0,0,0,.3)} 60%{opacity: 1; transform: translate3d(0,0,0) scale(.15); box-shadow:none;} 90%{opacity:.3; transform: translate3d(' + offset2CartLeft + 'px, ' + offset2CartTop + 'px, 0px) scale(.1) } 100%{opacity:1; transform: translate3d(' + offset2CartLeft + 'px, ' + (offset2CartTop + 20) + 'px, 0px) scale(0) } }</style>');
    //$('head').append('<style type="text/css">  @keyframes flytocart-animation-inline {0%  {opacity: 0; transform: translate3d(0,0,0) } 15%  {opacity: 1; transform: translate3d(0,0,0) scale(.15) } 17%  {opacity: 1; transform: translate3d(0,0,0) scale(.2) } 25%  {opacity: 1; transform: translate3d(0,0,0) scale(.2) } 40%  {opacity: 1; transform: translate3d(0,0,0) scale(.15) } 90%  {opacity:.2; transform: translate3d('+offset2CartLeft+'px, '+offset2CartTop+'px, 0px) scale(.1) } 100% {opacity:1; transform: translate3d('+offset2CartLeft+'px, '+(offset2CartTop+100)+'px, 0px) scale(0) } }</style>');

    $('body').append($('<div />').attr('class', 'popUpBg fadeIn'));
    $('header .full-row.module2').append($('<div />').attr('class', 'containerFixed').append(prodImgClone.attr('id', 'mainPhotoClone').css({
        'left': posImgLeft_def,
        'top': posImgTop_def,
        'width': prodImgWidth,
        'height': prodImgWidth,
        'object-fit': 'cover'
    })));
    $('#mainPhotoClone').addClass('flytocart').delay(600).queue(function () {
        setTimeout(function () {
            $('.containerFixed').remove();
            $('.popUpBg').addClass('fadeOut').delay(300).queue(function () {
                $(this).remove();
            });
        }, 3000);
    });
}

function popUpAddtocart() {
    $.post('/modules/user/loadContentModal',
        {template: 'popup_addtocart', question: __('added_to_cart'), small_text: __('')},
        function (result) {
            contentModal(result);
            $('#confirm-action').click(function () {
                $('#cancel-action').click();
                document.location.href = '/checkout';
            });
        }
    );
}

async function changePreferredNetwork(select, payMethodId) {
    let loadingDiv;
    try {
        loadingDiv = ContentLoading();
        select.closest('.saved-credit-card-network').className = `saved-credit-card-network ${select.value}`;
        document.getElementById('selected-network--img').src = `${STATIC_URL}media/common/checkout/${select.value}.svg`;

        const data = new FormData();
        data.append('network', select.value);
        data.append('paymentMethodId', payMethodId);

        const response = await fetch('/TPV_Stripe/updatePreferredNetwork?ajax=true', {
            method: 'POST',
            body: data
        });
        if (!response.ok) {
            const error = await response.text();
            throw new Error(error);
        }
        const result = await response.json();
        if (result.error) {
            throw new Error(result.error);
        }
        contentLoadingOK(loadingDiv, __('preferred_network_updated'));
        console.log('✔ ' + __('preferred_network_updated'));

    } catch (error) {
        contentLoadingKO(loadingDiv, __('preferred_network_update_error') + ': ' + error.message);
        console.error('❌ ' + __('preferred_network_update_error') + ': ', error.message);
    }
}

function popUpSocialConditions(email, first_name, social) {
    $.post('/modules/user/loadContentModal',
        {template: 'popup_social_network'},
        function (result) {
            contentModal(result);
            $('#confirm-social-confirm-action').click(function () {
                var newsletter = $('#newsletter:checked').val();
                var conditions = $('#conditions:checked').val();
                if (!conditions) {
                    $('#privacy_error').show();
                    return false;
                }
                $.post('/scripts/' + social + '-callback.php', {
                    email: email, first_name: first_name, newsletter: newsletter
                }, function (data) {
                    if (data.code == 200) {
                        $('#privacy_error').hide();
                        pushDatalayer('eventGA', 'Login', 'Success', 'Google', 1, 1);
                        UserInfo.clear();
                        location.reload();
                    } else {
                        pushDatalayer('eventGA', 'Login', 'Error', data.response, 1, 1);
                    }
                }, 'json');
            });
        }
    );
}


Promo.addPromoSnacks = function (event, el, ref, addItemTrigger = 'cross-selling-complementos-ficha') {
    const $checkbox = $(el);
    const $li = el.closest('li');
    addItemTrigger = getAddItemTrigger(addItemTrigger);

    if ($li.classList.contains('is-selected')) {
        ShopCart.delItem(ref, 1, false, addItemTrigger);
        $li.classList.remove('is-selected');
        $checkbox.prop('checked', false).attr('checked', false).val(0);
        ShopCart.refreshCartHeader();
    } else {
        ShopCart.addItem(ref, 1, function (result) {
            if (result === false) {
                $li.classList.remove('is-selected');
                $checkbox.prop('checked', false).attr('checked', false).val(0);
                ShopCart.refreshCartHeader();
            } else {
                var photo = $li.querySelector('.product-complement--image');
                ShopCart.setShowCart(true);
                ShopCart.refreshCartHeader();
                if (MOBILE) {
                    popUpAddtocart();
                } else {
                    addToCartAnimation(photo, 4);
                }
                $li.classList.add('is-selected');
                $checkbox.attr('checked', true).attr('checked', true).val(1);
            }
        }, addItemTrigger);
    }
}

function sendUserForm(form, fnSuccess) {
    var loading = getLoadingImg('20');
    loading.insertBefore(form.submit);
    form.submit.disabled = true;
    $.post(form.action,
        $(form).serialize(),
        function (result) {
            if (result.error && result.error == 'login_required') {
                var coords = getCoords(form.submit);
                PopUpLoginReg.getInstance()
                    .hide()
                    .show('normal',
                        function () {
                            sendUserForm(form, fnSuccess);
                        }, function () {
                            loading.remove();
                            form.submit.disabled = false;
                        });
            } else {
                loading.remove();
                form.submit.disabled = false;
                if (typeof fnSuccess == 'function')
                    fnSuccess(result);
            }
        },
        'json');
    return false;
}

function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


/***************** LOGIN *****************/
var INPUT_OK = 'shippingTextInputValidate';
var INPUT_KO = 'errorInput';

function showLoginForgot() {
    var toTable = $('.scrollItem:nth-child(2)');
    toTable.css({visibility: 'visible'});

    var iframe = $('.scrollItem').first();
    var email = iframe.find('form').get(0).user.value;
    if (email) toTable.find('form').get(0).email.value = email;
    var width = iframe.width();
    $('.scrollWrapper').stop(true).animate({scrollLeft: '290px'}, 500, 'easeOutCubic', function () {
        iframe.css({visibility: 'hidden'});
        var toTable = $('.scrollItem:nth-child(3)');
        toTable.css({visibility: 'hidden'});
        var toTable = $('.scrollItem:nth-child(1)');
        toTable.css({visibility: 'hidden'});
    });
}

function showLogin() {
    $('.scrollItem').first().css({visibility: ''});
    $('.scrollWrapper').stop(true).animate({scrollLeft: '0px'}, 500, 'easeOutCubic', function () {
        $('.scrollItem:nth-child(2)').css({visibility: 'hidden'});
        $('.scrollItem:nth-child(3)').css({visibility: 'hidden'});
    });
}

function login(form) {
    pushDatalayer('eventGA', 'Login', 'Click', 'Email', 1, 1);
    if (form.user.value == '' || form.pass.value == '') {
        pushDatalayer('eventGA', 'Login', 'Error', 'Sin datos de acceso', 1, 1);
        return false;
    }
    var $button = $(form).find('button');
    var orig_text = $button.html();
    $('#errorLogin').hide();
    if (IS_CHECKOUT_PAGE) {
        var loading = ContentLoading();
    } else {
        var loading = getLoadingImg('30');
        $button.empty().append(loading);
    }

     __checkLoginRecaptcha($button, function () {
        return sendForm(
            form,
            function (result) {
                pushDatalayer('eventGA', 'Login', 'Success', "Email", 1, 1);
                UserInfo.clear();
                if ($(form).attr('type') == 'popUp') {
                    var popup = PopUpLoginReg.getInstance();
                    var popupStock = PopUpStockLoginReg.getInstance();
                    if (typeof popup.callback == 'function') {
                        popup.callback(result);
                        popup.close();
                    } else if (typeof popupStock.callback == 'function') {
                        popupStock.callback(result);
                        popupStock.close();
                    }
                } else {
                    if (typeof form.next !== 'undefined' && form.next && !form.review_from_retail_qr) {
                        document.location.href = form.next.value;
                    } else if (form.review_from_retail_qr) {
                        document.location.href = form.review_from_retail_qr.value; // reload to url prod + #write-review-btn anchor to show review modal
                    } else {
                        document.location.reload();
                    }
                }
            },
            function (result) {
                if (IS_CHECKOUT_PAGE) {
                    $(loading).remove();
                }
                if ($('#errorLogin td:nth-child(2) span').length > 0) {
                    $('#errorLogin td:nth-child(2) span').text(result.error);
                } else {
                    $('#errorLogin').text(result.error);
                }
                $('#errorLogin').show();
                $(form.elements).filter(':not(:submit)').addClass(INPUT_KO);
                $button.html(orig_text);
                pushDatalayer('eventGA', 'Login', 'Error', result.error, 1, 1);
            }
        );
     });

    return false;
}

function __checkLoginRecaptcha($button, fn) {
    var grecaptcha_sitekey = $button.data('sitekey');

    if (grecaptcha_sitekey && typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function () {
            grecaptcha.execute(grecaptcha_sitekey, {action: 'login'}).then(function (token) {
                if ($($button.get(0).form).children('input[name=g-recaptcha-response]').length == 0) {
                    $($button.get(0).form).append(
                        $('<input />').attr({'type': 'hidden', 'name': 'g-recaptcha-response', 'value': token})
                    );
                } else {
                    $($button.get(0).form).children('input[name=g-recaptcha-response]').val(token)
                }
                fn();
            });
        });
    } else {
        fn();
    }
}

// // Mostrar/Ocultar login-form y login-forgot
// $(function () {
//   $('#password-forgot').click(function(){
//     $('#login-form').slideUp();
//     $('#login-forgot').slideDown();
//   });
//
//   $('#password-remembered').click(function(){
//     $('#login-form').slideDown();
//     $('#login-forgot').slideUp();
//
//   });
// });

function register(form) {
    $('#login-ko-message').hide();
    if (!checkPasswordLength(form, 'login-ko-message')) {
        return false;
    }
    var orig_text = $(form).find('button').text();
    var $button = $(form).find('button');

    $(form).find('button').text(__('loading') + '...');
    if (IS_CHECKOUT_PAGE) var loading = ContentLoading();
    __checkLoginRecaptcha($button, function () {
        return sendForm(form, function (result) {
            pushDatalayer('eventGA', 'Registro', 'Success', 1, 1, 1);
            $(form).find('button').text(orig_text);
            if (form.next && !form.review_from_retail_qr) document.location.href = form.next.value;
            else if (form.review_from_retail_qr) document.location.href = form.review_from_retail_qr.value;  // reload to url prod + #write-review-btn anchor to show review modal
            else document.location.reload();
        }, function (result) {
            if (IS_CHECKOUT_PAGE) $(loading).remove();
            var error = '';

            for (var key in result.error) {
                if (typeof result.error[key] === "function") {
                    continue
                }
                if (typeof result.error[key] === "undefined") {
                    continue
                }
                error = error + result.error[key];
            }

            $('#login-ko-message').text(error);
            $('#login-ko-message').show();
            $(form).find('button').text(orig_text);
            $(form.elements).filter(':not(:submit)').addClass(INPUT_KO);
            pushDatalayer('eventGA', 'Registro', 'Error', result.error, 1, 1);
        });
    });

    return false;
}

//MIS-1358
function showModalNewsletterOld() {
    var btn = $('#popup_login_button');
    var recaptcha = btn.data('sitekey');
    btn.replaceWith('<button type="submit" id="popup_login_button" data-sitekey="' + recaptcha + '" class="login__button email-login" >' + __('register_me') + '</div>');

    if ($('#newsletterModal').prop('checked') == true) {
        btn.click();

    } else {
        $.post('/modules/user/loadContentModal',
            {template: 'newsletter_check', question: __('newsletter_question_9'), small_text: __('newsletter_info_9')},
            function (result) {
                /* CONFIRM POPUP */
                contentModal(result);

                $('#confirm-action').click(function () {
                    $(this).closest('.popUpContainer-data').remove();
                    $('#newsletterModal').prop('checked', true);
                    $('#popup_login_button').click();
                });

                $('.close-button').click(function () {
                    $('#newsletterModal').prop('checked', false);
                    $('#popup_login_button').click();
                });
            });
    }
}

//END MIS-1358

function showModalNewsletter() {
    var btn = $('#popup_login_button');
    var recaptcha = btn.data('sitekey');
    btn.replaceWith('<button type="submit" id="popup_login_button" data-sitekey="' + recaptcha + '" class="login__button email-login" >' + __('register_me') + '</div>');

    let dog = document.getElementById('dog-input');
    let cat = document.getElementById('cat-input');
    let rodent = document.getElementById('rodent-input');
    let bird = document.getElementById('bird-input');
    let fish = document.getElementById('fish-input');
    let reptile = document.getElementById('reptile-input');

    if (dog.checked || cat.checked || rodent.checked || bird.checked || fish.checked || reptile.checked) {

    } else {
        $.post('/modules/user/loadContentModal',
            {
                template: 'newsletter_check',
                question: __('newsletter_question_9'),
                small_text: __('newsletter_info_9'),
                ext_content: '-modal-register'
            },
            function (result) {
                /* CONFIRM POPUP */
                contentModal(result, false, 'modal-newsletter-open', false);

                $('#confirm-action').click(function () {
                    dog.checked = document.getElementById('dog-input-modal-register').checked;
                    cat.checked = document.getElementById('cat-input-modal-register').checked;
                    rodent.checked = document.getElementById('rodent-input-modal-register').checked;
                    bird.checked = document.getElementById('bird-input-modal-register').checked;
                    fish.checked = document.getElementById('fish-input-modal-register').checked;
                    reptile.checked = document.getElementById('reptile-input-modal-register').checked;

                    $(this).closest('.popUpContainer-data').remove();
                    $('#popup_login_button').click();
                });

                $('.close-button').click(function () {
                    $('#popup_login_button').click();
                });
            });
    }
}

function popUpNewsletterPets() {

    //btn.replaceWith('<button type="submit" id="popup_login_button" data-sitekey="'+recaptcha+'" class="login__button email-login" >'+__('register_me')+'</div>');

    let dog = document.getElementById('dog-input-3');
    let cat = document.getElementById('cat-input-3');
    let rodent = document.getElementById('rodent-input-3');
    let bird = document.getElementById('bird-input-3');
    let fish = document.getElementById('fish-input-3');
    let reptile = document.getElementById('reptile-input-3');

    $.post('/modules/user/loadContentModal',
        {
            template: 'popup_newsletter_pets',
            question: __('newsletter_question_9'),
            small_text: __('newsletter_info_9'),
            ext_content: '-3'
        },
        function (result) {
            /* CONFIRM POPUP */
            contentModal(result, false, false, false);

            $('#confirm-action').click(function () {
                dog.checked = document.getElementById('dog-input-modal-register').checked;
                cat.checked = document.getElementById('cat-input-modal-register').checked;
                rodent.checked = document.getElementById('rodent-input-modal-register').checked;
                bird.checked = document.getElementById('bird-input-modal-register').checked;
                fish.checked = document.getElementById('fish-input-modal-register').checked;
                reptile.checked = document.getElementById('reptile-input-modal-register').checked;

                $(this).closest('.popUpContainer-data').remove();
                $('#popup_login_button').click();
            });

            $('.close-button').click(function () {
                $('#popup_login_button').click();
            });
        });
}

//Show Modal Map Shop MSK
function showModalMapShop(idRetailMsk) {
    const iframe = document.getElementById(idRetailMsk).value;
    contentModal(iframe);
    $('.data-wrapper').addClass('shop-map');
}


function setActiveRegionShopUrl() {
    const region = document.getElementById('region');
    if (!!region) {
        const urlBase = document.getElementById('url_our_shops').value;
        region.addEventListener('change', function () {
            const urlSlug = this.value == 'all' ? '' : this.value;
            window.location.href = urlBase + '/' + urlSlug;
        });
    }
}


function unsubscribe(form) {
    var loadingDiv = ContentLoading();
    form.submit.disabled = true;
    $.post(form.action,
        $(form).serialize(),
        function (result) {
            form.submit.disabled = false;
            if (result.error) {
                contentLoadingKO(loadingDiv, result.error);
            } else if (result.success) {
                contentLoadingOK(loadingDiv, result.success, 2500);
                _debounceFn(function () {
                    document.location.href = '/';
                }, 2000)();
            }
        },
        'json');
    return false;
}

function loginForgot(form, is_new) {
    var orig_text = $(form).find('button').text();
    $(form).find('button').text(__('loading') + '...');

    $('#errorLoginForgot').hide();
    return sendForm(form, function (result) {
        if (is_new === true) {
            $(form).find('p').animate({'opacity': 0}, 1000, function () {
                $(this).text(__('forgot_password_result'));
            }).animate({'opacity': 1}, 1000);
            $(form).find('button').html('<i class="icon-check-mark"></i>')
        } else {
            $(form).replaceWith(
                $('<span />').text(__('forgot_password_result'))
            );
        }
    }, function (result) {
        $('#errorLoginForgot').show();
        $(form).find('button').text(orig_text);
        $(form.elements).filter(':not(:submit)').addClass(INPUT_KO);
    });
}

function countryRedirection(value) {
    document.location.href = value;
}

function registerEmail(form, fnSuccess) {
    $('#errorRegister').hide();
    return sendForm(form, function (result) {
        if (typeof fnSuccess == 'function') {
            fnSuccess(result);
        } else if (form.next) {
            document.location.href = form.next.value;
        }
    }, function (result) {
        $(form.elements).filter(':not(:submit)').addClass(INPUT_KO);
        if ($('#errorRegister').length > 0) {
            $('#errorRegister span.errorSpan').text(result.error['email']);
            $('#errorRegister').show();
        }
    });
}

function registerEmailPopUp(form) {
    $('#errorRegister').hide();
    return sendForm(form, function (result) {
        var popup = PopUpStockLoginReg.getInstance();
        if (typeof popup.callback == 'function') {
            popup.callback(result);
            popup.close();
        } else if (form.next) {
            document.location.href = form.next.value;
        }
    }, function (result) {
        $(form.elements).filter(':not(:submit)').addClass(INPUT_KO);
        if ($('#errorRegister').length > 0) {
            $('#errorRegister td:nth-child(2) span').text(result.error);
            $('#errorRegister').show();
        }
    });
}

function subscribe(form, typeDL = 'undefined', buttonId = null, inputId = null) {
    if (buttonId) {
        $button = $(buttonId);
    } else {
        if ($('#newsletterBlock form').length) {
            $button = $('#newsletterBlock form').find('button[type=submit]');
        }

        if ($('#formSubscription3').length) {
            $button = $('#formSubscription3').find('input[type=button]');
        }
    }

    __checkLoginRecaptcha($button, function () {
        sendForm(
            form,
            function (result) {
                if (window.google_tag_manager) {
                    window.google_tag_manager[GTM_ID].dataLayer.set('usuario.email', form.email.value);
                }
                pushDatalayer('eventGA', 'Lead', 'Enviar', typeDL, 1, 1);
                $(form).replaceWith('<span class="newsletter-success">' + __('pet_suscribed_result') + '</span>');
            },
            function (result) {
                for (var key in result.error) {
                    var input = $(form.elements[key]);
                    input.addClass(INPUT_KO);
                }
            },
            inputId
        );
    });
    return false;
}

function subscribeWhenLogged(form, redirect = true) {

    var typeDL = typeof typeDL !== 'undefined' ? typeDL : 'Other';

    if ($('#newsletterBlock2 form').length > 0) {
        $button = $('#newsletterBlock2 form').find('button[type=submit]');
    }
    sendForm(form, function (result) {
        $(form).replaceWith('<span class="newsletter-success">' + __('pet_suscribed_result') + '</span>');
        if (redirect) {
            document.location.href = '/user?tab=interests';
        }
    }, function (result) {
        for (var key in result.error) {
            var input = $(form.elements[key]);
            input.addClass(INPUT_KO);
        }
    });

    return false;
}

function sendForm(form, fnSuccess, fnError, inputIdWrapper = null) {
    if (form.dataset.name === 'footer-subscribe') {
        if (!form.name || !form.conditions) {
            location.reload();
            return false;
        }
        if (form.name.value === '') {
            alert(__('error_name'));
            return false;
        }
    }
    if (form.conditions !== undefined && form.conditions.checked === false) {
        alert(__('must_accept_conditions'));
        return false;
    }

    $(form.elements).removeClass(INPUT_KO);
    let loading = resumeLoadingNewsletter();

    if (typeof form.submit == 'object') {
        form.submit.disabled = true;
        loading = insertLoadingImg(form.submit, '20px');
    }
    $.post(form.action,
        $(form).serialize(),
        function (result) {
            if (loading) {
                $(loading).remove();
            }
            if (!result || !result.error) {
                if (typeof fnSuccess == 'function') {
                    fnSuccess(result);
                }
            } else {
                $('.newsletter-error').remove();
                const text = result && result.error && result.error.email ? result.error.email : __('already_exists_account_email');
                if (inputIdWrapper) {
                    $(inputIdWrapper).after("<span class='newsletter-error'>" + text + "</span>");
                } else {
                    $('#newsletterBlock .input-text-wrapper').after("<span class='newsletter-error'>" + text + "</span>");
                    $('#newsletterBlock2 .input-text-wrapper').after("<span class='newsletter-error'>" + text + "</span>");
                }
                if (typeof fnError == 'function') {
                    fnError(result);
                }
            }
            if (typeof form.submit == 'object') {
                form.submit.disabled = false;
            }
        },
        'json'
    );

    return false;
}

function resumeLoadingNewsletter() {
    var div = $('.newsletter-wrapper > .newsletterResumeLoading');
    if (div.length > 0) return div;
    div = $('<div />').attr('class', 'checkoutResumeLoading');
    var loadingImg = getLoadingImg();
    div.append($('<div />').attr('class', 'popUpBg'))
        .append(($('<div />').attr('class', 'loading-wrapper'))
            .append(loadingImg));

    $('.newsletter-wrapper').append(div);
    return div;
}

/************************************** POPUP LOGIN/REGISTER STOCK **************************************/

function PopUpStockLoginReg() {
    var self = this;
    this.tmpls = {};
    this.deferLoading = false;

    $('<div />').load('/modules/user/printLoginRegisterStockPopUp', function () {
        self.popup = $(this).children();
        self.bg = self.popup.find('.loginpopUpBg');
        self.window = self.popup.find('.loginpopUpWindow');
        self.content = self.popup.find('.loginpopUpContent');
        self.popup.on('click', '.loginpopUpClose, .loginpopUpBg', function () {
            self.close();
        });
        $(document.body).append(this);

        const submitStockPopupBtn = document.getElementById('submitStockPopup');
        const form = document.getElementById('formStockPopup')
        submitStockPopupBtn.addEventListener('click', (e) => {
            e.preventDefault();
            form.requestSubmit();
        });
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            registerEmailStockPopUp(form);
        });

        if (self.deferLoading) {
            self.show();
        }
    });
}

PopUpStockLoginReg.instance = null;

PopUpStockLoginReg.getInstance = function (ref) {
    if (PopUpStockLoginReg.instance == null)
        PopUpStockLoginReg.instance = new PopUpStockLoginReg();
    PopUpStockLoginReg.instance.ref = (ref === undefined) ? null : ref;
    return PopUpStockLoginReg.instance;
}

PopUpStockLoginReg.prototype = {
    init: function () {

    },
    show: function (speed, callback, callbackClose) {
        if (typeof this.popup == 'undefined') {
            this.deferLoading = true;
        } else {
            addEvent(document, "keydown", PopUpStockLoginReg.closeDialogHandler);
            this.popup.fadeIn(speed || 0);
            this.callback = callback;
            this.callbackClose = callbackClose;
            this.center().popup.show();
            this.init();
            this.popup.find('input[name="email"]').focus();

            if (this.ref != undefined && this.ref)
                this.popup.find('input[name="ref"]').val(this.ref);
        }
        return this;
    },
    hide: function (speed) {
        var self = this;
        removeEvent(document, "keydown", PopUpStockLoginReg.closeDialogHandler);
        this.window.fadeOut(speed || 0, function () {
            self.popup.hide();
            $(this).show();
        });
        return this;
    },
    close: function () {
        if (typeof this.callbackClose == 'function')
            this.callbackClose();
        this.hide('normal');
    },
    center: function () {
        var lastDisplay = this.popup.css('display');
        var lastVisibil = this.popup.css('visibility');
        this.popup.css({display: 'flex', visibility: 'hidden'});
        var w = this.window.width();
        var h = this.window.height();
        this.popup.css({display: lastDisplay, visibility: lastVisibil});
        this.window.css({'margin-top': -h / 2 + 'px', 'margin-left': -w / 2 + 'px'})
        return this;
    }
}

PopUpStockLoginReg.closeDialogHandler = function (event) {
    var keyCode = window.event ? window.event.keyCode : event.which;
    if (keyCode == KeyEvent.DOM_VK_ESCAPE) {
        PopUpStockLoginReg.getInstance().close();
        event.preventDefault();
    }
}


;(function ($) {

    $.fn.saveHTMLTemplate = function (name, idx) {
        if (name == undefined) name = 'template';
        if (idx == undefined) idx = 0;

        var template = $(this).children().get(idx);
        var newTemplate = {};
        newTemplate[name] = $(template).detach().get(0);
        $(this).data('templates', $.extend($(this).data('templates'), newTemplate));

        return template;
    }

    $.fn.applyHTMLTemplate = function (info, name, replace) {
        if (this.attr('typelist') == 'unique' && !replace) this.empty();
        if (name == undefined) name = 'template';
        var template = $(this.data('templates')[name]).clone(true);

        if (info != undefined) {
            info = $.extend({}, info, this.data('info'));

            template = $(Template.parseVars(template.getHTML(), info));

            $(template).data('info', info);
        }

        if (replace != undefined) $(replace).replaceWith(template);
        else $(this).append(template);

        return template.show();
    }

    $.fn.applyHTMLTemplateList = function (list, name) {
        var templates = [];
        for (var idx = 0; idx < list.length; ++idx) {
            templates.push($(this).applyHTMLTemplate(list[idx], name));
        }
        return templates;
    }

    $.fn.getHTML = function () {
        return $('<div />').append(this.clone()).remove().html();
    };

    $.fn.replaceNodeValues = function (pattern, info, recursive) {
        var regexp = new RegExp(pattern),
            self = this.get(0), matches, tag, name;
        if (self.nodeType == Node.TEXT_NODE) {
            matches = regexp.exec(self.textContent);
            if (matches) {
                tag = matches[1];
                name = matches[2];
                // [,tag, name] = matches;
                if (info[tag] !== undefined && info[tag][name] !== undefined) {
                    self.textContent = self.textContent.replace(regexp, info[tag][name]);
                    $(self).empty().append(self.textContent);
                }
            }
        } else {
            if (self.attributes) {
                for (var idx = 0; idx < self.attributes.length; ++idx) {
                    var key = self.attributes[idx].nodeName,
                        value = self.attributes[idx].textContent;
                    matches = regexp.exec(value);
                    if (matches) {
                        tag = matches[1];
                        name = matches[2];
                        //[, tag, name] = matches;
                        if (info[tag] !== undefined && info[tag][name] !== undefined) {
                            $(self).attr(key, value.replace(regexp, info[tag][name]));
                        }
                    }
                }
            }

            var templates = $(self).data('templates');
            if (templates) {
                $(self).data('info', $.extend($(self).data('info'), info));
            }


            if (recursive) {
                for (var idx = 0; idx < self.childNodes.length; ++idx) {
                    $(self.childNodes[idx]).replaceNodeValues(pattern, info, recursive);
                }
            }
        }
    }

    $.fn.updateHTMLTemplateOld = function (info) {
        var template = $(this);

        $(template).replaceNodeValues('<#?ci:([a-zA-Z\\-_]+)\\s+([a-zA-Z\\-_]+)\\s*\\/>', info, true);
        for (var tag in info) {
            for (var name in info[tag]) {
                var value = info[tag][name];
                var elem = $(template).find('ci\\:' + tag + '[' + name + ']');
                if (elem.length > 0)
                    elem.replaceWith(value + '');
            }
        }

        return template;
    }
})(jQuery);

$(document).ready(function () {

    var enabledRecaptcha = false

    if ($('#newsletterBlock form').length > 0 && !enabledRecaptcha) {
        enableRecaptcha($('#newsletterBlock form').find('button[type=submit]'));
        enabledRecaptcha = true;
    }

    if ($('#formSubscription4').length > 0 && !enabledRecaptcha) {
        enableRecaptcha($('#formSubscription4').find('button[name=subbtn]'));
        enabledRecaptcha = true;
    }

    if ($('#formSubscription3').length > 0 && !enabledRecaptcha) {
        enableRecaptcha($('#formSubscription3').find('input[type=button]'));
        enabledRecaptcha = true;
    }

    if ($('#formSubscription1').length > 0 && !enabledRecaptcha) {
        enableRecaptcha($('#formSubscription1').find('input[type=button]'));
    }
});

function enableRecaptcha(btn) {
    const $button = btn;
    const grecaptcha_sitekey = $button.data('sitekey');
    const grecaptcha_loaded = $button.data('grecaptcha_loaded');

    if (grecaptcha_sitekey && !grecaptcha_loaded) {
        _loadScript('https://www.google.com/recaptcha/api.js?render=' + grecaptcha_sitekey, true); // test partytown and cross-origin in dev with https!
        $button.data('grecaptcha_loaded', true);
    }
}


/************************************** POPUP LOGIN/REGISTER **************************************/
function PopUpLoginReg() {
    var self = this;

    this.popup = $('#login-wrapper');
    this.bg = $('#login-overlay');
    this.loginEmail = document.querySelector('#login_email');
    this.forgotEmail = document.querySelector('#forgot_email');
    this.registerName = document.querySelector('#form_register_user #name');
    this.loginNext = this.popup.find('#form_login_user input[name=next]');

    this.popup.find('.close-modal-button').click(function () {
        self.close();
    });
    this.bg.click(function () {
        self.close();
    });
    this.popup.click(function (e) {
        if (e.target !== this) return;
        self.close();
    });

    $("#view-email-login").click(function () {
        $(this).slideToggle(160);
        $("#login-form").slideToggle(220);
    });

    $('#password-forgot').click(function () {
        self.showLoginForgot();
    });

    $('#password-remembered').click(function () {
        self.returnToLogin();
    });

    $("#login-modal-button").click(function () {
        if ($("#login__container").hasClass("register-mode")) {
            $("#login__container").removeClass("register-mode");
            $("#login-modal-button").addClass("is-active");
            $("#register-modal-button").removeClass("is-active");
            let timer = setTimeout(function () {
                self.loginEmail.focus();
                clearTimeout(timer);
            }, 200);
        }
    });

    $("#register-modal-button").click(function () {
        if (!$("#login__container").hasClass("register-mode")) {
            $('#login-form').show();
            $('#login-forgot').hide();

            pushDatalayer('eventGA', 'Registro', 'Click', 1, 1, 1);
            $("#login__container").addClass("register-mode");
            $("#register-modal-button").addClass("is-active");
            $("#login-modal-button").removeClass("is-active");
            let timer = setTimeout(function () {
                self.registerName.focus();
                clearTimeout(timer);
            }, 200);
        }
    });
}

PopUpLoginReg.instance = null;

PopUpLoginReg.getInstance = function () {
    if (PopUpLoginReg.instance == null)
        PopUpLoginReg.instance = new PopUpLoginReg();
    return PopUpLoginReg.instance;
}

PopUpLoginReg.prototype = {
    init: function () {
    },
    show: function (speed, callback, callbackClose, next = null) {
        GoogleLogin.init();
        FacebookLogin.init();

        var $button = this.popup.find('form [type="submit"]');
        var grecaptcha_sitekey = $button.data('sitekey');
        var grecaptcha_loaded = $button.data('grecaptcha_loaded');

        if (grecaptcha_sitekey && !grecaptcha_loaded) {
            _loadScript('https://www.google.com/recaptcha/api.js?render=' + grecaptcha_sitekey, true);
            $button.data('grecaptcha_loaded', true);
        }

        addEvent(document, "keydown", PopUpLoginReg.closeDialogHandler);
        if (callback !== undefined)
            this.callback = callback;
        if (callbackClose !== undefined)
            this.callbackClose = callbackClose;

        this.popup.fadeIn(30).removeClass('animation-out').addClass("animation-in");
        if (MOBILE) $('body').css({position: 'fixed', width: '100%'});

        // var show_login_modal = $_GET('slm');
        // if(show_login_modal) $(this.popup).find('form').find('input[name="next"]').val('/user/');

        if (next) {
            $nextInputs = document.querySelectorAll('#login-modal input[name="next"]');
            if ($nextInputs) {
                $nextInputs.forEach(input => input.value = next);
            }
        }

        // Si existe HyDrawer y está abierto lo cerramos antes de ejecutar showModal
        if (MOBILE && document.getElementById('drawerLeft') && window.drawerL && window.drawerL['opened'] == true) {
            window.drawerL['opened'] = false;
        }

        this.loginEmail?.focus();

        $('html').addClass('no-scroll');

        return this;
    },
    hide: function () {
        var self = this;
        removeEvent(document, "keydown", PopUpLoginReg.closeDialogHandler);

        if (MOBILE) $('body').css({position: '', width: ''});
        this.popup.removeClass('animation-in').addClass("animation-out"); /* .delay(300) */

        var myTimeout = setTimeout(function () {
            self.popup.removeClass("animation-out").hide();
        }, 400);
        $('html').removeClass('no-scroll');

        return this;
    },
    close: function () {
        if (typeof this.callbackClose == 'function')
            this.callbackClose();
        this.hide();
        $('#login-form').slideDown();
        $('#login-forgot').slideUp();
    },
    showLoginForgot: function () {
        let email = this.loginEmail ? this.loginEmail.value : ''
        if (email !== '') {
            this.forgotEmail.value = email;
        }
        $('#login-form').slideUp();
        $('#login-forgot').slideDown();
        $('#forgot_email').focus();
    },
    returnToLogin: function () {
        let email = this.forgotEmail ? this.forgotEmail.value : ''
        if (email !== '' && email !== this.loginEmail.value) {
            this.loginEmail.value = email;
        }
        $('#login-form').slideDown();
        $('#login-forgot').slideUp();
        $('#login_email').focus();
    }
}

PopUpLoginReg.closeDialogHandler = function (event) {
    var keyCode = window.event ? window.event.keyCode : event.which;
    if (keyCode == KeyEvent.DOM_VK_ESCAPE) {
        PopUpLoginReg.getInstance().close();
        event.preventDefault();
    }
}

function ClassExtends(subClass, superClass) {
    function surrogateClass() {
        this._self = subClass;
    }

    surrogateClass.prototype = superClass.prototype;
    var prototypeObject = new surrogateClass();
    prototypeObject.constructor = subClass;
    subClass.prototype = $.extend({}, prototypeObject, subClass.prototype);
}

/* Simple JavaScript Inheritance
 * By John Resig http://ejohn.org/blog/simple-javascript-inheritance/
 * MIT Licensed.
 */
!function () {
    var t = !1, n = /xyz/.test(function () {
        xyz
    }) ? /\b_super\b/ : /.*/;
    this.Class = function () {
    }, Class.extend = function b(r) {
        function e() {
            !t && this.init && this.init.apply(this, arguments)
        }

        var i = this.prototype;
        t = !0;
        var s = new this;
        t = !1;
        for (var o in r) s[o] = "function" == typeof r[o] && "function" == typeof i[o] && n.test(r[o]) ? function (t, n) {
            return function () {
                var r = this._super;
                this._super = i[t];
                var e = n.apply(this, arguments);
                return this._super = r, e
            }
        }(o, r[o]) : r[o];
        return e.prototype = s, e.prototype.constructor = e, e.extend = b, e
    }
}();


/***** INI GENERAL POPUP *****/
var PopUp = Class.extend({
    set: function (id) {
        this.popup = $('#' + id);
        this.init();
        return this;
    },
    init: function () {
        if (typeof this.popup == 'undefined') return false;
        var self = this;
        self.bg = self.popup.find('.popUpBg').click(function () {
            self.close();
        });
        self.window = self.popup.find('.popUpWindow');
        self.closeB = self.popup.find('.popUpClose');
        self.closeB.click(function () {
            self.close();
        });
        self.popup.appendTo(document.body);
        if (self.deferShow) self.show();
        return true;
    },
    load: function (url, fn) {
        if (typeof this.url != 'undefined' && this.url == url) return this;
        if (this.loading) return this;
        var self = this;
        this.deferShow = false;
        this.loading = true;
        $('<div />').load(url, function () {
            self.popup = $(this).children();
            self.init();
            self.url = url;
            if (self.deferShow) self.show();
            if (typeof fn == 'function')
                fn(self);
            self.loading = false;
        });
        return this;
    },
    show: function () {
        if (typeof this.popup == 'undefined') {
            this.deferShow = true;
        } else {
            var id = $(this.popup).attr('id');
            var self = this;
            document.addEventListener("keydown", PopUp.closeDialogHandler, false);
            this.window.show();
            this.center().popup.show(function () {
                self.center();
            });
            if (id == 'popUpBestPriceForm' && window['google_tag_manager']) {
                window.dataLayer.push({
                    'event': 'eventGA',
                    'eventCategory': 'Lead',
                    'eventAction': 'Open',
                    'eventLabel': 'mejorprecio',
                    'eventValue': 1,
                    'eventTimeout': 1000
                });
            }
        }
        return this;
    },
    hide: function (speed, fn) {
        if (typeof this.popup == 'undefined') return false;
        var self = this;
        document.removeEventListener("keydown", PopUp.closeDialogHandler, false);
        this.window.fadeOut(speed || 0, function () {
            self.popup.hide();
            if (typeof fn == 'function') fn();
        });
    },
    close: function (fn) {
        this.hide('normal', fn);
    },
    center: function () {
        var lastDisplay = this.popup.css('display');
        var lastVisibil = this.popup.css('visibility');
        this.popup.css({display: 'block', visibility: 'hidden'});
        var w = this.window.outerWidth();
        var h = this.window.outerHeight();
        this.popup.css({display: lastDisplay, visibility: lastVisibil});
        this.window.css({'margin-top': -h / 2 + 'px', 'margin-left': -w / 2 + 'px'})
        return this;
    }
});

PopUp.instance = null;

PopUp.getInstance = function () {
    if (PopUp.instance == null)
        PopUp.instance = new PopUp();
    return PopUp.instance;
}

PopUp.closeDialogHandler = function (event) {
    var keyCode = window.event ? window.event.keyCode : event.which;
    if (keyCode == 27) PopUp.getInstance().close();
}

/***** FIN GENERAL POPUP *****/

function showPopUpForm(target, title, template, onLoad) {
    PopUp.getInstance().load(title, template, function (tmpl) {
        var form = $(tmpl).find('form').get(0);
        if (typeof onLoad == 'function') onLoad(form);
        var typeForm = $(form).attr('type');
        var objForm = new window[typeForm + 'Form'](form);
        objForm.target = target;
        objForm.popup = PopUp.getInstance();
    }).show();
}


/******* SAMEDAY *******/

/* OXP-73: Sameday. Inicializamos los procesos de Sameday */
const initSameday = () => {
    getSamedayCPtoInput();
    addSamedayFormEvents();
    showSamedayInfoModal();
    toggleSamedayFilter();
    showSamedayAvailableModal();
}

/* OXP-73: Sameday. Recuperar CP de cookie 'sameday_cp' y aplicarla al input del header */
/* TODO: Hacerlo con PHP */
const getSamedayCPtoInput = () => {
    let samedayCpInput = $('.sameday-header input[name="sameday_cp"]')[0];
    if (getCookie('sameday_cp') && !!samedayCpInput) {
        let cp = getCookie('sameday_cp');
        if (samedayCpInput.value) samedayCpInput.value = cp;
    }
}


/* OXP-73: Sameday. Setea/Actualiza la "shipping zone" de sameday al introducir/modificar CP en input del header */
const updateSamedayCP = (form) => {
    let samedayCp = $(form).find('#sameday-cp').val();
    if (samedayCp.length == 0) return false; // No permitimos el submit vacío
    if (samedayCp.length > 5) samedayCp = samedayCp.slice(0, 5);

    ContentLoading();

    $.get('/cart/getSamedayStoresByCP?ajax=1', {
        cp: samedayCp
    }, (tiendaDisponible) => {
        if (!isEmpty(tiendaDisponible)) {
            setCookie('sameday_retail_id', tiendaDisponible.retail_shop_id, 365);
            setCookie('sameday_retail_name', tiendaDisponible.name, 365);
            setCookie('sameday_retail_ship_zone', tiendaDisponible.ship_zone, 365);
            setCookie('isSamedayActive', true, 30); //Activamos sameday by default
        } else {
            setCookie('sameday_retail_id', "", -1);
            setCookie('sameday_retail_name', "", -1);
            setCookie('sameday_retail_ship_zone', "", -1);
            setCookie('isSamedayActive', "", -1);
        }
        setCookie('sameday_cp', samedayCp, 365);
        location.reload();

    }, 'json');

    return false;
}

/* OXP-73: Sameday. Muestra/Oculta input de modificación de C.P en header sameday */
const addSamedayFormEvents = () => {
    let header = document.getElementById('sameday-header');
    if (!!header) {
        let toggle = document.querySelectorAll('.js-sameday-form-toggle');
        let formBtn = document.querySelectorAll('.js-sameday-form-btn');
        let form = document.querySelector('.js-sameday-form');
        let input = document.getElementById('sameday-cp');
        let modifyBtn = document.querySelector('.js-sameday-modify');

        toggle.forEach((btn) => {
            btn.addEventListener('click', (event) => {
                toggleMyClass('hidden', form);
                toggleMyClass('hidden', modifyBtn);
                if (event.target.classList.contains('sameday-modify-cp')) input.focus();
            });
        });

        formBtn.forEach((btn) => {
            btn.addEventListener('click', () => {
                updateSamedayCP(form);
            })
        });

        form.addEventListener('submit', () => {
            updateSamedayCP(form);
        });
    }
}

/* OXP-73: Sameday. Mostrar modal "Entrega hoy disponible" cuando al hacer login el cliente tiene algúna dirección guardada con CP válido. Se aplica dicho CP y se muestra la modal informando */
/* TODO: Hacer modal en monito con template */
const showSamedayAvailableModal = () => {
    if (bodyClassList.contains('sameday-available-popup-active')) {
        const contentSameday = `
            <div style="padding: 30px 20px;text-align: center; margin-bottom: -30px">
                <p style="color:var(--primary);margin-bottom: 6px;font-family: var(--titlef);font-size: 23px;font-weight: 300;">
                    <b>Entrega hoy disponible en tu zona.</b>
                </p>
                <p>Pide ahora y recibe en tu casa en 2 horas.</p>
            </div>`;
        let modal = contentModal(contentSameday);
        modal.show();

        let close = setTimeout(() => {
            modal.hide();
            $('body.sameday-available-popup-active').removeClass('sameday-available-popup-active');
            clearTimeout(close);
        }, 3000);
    }
}

/* OXP-73: Sameday. Mostrar modal informativa al hacer click */
const showSamedayInfoModal = () => {
    let trigger = document.querySelectorAll('.js-sameday-modal-trigger');
    if (!!trigger) {
        trigger.forEach(function (el) {
            el.addEventListener('click', () => {
                if (MOBILE) window.drawerL.close();
                loadContentModal('popup_sameday_info', true, null);
            });
        });
    }
}

/* OXP-73: Sameday. Muestra/Oculta el filtro "Productos con Entrega Hoy" en listados */
const toggleSamedayFilter = () => {
    let samedayFilter = document.getElementById('samedayFilter');
    if (IS_LIST) {
        if (getCookie('sameday_retail_id') && getCookie('sameday_cp')) {
            $('#filter-sameday').show();
        } else {
            $('#filter-sameday').hide();
        }
    }
}


/******* LOCATION NEW POPUP ******/
var locationPopUp = PopUp.extend({
    show: function () {
        setCookie('showLocationChange', 'shown', 365);
        //this.load('/modules/user/printlocationPopup'); // Loaded into DOM. When Varnish use this line so will be executed by AJAX
        this.set('popup-location');
        this._super();
        return this;
    },
});

locationPopUp.instance = null;
locationPopUp.getInstance = function () {
    if (locationPopUp.instance == null)
        locationPopUp.instance = new locationPopUp();
    return locationPopUp.instance;
}

/***** INI AUTOSHIP POPUP *****/
function showAutoShipPopUp() {
    AutoShipPopUp.getInstance().show();
}

var AutoShipPopUp = PopUp.extend({
    init: function () {
        var self = this;
        $.post('/modules/user/loadContentModal', {template: 'modal_autoship_2', question: '', small_text: ''},
            function (result) {
                var div = contentModal(result, false, false, false);
                $(div).find('.data-wrapper').addClass('autoship-info-wrapper');
                if (MOBILE) self.blockBody();

                var swiper = new Swiper($(div).find('.swiper-container'), {
                    pagination: {
                        el: '.swiper-pagination',
                    },
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                });
                self.popup = $(div);
                self.bg = self.popup.find('.popUpBg').unbind('click').bind('click', function () {
                    self.close();
                });
                self.closeB = self.popup.find('.close-button').unbind('click').bind('click', function () {
                    self.close();
                });
            }
        );
    },
    show: function () {
        if (typeof this.popup != 'undefined' && !this.popup.is(':visible')) {
            var self = this;
            document.addEventListener("keydown", PopUp.closeDialogHandler, false);
            this.popup.show();
            if (MOBILE) self.blockBody();
        }
        return this;
    },
    hide: function (speed, fn) {
        if (typeof this.popup == 'undefined') return false;
        var self = this;
        document.removeEventListener("keydown", PopUp.closeDialogHandler, false);
        this.popup.hide();
        if (MOBILE) self.unBlockBody();
    },
    blockBody: function () {
        var offset = $(document).scrollTop();
        $('body').css({'position': 'fixed', 'margin-top': '-' + offset + 'px', 'width': '100%'});
    },
    unBlockBody: function () {
        var offset = parseInt($('body').css('margin-top'));
        $('body').css({'position': 'initial', 'margin-top': 'initial', 'width': 'initial'});
        $(window).scrollTop(-offset);
    }
});

AutoShipPopUp.instance = null;

AutoShipPopUp.getInstance = function () {
    if (AutoShipPopUp.instance === null || AutoShipPopUp.instance === undefined)
        AutoShipPopUp.instance = new AutoShipPopUp();
    return AutoShipPopUp.instance;
}
/***** FIN AUTOSHIP POPUP *****/


/******* SUBSCRIPTION NEW POPUP ******/
var NewSubscriptionPopUp = PopUp.extend({
    show: function () {
        setCookie('stopSubscriptionPopUp', 'shown', 365);
        //this.load('/modules/user/printPopupNewSubscription'); // Loaded into DOM. When Varnish use this line so will be executed by AJAX
        this.set('popup-subscription');
        this._super();
        return this;
    },
});

NewSubscriptionPopUp.instance = null;

NewSubscriptionPopUp.getInstance = function () {
    if (NewSubscriptionPopUp.instance === null || NewSubscriptionPopUp.instance === undefined)
        NewSubscriptionPopUp.instance = new NewSubscriptionPopUp();
    return NewSubscriptionPopUp.instance;
}


/**
 * Countries where WE SHOW the Tax ID field.
 * Show the TAX id number input field.
 * @returns {boolean} const SHOW_TAX_ID_FIELD defined in preLoadScripts() @ GeneralController.php
 * */
function showTaxId() {
    return SHOW_TAX_ID_FIELD ? SHOW_TAX_ID_FIELD : false;
}

/**
 * Countries where IS REQUIRED Tax ID field.
 * @return {boolean} const REQUIRED_TAX_ID_FIELD defined in preLoadScripts() @ GeneralController.php
 */
function isRequiredTaxId() {
    return REQUIRED_TAX_ID_FIELD ? REQUIRED_TAX_ID_FIELD : false;
}

/*
    * Validate Tax ID field by country
    * @param {string} idCountry
    * @param {string} taxId
    * @use TaxIdValidatorService
    * @return {boolean}
 */
function validateTaxId(idCountry, taxId) {
    if (isEmpty(taxId)) {
        return {'error': isRequiredTaxId() ? `<b>${__('tax_id_is_required')}</b> ` : false};
    }
    return new TaxIdValidatorService(idCountry).validate(taxId);
}

function getUrlHash(url = window.location.href) {
    try {
        const parsedUrl = new URL(url);
        return parsedUrl.hash ? parsedUrl.hash.substring(1) : '';
    } catch (e) {
        return '';
    }
}


/**
 * Obtiene los parámetros de la consulta de una URL y los retorna como un objeto.
 * Soporta parámetros simples, anidados (formato a[b]=c), objetos y arrays.
 *
 * @param {string} [queryString=window.location.search] - La cadena de consulta de la URL.
 * @param {boolean} [parseTypes=false] - Indica si se deben convertir cadenas a tipos nativos.
 * @returns {Object} Objeto que representa los parámetros y estructura de la consulta de la URL.
 */
function getQueryParams(queryString = window.location.search, parseTypes = false) {
    const params = new URLSearchParams(queryString);
    const result = {};

    for (const [key, value] of params.entries()) {
        const keys = parseNestedKeys(key);
        const parsedValue = parseTypes ? convertType(value) : value;
        setNestedValue(result, keys, parsedValue);
    }

    return result;
}

/**
 * Parsear una clave con estructura anidada, como 'a[b][c]' en ['a', 'b', 'c']
 * Preserva claves y valores vacíos.
 *
 * @param {string} key - Clave a parsear.
 * @returns {Array<string>} Array de claves anidadas, preservando claves vacíos.
 */
function parseNestedKeys(key) {
    // Dividir la clave usando corchetes como delimitadores
    return key.split(/[\[\]]/);
}

/**
 * Convierte un valor de entrada, generalmente una cadena, a su tipo nativo correspondiente.
 *
 * @param {any} value - Valor a convertir.
 * @returns {any} Valor convertido.
 */
function convertType(value) {
    if (typeof value !== "string") {
        return value;
    }
    if (value === "") {
        return "";
    }

    const cleanValue = (value.startsWith(" ") || value.endsWith(" ")) ? value.trim() : value;
    const typedValues = {
        "null": null,
        "undefined": undefined,
        "true": true,
        "false": false
    };

    if (typedValues.hasOwnProperty(cleanValue)) {
        return typedValues[cleanValue];
    }

    if (cleanValue.length > 1 && cleanValue[0] === '0') {
        return cleanValue; // Devolver como cadena para conservar los ceros iniciales
    }

    const numValue = Number(cleanValue);
    if (Number.isFinite(numValue)) {
        return numValue; // Si es número y finito, devolver como número
    }

    return cleanValue;
}


/**
 * Establece un valor en un objeto anidado dado un array de claves.
 *
 * @param {Object} obj - Objeto donde se establecerá el valor.
 * @param {Array<string>} keys - Array de claves que representan la ruta.
 * @param {any} value - Valor a establecer.
 */
function setNestedValue(obj, keys, value) {
    let current = obj;
    // Iterar sobre cada una de las claves para establecer el valor en el objeto
    for (let i = 0; i < keys.length; i++) {
        const key = keys[i];
        // Si es la última clave, asigna el valor
        if (i === keys.length - 1) {
            // Si la clave ya existe y no es un array, convertir en array para soportar múltiples valores
            if (current[key] !== undefined && current[key] !== null) {
                if (!Array.isArray(current[key])) {
                    current[key] = [current[key]];
                }
                // Añadir el nuevo valor al array existente
                current[key].push(value);
            } else {
                // Si la clave no existe, simplemente asignar el valor
                current[key] = value;
            }
        } else {
            // Manejo de claves vacíos para representar arrays
            if (key === "") {
                // Si el valor actual no es un array, inicializar como un array vacío
                if (!Array.isArray(current)) {
                    current = [];
                }
                // Crear un nuevo objeto en el array si es necesario
                if (current.length === 0 || typeof current[current.length - 1] !== 'object' || Object.keys(current[current.length - 1]).length > 0) {
                    current.push({});
                }
                // Actualizar el contexto actual al último objeto del array
                current = current[current.length - 1];
            } else {
                // Si la clave no existe o no es un objeto, inicializar como un objeto vacío
                if (current[key] === undefined || current[key] === null || typeof current[key] !== 'object') {
                    current[key] = {};
                }
                // Actualizar el contexto actual al objeto anidado correspondiente
                current = current[key];
            }
        }
    }
}



// get only the first capture group from a regex
const getFirstCaptureGroup = (regex, string) => {
    const match = regex.exec(string);
    if (match) {
        return match[1];
    }
    return null;
}

// get query string from url formed by api search
const getQueryFromUrl = (url = window.location.hash) => {
    const regex = /:%22(\w+)%22/gm;
    return getFirstCaptureGroup(regex, url);
}

function canUseApiSearch() {
    return SHOP_ID === "1" && API_SEARCH_COUNTRIES_MIS.includes(parseInt(COUNTRY))
        || SHOP_ID === "10" && API_SEARCH_COUNTRIES_PTN.includes(parseInt(COUNTRY));
}

function handleSearchEngine() {
    canUseApiSearch()
        ? pushApiSearchEventHandler() // Use 'API Search'. Listen search event of api-search to push it to dataLayer
        : initSearchSuggester(); // Use our own Search Suggester for all webs, EXCEPT FOR: Miscota ES and Petness PT
}

// push api search query string to analytics datalayer if events occur
function pushApiSearchEventHandler() {
    const trigger = MOBILE ? 'searchTrigger' : 'searchInput';
    const event = MOBILE ? 'touchstart' : 'focus';
    const $searchInput = document.getElementById(trigger);
    const intervalTime = MOBILE ? 2500 : 1500;
    if (!$searchInput) {
        return false;
    }
    $searchInput.addEventListener(event, () => {
        const urlBase = '';
        const timerHandler = setInterval(() => {
            let urlNew = window.location.hash;
            if (urlNew !== urlBase) {
                let query = getQueryFromUrl(urlNew);
                if (!!query && query.length > 3) {
                    clearInterval(timerHandler);
                    pushDatalayer('eventGA', 'Nav', 'Search', query, 1, 1);
                }
            }
        }, intervalTime);
    });
}

// Custom search suggester & search emgine
function initSearchSuggester() {
    $suggContainer = $('#suggestions');
    $closeSuggest = $('.closeSuggest');
    $wrapperBg = $('.wrapper-search-suggest-bg');
    $searchInput = $('#searchInput');
    var $searchModule = $('#searchModule');
    var $topHeader = $('#topHeader');

    $closeSuggest.click(function () {
        closeSuggester();
        if ($searchModule.length > 0) {
            $searchModule.removeClass('show-results');
            $topHeader.removeClass('search-focussed');
        }
    });

    new Suggester('#searchInput');

    if (MOBILE) {
        $('#searchTrigger').click(function () {
            toogleClasses($('#searchContainer'), 'is-active', 'is-inactive');
            drawerL.close();
            $('#lastSearch').show();
            setTimeout(function () {
                mobileMenuFixBody();
            }, 1000);
        });
        $('.full-container--search .back-button, .full-container--search .full-overlay, .search-link').click(function () {
            toogleClasses($('.full-container--search'), 'is-active', 'is-inactive');
            mobileMenuFixBody();
        });
    }
}

function closeSuggester() {
    $suggContainer = $('#suggestions');
    $wrapperBg = $('.wrapper-search-suggest-bg');
    $searchModule = $('#searchModule');
    $topHeader = $('#topHeader');

    if ($searchModule.length > 0) {
        $searchModule.removeClass('show-results');
        $topHeader.removeClass('search-focussed');
    }
    $suggContainer.removeClass('is-open');
    if (SHOP_ID != 1 && SHOP_ID != 10) {
        $suggContainer.hide();
    }
    $wrapperBg.hide();
}

function submitForm(form) {
    var $searchForm;
    $('#search-form').length > 0 ? $searchForm = $('#search-form') : $searchForm = null;
    var $myForm = (form || $searchForm);

    if ($searchForm != null) $myForm.submit();
}

function Suggester(input) {
    this.init(input);
}

Suggester.prototype = {
    init: function (input) {
        var self = this;
        this.searchTimer = null;
        this.searchXHR = null;
        this.currentTerm = null;
        this.$input = $(input);
        this.$suggContainer = $('#suggestions');
        this.$wrapperBg = $('.wrapper-search-suggest-bg');
        this.$searchModule = $('#searchModule');
        this.$topHeader = $('#topHeader');

        this.$input.bind("paste keyup", function (e) {
            self.printSuggestions(this);
            if (e.keyCode == KeyEvent.DOM_VK_ESCAPE) closeSuggester();
            if (e.keyCode == KeyEvent.DOM_VK_DOWN) self.bindKeyControl(e);

        }).focus(function (e) {
            self.unbindKeyControl(e);
            if (self.$searchModule.length > 0) self.inputFocusControl(e);

        }).click(function () {
            if (self.$searchModule.length > 0) self.$topHeader.addClass('search-focussed');
        });
    },

    printSuggestions: function (input) {
        var term = trim(input.value);
        if (term.length < 3 || term == this.currentTerm) return false;
        this.currentTerm = term;

        var self = this;
        $(input).addClass('loading');

        if (this.searchXHR)
            this.searchXHR.abort(); /* If there is an existing XHR, abort it. */

        clearTimeout(this.searchTimer); /* Clear the timer so we don't end up with duplicates. */

        this.searchTimer = setTimeout(function () { /* assign timer a new timeout */
            self.searchXHR = $.ajax({
                dataType: "html",
                url: '/modules/products/printSearchSuggest',
                data: 'term=' + encodeURIComponent(term),
                success: function (result) {
                    self.$suggContainer.html(result);
                    self.$suggContainer.removeClass('no-results');
                    $(input).removeClass('loading');

                    if (result) {
                        if (self.$searchModule.length > 0) self.$searchModule.addClass('show-results');
                        if ($('#suggHeader').hasClass('no-results')) self.$suggContainer.addClass('no-results');
                        if ($('#suggHeader').hasClass('has-banner')) self.$suggContainer.addClass('has-banner');

                        self.$wrapperBg.show();
                        if (MOBILE) {
                            $('#lastSearch').hide()
                        }

                        self.$suggContainer.addClass('is-open').show();
                        self.$suggContainer.find('a[datalayer]').attr('dl-label', term);
                        initDataLayerClickEvents(self.$suggContainer);
                        pushDatalayer('eventGA', 'Suggest', 'Query', term, 1, 1);

                    } else {
                        self.$wrapperBg.hide();
                        // self.$suggContainer.removeClass('is-open').hide();
                        self.$suggContainer.removeClass('is-open').addClass('no-results');
                        if (SHOP_ID != 1 && SHOP_ID != 10) {
                            self.$suggContainer.hide();
                        }
                        pushDatalayer('eventGA', 'Suggest', 'Query', term, 0, 1);
                    }

                    $suggContainer.on('click', '.view-all-trigger', function () {
                        submitForm();
                        ContentLoading();
                    });
                }
            });
        }, 100); /* 150ms delay, tweak for faster/slower */
    },

    inputFocusControl: function () {
        var self = this;

        self.$input.focus(function () {
            if (self.$searchModule.length != 0) self.$topHeader.addClass('search-focussed');
            if (self.$searchModule.length != 0 && self.$suggContainer.html() != '' && self.$input.val() != '') {
                self.$searchModule.addClass('show-results');
                self.$wrapperBg.show();
            }
        })

        self.$input.blur(function () {
            if ($('#suggestions').hasClass('is-open')) return;
            if (self.$searchModule.length != 0 && !self.$searchModule.hasClass('show-results')) self.$topHeader.removeClass('search-focussed');
        })
    },

    bindKeyControl: function (e) {
        var self = this;
        this.$sugg_ul = this.$suggContainer.find('ul:first');
        this.$sug_selected = this.$sugg_ul.find('.suggest-prod:first').addClass('selected');
        this.$input.blur();
        window.__sugKeyControl = this.keyControl.bind(this);
        addEvent(document, "keydown", window.__sugKeyControl);
        if (e.keyCode == KeyEvent.DOM_VK_ESCAPE) closeSuggester();
    },

    unbindKeyControl: function (e) {
        var self = this;
        if (this.$sug_selected) {
            this.$sug_selected.removeClass('selected');
        }
        this.$sugg_ul = null;
        this.$sug_selected = null;
        if (e.keyCode == KeyEvent.DOM_VK_ESCAPE) closeSuggester();
        removeEvent(document, "keydown", window.__sugKeyControl);
    },

    keyControl: function (e) {
        if (e.keyCode == KeyEvent.DOM_VK_ESCAPE) {
            this.$input.focus();
            //closeSuggester();

        } else if (e.keyCode == KeyEvent.DOM_VK_DOWN) {
            if (this.$sug_selected) {
                var $next = $(this.$sug_selected).nextAll('.suggest-prod').slice(0, 3).last();
                this.$sug_selected.removeClass('selected');
                if ($next.length > 0) {
                    this.$sug_selected = $next.addClass('selected');
                } else {
                    this.$input.focus();
                }
            } else {
                var $next = this.$sug_selected.nextAll('.suggest-prod:first');
                if ($next.length > 0) {
                    this.$sug_selected.removeClass('selected');
                    this.$sug_selected = $next.addClass('selected');
                }
            }
            e.preventDefault();

        } else if (e.keyCode == KeyEvent.DOM_VK_UP) {
            if (this.$sug_selected) {
                var $next = $(this.$sug_selected).prevAll('.suggest-prod').slice(0, 3).last();
                this.$sug_selected.removeClass('selected');
                if ($next.length > 0) {
                    this.$sug_selected = $next.addClass('selected');
                } else {
                    this.$input.focus();
                }
            } else {
                var $next = this.$sug_selected.prevAll('.suggest-prod:first');
                if ($next.length > 0) {
                    this.$sug_selected.removeClass('selected');
                    this.$sug_selected = $next.addClass('selected');
                }
            }
            e.preventDefault();

        } else if (e.keyCode == KeyEvent.DOM_VK_RETURN) {
            if (this.$sug_selected.length > 0) {
                $(this.$sug_selected).find('a').click();
            }
            e.preventDefault();
            ContentLoading();

        } else if (e.keyCode == KeyEvent.DOM_VK_RIGHT) {
            if (this.$sug_selected) {
                var $next = this.$sug_selected.nextAll('.suggest-prod:first');
                if ($next.length > 0) {
                    this.$sug_selected.removeClass('selected');
                    this.$sug_selected = $next.addClass('selected');
                }
            }
            e.preventDefault();

        } else if (e.keyCode == KeyEvent.DOM_VK_LEFT) {
            if (this.$sug_selected) {
                var $next = this.$sug_selected.prevAll('.suggest-prod:first');
                if ($next.length > 0) {
                    this.$sug_selected.removeClass('selected');
                    this.$sug_selected = $next.addClass('selected');
                }
            }
            e.preventDefault();
        }
    }
}


function SliderPagination(list, maxElems) {
    var self = this;

    this.list = $(list);
    this.elements = this.list.children();

    if (this.list.attr('rel') !== undefined) maxElems = parseInt(this.list.attr('rel'));
    this.maxElems = maxElems;

    this.maxPags = Math.ceil(this.elements.length / maxElems);
    this.viewPortW = $(this.elements[0]).outerWidth(true) * maxElems;
    this.list.wrap('<div />');
    this.wrapper = this.list.parent();
    this.wrapper.wrap('<div />');
    this.viewPort = this.wrapper.parent();
    this.viewPort.css({overflow: 'hidden', width: this.viewPortW, 'float': 'left'}).addClass('sliderViewport');
    this.wrapper.css({width: '9999px'}).addClass('sliderWrapper');

    this.curPage = 1;

    this.divPagination = $('<div />').addClass('slidePagination');
    this.nextButton = $('<span />').addClass('arrowRightOn').click(function () {
        self.next();
    });
    this.prevButton = $('<span />').addClass('arrowLeftOn').click(function () {
        self.prev();
    });
    this.divPagination.append(this.nextButton, this.prevButton);
    this.dots = [];
    for (var idx = this.maxPags; idx >= 1; --idx) {
        var dot = $('<span />').addClass('page').addClass('pageOff').attr({rel: idx});
        this.divPagination.append(dot);
        this.dots.push(dot);
    }
    this.divPagination.find('.page').click(function () {
        self.moveTo($(this).attr('rel'));
    });
    this.wrapper.parent().parent().append(this.divPagination);

    //Load all images at start of carrousel
    $(this.elements).find("img").each(function () {
        if ($(this).attr("data-original") !== undefined) {
            $(this).attr("src", $(this).attr("data-original"));
            $(this).removeAttr("data-original");
        }
    });

    this.moveTo(1);
}

SliderPagination.prototype = {
    moveTo: function (pag) {
        pag = parseInt(pag);
        if (pag > this.maxPags) pag = this.maxPags;
        else if (pag < 1) pag = 1;

        var scrollLeft = (pag - 1) * this.viewPortW;

        this.viewPort.stop(true, true).animate({scrollLeft: scrollLeft + 'px'}, 500, 'easeOutCubic');

        $(this.dots[this.maxPags - this.curPage]).removeClass('pageOn').addClass('pageOff');
        $(this.dots[this.maxPags - pag]).removeClass('pageOff').addClass('pageOn');

        if (pag == this.maxPags) this.nextButton.removeClass('arrowRightOn').addClass('arrowRightOff');
        else this.nextButton.addClass('arrowRightOn').removeClass('arrowRightOff');

        if (pag == 1) this.prevButton.removeClass('arrowLeftOn').addClass('arrowLeftOff');
        else this.prevButton.addClass('arrowLeftOn').removeClass('arrowLeftOff');

        this.curPage = pag;
    },
    next: function () {
        if (this.curPage < this.maxPags)
            this.moveTo(this.curPage + 1);
    },
    prev: function () {
        if (this.curPage > 1)
            this.moveTo(this.curPage - 1);
    }
};

function showPasswordInput() {

    var status = $('input[name=pass]').prop('type');
    if (status == 'password') {
        $('input[name=pass]').prop('type', 'text');
    } else {
        $('input[name=pass]').prop('type', 'password');
    }
}


function toyFinderSubmit(form) {
    if (form.age.value == -1 && form.gender.value == -1 && form.price.value == -1) return false;

    var url = "/" + form.toy_url.value;
    var sep = "_";
    if (form.age.value != -1) {
        url += sep + form.age.value;
        sep = "-";
    }
    if (form.gender.value != -1) {
        url += sep + form.gender.value;
        sep = "-";
    }
    if (form.price.value != -1) {
        url += "?" + form.price.value;
    }

    document.location.href = url;
    return false;
}

function showLetter(elem, letter) {
    resetBrandSearch(elem);
    var context = $(elem).closest('.by-brand');
    $(context).find(".brand-list-wrapper").animate({
        scrollTop: ($("#" + letter).parent().scrollTop() + $("#" + letter).offset().top - $("#" + letter).parent().offset().top) - 60
    }, 500);
}

var searchBrandTimeout = null;

function searchBrand(elem) {
    var context = $(elem).closest('.by-brand');
    var search = $(elem).val();
    var letters = $(context).find('.brand-list-wrapper').first();

    if (search == "") {
        $('.brand-list-search', context).find('.icon2-close').hide();
        $('.search-brand-results', context).hide();
        $(letters).show();
        return false;
    }
    $('.brand-list-search', context).find('.icon2-close').show();
    $('.search-brand-results', context).show();
    $(letters).hide();

    var search = removeAccents(search);

    if (searchBrandTimeout) clearTimeout(searchBrandTimeout);

    searchBrandTimeout = setTimeout(function () {
        $('.search-brand-results ul', context).html('');
        $(letters).find('li').each(function (indice, elemento) {
            var regexp = new RegExp(search, "ig");
            var element = removeAccents($(elemento).attr('rel'));
            if (element.match(regexp)) {
                $('.search-brand-results ul', context).append($(elemento).clone(true));
            }
        });
    }, 100);

    return false;
}

function resetBrandSearch(elem) {
    var context = $(elem).closest('.by-brand');
    $('input[name="search-brand"]', context).val('');
    $('.search-brand-results ul', context).html('');
    $(".brand-list-wrapper", context).show();
    $('.search-brand-results', context).hide();
    $('#js-reset-brand-search').hide();
}

/******* FICHA PROMOS NEW POPUP ******/

function FichaPromoPopup(form) {
    var self = this;
    this.tmpls = {};
    this.deferLoading = false;
    this.formulario = form;

    for (var idx = 0; idx < form.elements.length; ++idx) {
        var elem = form.elements[idx];
        var results = /^quan\[([^\]]+)\]$/.exec(elem.name);
        if (results && elem.value > 0) {
            var ref = results[1];
            var quantity = elem.value;
        }
    }

    $('<div class="mobilePopupBoss container-fluid" />').load('/modules/user/printfichaPromoPopup/' + ref, function (response, status, xhr) {
        if (status === "error") {
            return;
        }
        self.popup = $(this).children();
        self.bg = self.popup.find('.fichaPromoPopupBg');
        self.window = self.popup.find('.fichaPromoPopupWindow');
        self.content = self.popup.find('.fichaPromoPopupContent');

        $(document.body).append(this);
        initSwiper(this);
        window.lazyLoadInstance.update();

        $(this).on('click', '.fichaPromoPopupClose, .promoAdd, .fichaPromoPopupBg', function () {
            self.close();
        });

        if (self.deferLoading) self.show();
        var numProduct = document.getElementsByClassName('productPromo').length;
        if (numProduct < 4) {
            $('.arrowRight').hide();
            $('.arrowLeft').hide();
        }
    });
}

FichaPromoPopup.instance = null;

FichaPromoPopup.getInstance = function (form) {
    if (FichaPromoPopup.instance === null || FichaPromoPopup.instance === undefined)
        FichaPromoPopup.instance = new FichaPromoPopup(form);
    return FichaPromoPopup.instance;
}

FichaPromoPopup.prototype = {
    init: function () {

    },
    show: function () {
        if (typeof this.popup == 'undefined') {
            this.deferLoading = true;
        } else {
            addEvent(document, "keydown", FichaPromoPopup.closeDialogHandler);
            this.center().popup.show('normal');
            this.init();
        }
        if (MOBILE)
            $('html, body').animate({scrollTop: 0}, 'slow');
        return this;
    },
    hide: function () {
        var self = this;
        removeEvent(document, "keydown", FichaPromoPopup.closeDialogHandler);
        this.window.fadeOut('normal' || 300, function () {
            self.popup.hide();
            $(this).show();
        });
        return this;
    },
    close: function () {
        this.hide('normal');
    },
    center: function () {
        var lastDisplay = this.popup.css('display');
        var lastVisibil = this.popup.css('visibility');

        this.popup.css({display: 'block', visibility: 'hidden'});
        var w = this.window.width();
        var h = this.window.height();
        this.popup.css({display: lastDisplay, visibility: lastVisibil});
        this.window.css({'margin-top': -(h + 80) / 2 + 'px', 'margin-left': -(w + 80) / 2 + 'px'});
        return this;
    }
}

FichaPromoPopup.closeDialogHandler = function (event) {
    var keyCode = window.event ? window.event.keyCode : event.which;
    if (keyCode == 27) {
        FichaPromoPopup.getInstance().close();
    }
}
/******* END FICHA PROMOS NEW POPUP ******/


/***** USER INFO *****/
UserInfo = {
    get: function (fn) {
        if (LOCAL_STORAGE_ENABLED && !isEmpty(localStorage['userinfo']) && localStorage['userinfo'] != '[]') { // HTML5 localStorage
            if (!USER_LOGGED) {
                this.clear();
                return this.fetch();
            }
            fn(JSON.parse(localStorage['userinfo']));
        } else {
            UserInfo.fetch(fn);
        }
    },
    fetch: function (fn) {
        if (!USER_LOGGED) return false;
        $.get('/user/getLoggedInfo', function (res) {
            if (LOCAL_STORAGE_ENABLED) { // HTML5 localStorage
                try {
                    localStorage['userinfo'] = JSON.stringify(res);
                } catch (e) {
                    console.log('Exception: ' + e.message);
                }
            }
            fn(res);
        }, 'json');
    },
    clear: function () {
        if (LOCAL_STORAGE_ENABLED && !isEmpty(localStorage['userinfo'])) {
            delete localStorage['userinfo']
        }
    }
};
/***** END USER INFO *****/


/***** MOBILE FUNCTIONS *****/
var searchAllBrandsTimer = null;
var searchAllBrandsXHR = null;

function filterBrandsMobile(str) {
    if (str == '') {
        $('#results_brands').hide();
        $('#all-brands-list').show();
    } else {
        if (str.length < 3) return false;
        if (searchAllBrandsXHR) searchAllBrandsXHR.abort(); /* If there is an existing XHR, abort it. */
        clearTimeout(searchAllBrandsTimer);
        searchAllBrandsTimer = setTimeout(function () {
            searchAllBrandsXHR = $.ajax({
                dataType: "html",
                url: '/modules/products/printBrandsResultsMobile',
                data: 'query=' + str,
                success: function (result) {
                    if (result) {
                        $('#all-brands-list').hide();
                        $('#results_brands').html(result).show();
                        initLazyLoad();
                    }
                }
            });
        }, 50);
    }
    return false;
}

function activeRebuyProduct(input) {
    $(input).parent().parent().parent().toggleClass('selected');
}


function removeAccents(inStr) {
    return inStr.replace(/([àáâãäå])|([ç])|([èéêë])|([ìíîï])|([ñ])|([òóôõöø])|([ß])|([ùúûü])|([ÿ])|([æ])/ig, function (str, a, c, e, i, n, o, s, u, y, ae) {
        if (a) return 'a'; else if (c) return 'c'; else if (e) return 'e'; else if (i) return 'i'; else if (n) return 'n'; else if (o) return 'o'; else if (s) return 's'; else if (u) return 'u'; else if (y) return 'y'; else if (ae) return 'ae';
    });
}

/**
 * Called when a product is added or removed to/from the shopping cart,
 * to push event data to dataLayer to feed Google Analytics.
 * @param ref The ref of the product combination
 * @param action The action taken. 'add' or 'remove'
 * @param quantity The number of product items added or removed
 * @param addItemTrigger The block/section that triggered the add_to_cart event/action (list, prod page, upselling...)
 */

function pushAddToCartEventToDataLayer(ref, action, quantity = 1, addItemTrigger) {
    const itemGA4 = {'item_id': ref, 'quantity': quantity} // Google Analytics 4
    const productData = {'id': ref, 'quantity': quantity} // Universal Analytics
    const origin = getProductsOrigin(addItemTrigger);

    // TODO: get price and other data when remove an item from the floating cart (addItemTrigger = 'carrito-flotante').
    // Get data from DOM, as the case origin === 'cart', because we don't have cart datalayer object, and we don't want to do it for performance reasons.

    if (origin === 'product') {
        if (addItemTrigger === 'cross-selling-complementos-ficha' && hasCrossSelling()) { // Product complements (cross-selling) @ prod page
            itemGA4.item_name = __DATA_LAYER_CROSS_SELLING_PRODS.items[ref].item_name;
            itemGA4.item_brand = __DATA_LAYER_CROSS_SELLING_PRODS.items[ref].item_brand;
            itemGA4.price = __DATA_LAYER_CROSS_SELLING_PRODS.items[ref].price;
        }
        if (addItemTrigger === 'producto-ficha') { // Main Combs @ prod page
            // Google Analytics 4
            itemGA4.item_name = `${__DATA_LAYER_PROD.items[ref].item_name} : ${__DATA_LAYER_PROD.prods[ref].variant}`;
            itemGA4.item_brand = __DATA_LAYER_PROD.prods[ref].brand;
            itemGA4.item_variant = __DATA_LAYER_PROD.prods[ref].variant;
            itemGA4.price = __DATA_LAYER_PROD.prods[ref].price;
            itemGA4.item_category = __DATA_LAYER_PROD.items[ref].item_category;
            itemGA4.item_category2 = __DATA_LAYER_PROD.items[ref].item_category2;
            itemGA4.item_category3 = __DATA_LAYER_PROD.items[ref].item_category3;
            // Universal Analytics
            productData.name = __DATA_LAYER_PROD.title;
            productData.brand = __DATA_LAYER_PROD.brand;
            productData.variant = __DATA_LAYER_PROD.prods[ref].variant;
            productData.price = __DATA_LAYER_PROD.prods[ref].price;
            productData.metric1 = __DATA_LAYER_PROD.prods[ref].price * quantity;
            productData.dimension4 = __DATA_LAYER_PROD.prods[ref].dimension4;
            productData.category = __DATA_LAYER_PROD.cats;
        }
        itemGA4.item_list_title = __DATA_LAYER_PROD.item_list_title;
        itemGA4.item_list_id = `${getDataLayerPage('tipo')}-${__DATA_LAYER_PROD.id_product}`;

    } else if (origin === 'list') { // List & Products Carrousels (like Upselling @ prod page, or Recommended prods @ Cart...)
        const COMB = getAddedComb();
        if (COMB) {
            // Google Analytics 4
            itemGA4.item_name = COMB.item_name;
            itemGA4.item_brand = COMB.item_brand;
            itemGA4.item_variant = COMB.variation;
            itemGA4.price = COMB.price;

            if (addItemTrigger === 'upselling-ficha' || addItemTrigger === 'popup-ficha') {
                itemGA4.item_list_title = __DATA_LAYER_PROD.item_list_title;
                itemGA4.item_list_id = `${getDataLayerPage('tipo')}-${__DATA_LAYER_PROD.id_product}`;
            }
            if (addItemTrigger === 'listado-productos'
                || addItemTrigger === 'top-ventas-listado'
                || addItemTrigger === 'monthly-campaign-home'
                || addItemTrigger === 'cross-selling-carrito') {
                itemGA4.item_category = getDataLayerPage('seccion');
                itemGA4.item_category2 = getDataLayerPage('categoria');
                itemGA4.item_category3 = getDataLayerPage('subcategoria');
                itemGA4.item_list_id = getDataLayerPage('tipo') === 'checkout' ? 'cart' : getDataLayerPage('tipo');
            }
            // Universal Analytics
            productData.price = COMB.price;
        }
    } else if (origin === 'cart') { // Cart
        if (addItemTrigger === 'productos-carrito') {
            const quantityInput = document.getElementById(`quantity[${ref}]`);
            const priceInput = document.getElementById(`price[${ref}]`);
            if (quantityInput && priceInput) {
                let price = priceInput.value / quantityInput.value * quantity;
                let roundPrice = price.toFixed(2);
                itemGA4.price = roundPrice > 0 ? roundPrice : -roundPrice;
                itemGA4.item_list_id = 'cart';
            }
        }
    }

    itemGA4.item_list_name = addItemTrigger ? addItemTrigger : "";

    const eventData = {
        'event': action === 'add' ? 'add_to_cart' : 'remove_from_cart',
        'ecommerce': {
            'currencyCode': CURRENCY_ISO,
            'value': action === 'add' ? itemGA4.price * quantity : itemGA4.price, // GA4
        }
    }
    eventData.ecommerce[action] = {
        'items': [itemGA4], // GA4
        'products': [productData],
    }

    window.dataLayer.push(eventData);

    // functions
    function getDataLayerPage(page) {
        if (!window.dataLayer) {
            return false;
        }
        let i = 0;
        while (!window.dataLayer[i].hasOwnProperty('pagina')) {
            i++;
        }
        return window.dataLayer[i].pagina[page];
    }

    function getProductsOrigin(addItemTrigger) {
        if (addItemTrigger === 'productos-carrito') {
            return 'cart';
        }
        const isProductDefined = typeof __DATA_LAYER_PROD !== 'undefined';
        const isCrossSellingDefined = typeof __DATA_LAYER_CROSS_SELLING_PRODS !== 'undefined';
        const hasProductCombInfo = isProductDefined && __DATA_LAYER_PROD.prods && __DATA_LAYER_PROD.prods[ref];
        const hasCrossSellingCombInfo = isCrossSellingDefined && __DATA_LAYER_CROSS_SELLING_PRODS.items && __DATA_LAYER_CROSS_SELLING_PRODS.items[ref];

        if (hasProductCombInfo || hasCrossSellingCombInfo) {
            return 'product';
        } else if (typeof __PRODS !== 'undefined' || typeof __DATA_LAYER_PROMO_POPUP !== 'undefined') {
            return 'list';
        }
        return '';
    }

    function hasCrossSelling() {
        return typeof __DATA_LAYER_CROSS_SELLING_PRODS !== 'undefined' && !!__DATA_LAYER_CROSS_SELLING_PRODS.items;
    }

    function getAddedComb() {
        if (typeof __PRODS === 'undefined' || __PRODS.length === 0) {
            return null;
        }
        const PRODS = __PRODS.filter(prod => !isEmpty(
            prod.filter(comb => comb.ref == ref))
        );
        if (PRODS.length) {
            const PROD = PRODS[0];
            const COMB = PROD.filter(comb => comb.ref == ref)[0];
            if (COMB) {
                return COMB;
            }
        }
        return null;
    }
}


/**
 * Initializes a delegated 'click' event listener on the '.js--products' container
 * to handle product click events and trigger navigation using the link in the [data-url] attribute.
 */
function initDataUrlEvents() {
    const productsContainer = document.querySelector('.js--products');
    if (!productsContainer)  return;

    productsContainer.addEventListener('click', openProductUrl);
}

/**
 * Receives the click event and trigger navigation using the link in the [data-url] attribute.
 * @param {Event} e
 */
function openProductUrl(e){
    if (e.target.tagName === 'A') {
        return;
    }
    const dataUrlEl = e.target.classList.contains('prod__box--action')
        ? e.target.parentNode.querySelector('[data-url]')
        : e.target.closest('[data-url]');

    if (dataUrlEl) {
        const linkEl = dataUrlEl.querySelector('a');
        if (linkEl) {
            e.preventDefault();
            e.stopPropagation();
        }
        const { url, urlTarget } = dataUrlEl.dataset;
        openurl(url, e, urlTarget);
    }
}


/**
 * Initializes the banners dataLayer by extracting promotions and setting up click events.
 */
async function initBannersDatalayer() {
    try {
        const banners = document.querySelectorAll('[dl-banner]');
        if (!banners || !banners.length) return;

        const promotions = await extractPromotions(banners);
        if (!promotions.length) return;

        pushPromoView(promotions);
        setupClickEvent(banners, promotions);
    } catch (error) {
        console.error('Error initializing banners dataLayer:', error);
    }
}

/**
 * Extracts promotion information from the given banners.
 *
 * @param {NodeList} banners - A NodeList of banner elements to extract promotions from.
 * @returns {Array<Object>} An array of promotion objects with relevant attributes.
 */
async function extractPromotions(banners) {
    return Array.from(banners).map(banner => {
        return {
            'bannerElement': banner,
            'href': banner.getAttribute('href'),
            'id': banner.getAttribute('dl-banner'),
            'name': banner.getAttribute('dl-label'),
            'creative': banner.getAttribute('dl-category'),
            'position': banner.getAttribute('dl-value')
        };
    });
}

/**
 * Pushes the promo view information to the dataLayer.
 *
 * @param {Array<Object>} promotions - An array of promotion objects.
 */
function pushPromoView(promotions) {
    try {
        const promotionsData = promotions.map(promo => {
            const promoData = {};
            for (let key in promo) {
                if (key !== 'bannerElement' && key !== 'href') {
                    promoData[key] = promo[key];
                }
            }
            return promoData;
        });
        window.dataLayer.push({
            'ecommerce': {
                'promoView': {
                    'promotions': promotionsData
                }
            }
        });
    } catch (error) {
        console.error('Error pushing promo view to dataLayer:', error);
    }
}

/**
 * Sets up click events for each banner.
 *
 * @param {NodeList} banners - A NodeList of banner elements.
 * @param {Array<Object>} promotions - An array of promotion objects corresponding to the banners.
 */
function setupClickEvent(banners, promotions) {
    banners.forEach((banner, index) => {
        banner.addEventListener('click', (e) => {
            handleBannerClick(promotions[index], e);
        });
    });
}

/**
 * Handles click events for a banner and pushes the event to the dataLayer.
 *
 * @param {Object} promo - The promotion object corresponding to the clicked banner.
 * @param {Event} event - The click event triggered by the user.
 */
function handleBannerClick(promo, event) {
    try {
        const { bannerElement, href, ...promoData } = promo;
        window.dataLayer.push({
            'event': 'promotionClick',
            'ecommerce': { 'promoClick': { 'promotions': [promoData] } },
            'eventCallback': function (containerId) {
                if (href && containerId === GTM_ID) {
                    openurl(href, event);
                }
            },
            'eventTimeout': 1000
        });
    } catch (error) {
        console.error('Error handling banner click:', error);
    }
}


function initDataLayer() {
    $('[datalayer="datalayer"][dl-imp="true"]').each(function () {
        var category = $(this).attr('dl-category');
        var action = 'Impresion';
        var label = $(this).attr('dl-label');
        var event = $(this).attr('dl-event');
        var interaction = $(this).attr('dl-interaction');
        var value = $(this).attr('dl-value');
        if (!event) event = 'eventGA';
        if (!interaction) interaction = 0;
        if (!value) value = 1;
        pushDatalayer(event, category, action, label, value, interaction);
    });
}

function initDataLayerClickEvents(content) {
    $('[datalayer="datalayer"]', content).click(function (e) {
        e.preventDefault();
        var category = $(this).attr('dl-category');
        var action = $(this).attr('dl-action');
        var label = $(this).attr('dl-label');
        var event = $(this).attr('dl-event');
        var interaction = $(this).attr('dl-interaction');
        var value = $(this).attr('dl-value');
        if (!event) event = 'eventGA';
        if (!interaction) interaction = 1;
        if (!value) value = 1;

        var url = false;
        if ($(this).attr('href')) url = $(this).attr('href');

        pushDatalayer(event, category, action, label, value, interaction, url);
    });
}


/* MOBILE FUNCTIONS */

function loadHoverCategoriesMobile() {
    if ($('.nav-categories').data('loading')) return false;
    $('.nav-categories').data('loading', true);
    setTimeout(function () {
        $('.nav-categories .nav-item[data-rel]').each(function () {
            var main_category = $(this).data('rel');
            if (main_category && $('#cat_' + main_category).length == 1) {
                var loading = getLoadingImg('20');
                $('#cat_' + main_category).append(loading);
                $.post('/modules/shop/printCategoryTreeMobile/' + main_category, function (result) {
                    $('#cat_' + main_category).replaceWith(result);
                });
            }
        });
    }, 800);
}

function mobileMenuFixBody() { // TODO: Fix selectors!!!
    const body = document.body;
    const menu = document.querySelector('.full-container--nav');
    const search = document.querySelector('.full-container--search');
    const $filters = document.querySelector('.full-container--filters');
    const menuActive = menu && menu.classList.contains('is-active');
    const searchActive = search && search.classList.contains('is-active');
    const filtersActive = $filters && $filters.classList.contains('is-active');

    if (menuActive || searchActive || filtersActive) {
        if (!body.classList.contains('fixed-scroll')) {
            // Guarda la posición actual de scroll
            const scrollY = window.scrollY;
            body.style.top = `-${scrollY}px`;
            body.classList.add('fixed-scroll');
        }
    } else {
        // Recupera la posición previa del scroll
        const scrollY = Math.abs(parseInt(body.style.top || '0', 10));
        body.classList.remove('fixed-scroll');
        body.style.top = '0';
        window.scrollTo(0, scrollY);
    }
}


let bodyScrollY = null;

function fixBodyScroll(bool) {
    const body = document.body;
    if (bool) {
        bodyScrollY = window.scrollY;
        body.style.position = 'fixed';
        body.style.top = `-${bodyScrollY}px`;
        body.style.width = '100%';
    } else {
        body.style.position = '';
        body.style.top = '';
        body.style.width = '';
        if (bodyScrollY !== null) {
            window.scrollTo(0, bodyScrollY);
            bodyScrollY = null;
        }
    }
}

function toggleBodyScroll() {
    bodyClassList.contains('fixed-scroll')
        ? fixBodyScroll(false)
        : fixBodyScroll(true);
}


function addToCart(button, ref, redirect, event, addItemTrigger = 'listado-productos') {
    redirect = typeof redirect == 'undefined' ? true : redirect;
    var loading = getLoadingImg('24');
    var photo = $(button).parents('.prod__box__inner-wrapper').find('.prod-image').first();
    $(button).empty().append(loading);
    $(button).find('.new-loading-icon').addClass('is-active');

    if (redirect || IS_CART) {
        ShopCart.addItem(ref, 1, undefined, getAddItemTrigger(false, button));
    } else {
        ShopCart.addItem(ref, 1, function () {
            ShopCart.setShowCart(true);
            ShopCart.refreshCartHeader();
            if (!MOBILE) {
                addToCartAnimation(photo, 1.5);
            } else {
                popUpAddtocart();
            }
            $(button).addClass('product-added--button').html('<span class="icon2-check-1 green-check"></span> <span class="button-text">' + __('added_to_cart') + '</span>');
        }, getAddItemTrigger(addItemTrigger, button));
    }
    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
}

/* END MOBILE FUNCTIONS */


/*Expandable-box jQuery plugin*/
//-----------------------------
/*
 * options:
 *  -scroll <data-scroll>:
 *      boolean - True if you want the page to scroll to the top of the box everytime it opents/closes
 *  -scroll_offset <data-scroll_offset>:
 *      number - The offset above the block where the autoscroll moves.
 *  -scroll_timing <data-scroll_timing>:
 *      number - The time that takes to move scroll to the top of the box.
 * */
$.fn.expandableBox = function (options) {
    //Get options
    var options = $.extend({}, $.fn.expandableBox.defaults, options);

    //Default class names
    var opened_class = "is-open";
    var trigger_class = "expandable-box--trigger";

    //We use each to apply plugin to every selected element.
    return this.each(function () {
        var $block = $(this);
        var this_options = $.extend({}, options, $block.data());
        //console.log(this_options);

        //Return if already initialized
        if ($block.data("expandableBoxDone")) return;

        //Attach event to toggle open and close classes
        $block.on("click", "." + trigger_class, function () {
            //Toggle open class
            $block.toggleClass(opened_class);
            //Scroll to top
            if (this_options.scroll) {
                var position = $block.offset().top;
                $("body, html").animate({
                    scrollTop: position - this_options.scroll_offset
                }, this_options.scroll_timing);
            }
        });

        //Add initialization flag
        $block.data("expandableBoxDone", true);
    });
};

$.fn.expandableBox.defaults = {scroll: true, scroll_offset: 160, scroll_timing: 300};

/**
 * Tab Panel
 * Refactor and update to modern javascript. Based on Alex Ruiz jQuery plugin.
 * The last tab selected is saved in localStorage.
 *
 * @param panelSelector string | DOM element
 * @attribute data-toggle="tab-panel" | The selector to auto-initialize the plugin.
 * @attribute data-panel-name="the_name_of_the_panel" | The name of the panel to save the last tab selected.
 * @attribute data-save-tab="[true|false]" | If true, the last tab selected is saved in localStorage.
 * @use new TabPanel() | new TabPanel([data-toggle="tab-panel"|custom_selector]).
 * @example
 *    <element data-toggle="tab-panel" data-panel-name="the_name_of_the_panel" data-save-tab="true">
 *        <element class="js-tab-panel--tabs">
 *            <element class="js-tab-button" data-tab="the_tab_id_1">
 *            <element class="js-tab-button" data-tab="the_tab_id_2">
 *         ...
 *        <element>
 *            <tab_element class="js-tab-content" id="the_tab_id_1">
 *            <tab_element class="js-tab-content" id="the_tab_id_2">
 *        ...
 * Add data-toggle="tab-panel" in the parent html element for auto-initialization,
 * or add a custom selector and pass it to the constructor in the class instantiation using `new TabPanel()`.
 */
class TabPanel {
    constructor(panelSelector = '[data-toggle=tab-panel]') {
        this.panel = document.querySelector(panelSelector);
        if (!this.panel) {
            return;
        }
        this.saveLastTab = this.panel.dataset.saveTab === 'true';
        this.selectedTabKey = `selTab--${this.panel.dataset.panelName}`;
        this.lastTabId = this.saveLastTab ? localStorage.getItem(this.selectedTabKey) : null;
        this.tabButtons = Array.from(this.panel.querySelectorAll('.js-tab-button'));
        this.tabContents = Array.from(this.panel.querySelectorAll('.js-tab-content'));
        this.init();
    }

    init() {
        this.panel.addEventListener('click', ev => this.handleClick(ev));
        const initialTab = this.lastTabId
            ? this.tabButtons.find(button => button.dataset.tab === this.lastTabId)
            : this.tabButtons[0];
        initialTab.click();
    }

    handleClick(ev) {
        let clickedTab = ev.target;
        if (!clickedTab.matches('.js-tab-button')) {
            return;
        }
        const clickedTabId = clickedTab.dataset.tab;
        this.tabButtons.forEach(el => el.classList.remove('selected'));
        this.tabContents.forEach(el => (el.style.display = 'none'));
        document.getElementById(clickedTabId).style.display = 'block';
        clickedTab.classList.add('selected');

        if (this.saveLastTab) {
            localStorage.setItem(this.selectedTabKey, clickedTabId);
        }
    }
}

function CountDown(t) {
    const i = document.getElementById(t).getAttribute("deadline");
    this.deadline = "Date" == typeof i ? i : new Date(1e3 * i), this.counterD = document.getElementById(t + "D"), this.counterH = document.getElementById(t + "H"), this.counterM = document.getElementById(t + "M"), this.counterS = document.getElementById(t + "S"), this.sizeD = this.counterD ? this.counterD.innerHTML.length : 1, this.sizeH = this.counterH ? this.counterH.innerHTML.length : 1, this.sizeM = this.counterM ? this.counterM.innerHTML.length : 1, this.sizeS = this.counterS ? this.counterS.innerHTML.length : 1, this.ratio = 1, this.counterS || (this.ratio *= 60), this.counterM || (this.ratio *= 60), this.counterH || (this.ratio *= 24), this.restart()
}

CountDown.prototype = {
    display: function (t) {
        var i = t % 60;
        t = Math.floor(t / 60);
        var e = t % 60;
        t = Math.floor(t / 60);
        var n = t % 24;
        t = Math.floor(t / 24);
        var s = t;
        this.counterS ? this.counterS.innerHTML = i.toFixedNumbers(this.sizeS) : i > 0 && ++e, this.counterM ? this.counterM.innerHTML = e.toFixedNumbers(this.sizeM) : e > 0 && ++n, this.counterH ? this.counterH.innerHTML = n.toFixedNumbers(this.sizeH) : n > 0 && ++s, this.counterD && (this.counterD.innerHTML = s)
    }, countBack: function (t) {
        var i = this;
        this.remaining > 0 ? (this.timer = setTimeout(function () {
            i.countBack(i.ratio)
        }, 1e3 * t), this.display(this.remaining), this.remaining -= t, "function" == typeof this.onchange && this.onchange()) : "function" == typeof this.finish && this.finish()
    }, stop: function () {
        this.timer && clearTimeout(this.timer)
    }, restart: function () {
        this.stop(), this.remaining = Math.floor((this.deadline.valueOf() - (new Date).valueOf()) / 1e3), this.countBack(this.remaining % this.ratio)
    }
};

function initCountDown() {
    document.querySelectorAll('[countdown]').forEach(function (element) {
        new CountDown(element.id);
    });
}


function showAutoShipPopUpMini() {
    var question = SHOP_ID == 1 || SHOP_ID == 10 ? __('whats_autoship') : __('whats_autoship_ani');
    var smallText = SHOP_ID == 1 || SHOP_ID == 10 ? __('landing_autoship_title') : __('autoship_concept_ani');

    $.post('/modules/user/loadContentModal',
        {template: 'popup_autoship_info_mini', question: question, small_text: smallText},
        function (result) {
            contentModal(result);
            $('.data-wrapper').addClass('no-buttons autoship-info-mini');
        }
    );
}


/**
 * Generic function to show content modal popup passing template as argument, and other args
 * @param template string        The html template of the content of modal
 * @param bigModal bool          Set modal as 'big-modal' by adding the class 'big-modal' to modal .data-wrapper
 * @param bodyClass string       Add a class (custom or template_name) to the $('body') for styling purposes
 * @param overflowVisible bool   Set modal overflow by adding the class 'oVisible' or 'oHidden' to modal .data-wrapper
 * @param extraData object       Extra data to pass to the template
 * @param callback function      Extra callback function
 */
function loadContentModal(
    template, bigModal = false, bodyClass = '',
    overflowVisible = true, extraData = {}, callback = null
) {
    if (!template) {
        return false;
    }
    bigModal = bigModal ? 'big-modal' : '';
    bodyClass = bodyClass || template;
    overflowVisible = overflowVisible ? 'oVisible' : 'oHidden';

    $.post('/modules/user/loadContentModal',
        {
            'template': template,
            'extra_data': extraData
        },
        function (result) {
            contentModal(result, false, bodyClass);
            $('.data-wrapper').addClass(template + ' ' + bigModal + ' ' + overflowVisible + ' no-buttons ');

            if (typeof callback === 'function') {
                callback();
            }
        }
    )
    return true;
}


/**
 * Adeslas landing: Pet insurance form
 *
 * @param formName String    The name attr of the form
 * @param url String         The url to post the form
 *
 * @template landing-pet-insurance.html
 */
class PetInsuranceForm {
    constructor(formName, url) {
        this.formName = formName;
        this.url = url;
        this.formData = null;
        this.selectShopInput = null;
        this.modal = null;
        this.validForm = false;
        this.init();
    }

    init() {
        this.form = document.forms[this.formName];
        if (!this.form) {
            return;
        }
        this.selectShopInput = this.form.origin_shop_id;
        this.initFormData();
        this.initEvents();
    }

    initFormData() {
        this.formData = new FormData(this.form);
        this.formData.append('Nombre tienda origen', '');
    }

    initEvents() {
        this.handleClick();
        this.handleChange();
        this.handleReset();
    }

    handleClick() {
        this.form.submit_button.addEventListener('click', async (e) => {
            e.preventDefault();
            this.validForm = await this.validateForm();
            if (!this.validForm) {
                return;
            }
            await this.updateFormData();
            const submitResult = await this.submitForm();
            await this.showModal(submitResult, 4000);
            if (submitResult && submitResult.status) {
                this.form.reset();
            }
        });
    }

    handleChange() {
        this.form.addEventListener('change', async (e) => {
            const trigger = e.target.id;
            if (trigger === 'origin_shop_id') {
                const bool = this.form[trigger].selectedIndex !== 0;
                setFieldAttributes(this.form, {
                    id: 'employee_id',
                    visibility: bool,
                    required: false,
                    wrapper: '.form--field',
                });
            }

            if (!this.validForm) {
                await this.validateForm();
            }
        });
    }

    handleReset() {
        this.form.addEventListener('reset', async (e) => {
            cleanErrorMessage()
        });
    }

    async validateForm() {
        try {
            this.validForm = await asyncValidateForm(this.form);
            return true;
        } catch (error) {
            return false;
        }
    }

    async updateFormData() {
        return new Promise(resolve => {
            this.formData = new FormData(this.form);
            this.formData.set(
                'Nombre tienda origen',
                this.selectShopInput.selectedOptions[0].text.toLowerCase()
            );
            resolve(true);
        });
    }

    async submitForm() {
        try {
            const result = await asyncSubmitForm(this.formData, this.url);
            if (result.status !== 'success') {
                throw new Error('Status ' + result.status);
            }
            return {
                'status': true,
                'pet': this.formData.get('Mascota')
            };
        } catch (error) {
            console.info('Error: ', error.message);
            return false;
        }
    }

    async showModal(submitResult, removeTimeout = 0) {
        const modalData = await this.getModalData(submitResult);
        this.modal = contentModal(modalData);
        if (removeTimeout) {
            this.removeModal(removeTimeout);
        }
    }

    async getModalData({status, pet}) {
        return new Promise(resolve => {
            const index = status ? 1 : 0;
            const petUser = {
                'icon': pet === 'perro' ? '🐶' : '😺',
                'thanks': pet === 'perro' ? '¡Guau guau!' : '¡Miaaaau!'
            };
            const modalMessage = [
                `<svg class="checkmark ko" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle class="checkmark-circle" cx="25" cy="25" r="25" fill="none"/><line class="checkmark-cross stroke" x1="16" y1="34" x2="34" y2="16"/><line class="checkmark-cross stroke" x1="16" y1="16" x2="34" y2="34"/></svg>
                <p class="mt5 ml20 mr20 lh1-6"><b>Ups... Parece que algo ha fallado 🙊🙏</b> <br><em>Vuelve a intentarlo en unos instantes</em></p>`,

                `<svg class="checkmark ok" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><circle class="checkmark-circle" cx="25" cy="25" r="25" fill="none"/><path class="checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg>
                <p class="mt5 ml20 mr20 lh1-6"><b>${petUser.thanks} Formulario recibido ${petUser.icon} 👍</b> <br><em>En breve nos pondremos en contacto contigo</em></p>`
            ];
            const data = document.createElement('div');
            data.classList.add('flex-row', 'justify-fs');
            data.style.margin = '20px 0 -10px';
            data.style.paddingLeft = '20px';
            data.innerHTML = modalMessage[index];
            resolve(data);
        });
    }

    removeModal(timeout) {
        return setTimeout(() => {
            this.modal.remove();
        }, timeout);
    }
}


/**
 * Asynchronous function to submit a form using fetch and async/await
 *
 * @param formData FormData      The form data object to submit
 * @param url String             The url to post the form
 * @returns {Promise<any>}
 */
async function asyncSubmitForm(formData, url) {
    try {
        const response = await fetch(url, {
            method: 'POST',
            body: formData
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return await response.json();
    } catch (error) {
        throw error;
    }
}

async function asyncValidateForm(form) {
    return new Promise(async (resolve, reject) => {
        try {
            cleanErrorMessage();
            await checkRequiredFields(form);
            resolve(true);
        } catch (errorMessage) {
            await printErrorMessage(errorMessage, form);
            reject(false);
        }
    });
}

async function checkRequiredFields(form) {
    return new Promise((resolve, reject) => {
        const validTypes = ['text', 'email', 'tel', 'number', 'password', 'select-one', 'checkbox', 'radio', 'date'];
        let allFieldsAreFilled = true;
        let errorMessage = "";
        for (const field of form.elements) {
            if (validTypes.includes(field.type) && field.required && !field.value) {
                errorMessage += `El campo "${field.name}" es requerido.<br>`;
                allFieldsAreFilled = false;
            }
        }
        if (!allFieldsAreFilled) {
            reject(errorMessage);
        }
        resolve(true);
    });
}

async function printErrorMessage(message, targetEl, errorCssClass = 'js-error-message') {
    return new Promise(resolve => {
        const errorContainer = document.createElement('div');
        errorContainer.classList.add(errorCssClass, 'newsletter-error', 'mt20');
        errorContainer.innerHTML = message;
        targetEl.insertAdjacentElement('afterend', errorContainer);
        resolve();
    });
}

function cleanErrorMessage(errorCssClass = 'js-error-message') {
    const errorContainer = document.querySelector(`.${errorCssClass}`);
    if (errorContainer) {
        errorContainer.remove();
    }
}

function setFieldAttributes(form, attributes) {
    const {id, visibility, required, wrapper} = attributes;
    const el = form[id];
    const container = el.closest(wrapper) || el;

    container.style.display = visibility ? 'flex' : 'none';
    el.required = required;
    el.focus();
}


function getStockBarData() {
    var dateStart = new Date(startYear, startMonth - 1, startDay);
    var dateEnd = new Date(endYear, endMonth - 1, endDay);
    var today = new Date();
    //today = new Date(2021, 06, 10); // <-- COMMENT this line. Use only for test !!!!!  ---> January = 0 !

    var data = {
        campDuration: ((dateEnd.getTime() - dateStart.getTime()) / 86400000) + 1, // duration in days :: (1000*60*60*24 = 86400000)
        campActualDay: ((today.getTime() - dateStart.getTime()) / 86400000) + 1, // actual day
        pi2: (Math.pow(Math.PI, 2)).toFixed(4), // PI elevated to 2. Result with 4 decimals
        maxWidth: 94, // DON'T INCREASE FROM 94! The max. average desired initial width for the stockBar in percentage (ex.: 94%)
        iniMinWidth: 64, // The average initial min width for the first day of campaign
        minWidth: 4 // DON'T REDUCE FROM 4! The minimum average desired final width for the stockBar in percentage at the end of the campaign. (ex.: 4%)
    }
    data['dateStart'] = dateStart;
    data['dateEnd'] = dateEnd;
    data['today'] = today;

    return data;
}


/* Show New Miscota modal only one time */
/*const showNewMiscotaModal = function () {
    if (getCookie('new_miscota_modal') != 'shown' && !document.body.classList.contains('app')) {
        loadContentModal('popup_new_miscota', true);
        setCookie('new_miscota_modal', 'shown', 365);
    }
}*/


/* --------------------------------------------- */
/* ------------- ### Autoship ### -------------- */

AutoShip = {
    insertAutoshipItem: function (id_autoshipping, ref, quantity, replace_qty) {
        quantity = quantity || 1;
        replace_qty = replace_qty ? true : false;
        return $.post('/order_autoship_form/addEanAsItem', {
            id_autoshipping: id_autoshipping,
            ref: ref,
            qty: quantity,
            replace_qty: replace_qty ? 1 : 0
        });
    }
};

function closeAddToAutoshippingBox() {
    $(".autoship-list--wrapper").removeClass("is-open");
}

$(function () {
    $(".prod__box").on('mouseleave', function () {
        closeAddToAutoshippingBox();
    });
});


/**
 * Adds a new item to autoshipping.
 * path '/order_autoship_form/prdStatusAutoship'
 * belongs to 'autoship/form.php'
 * @param {*} id_autoshipping *Required
 * @param {*} id_product *Required
 * @param {*} ref *Required
 * @param {*} qty *Required
 */
function openAddItemToAutoshippingBox(id_product, ref, event) {
    event.preventDefault();
    $('.autoship-list--wrapper').removeClass('is-open');
    var this_autoship_list_wrapper = $(event.currentTarget).next('.autoship-list--wrapper');
    var autoship_list_ul = $(this_autoship_list_wrapper).find("ul");

    // Start a promise to time processes
    $.post('/user/getLoggedAutoships',
        {},
        function (active_autoshippings) {
            var data = JSON.parse(active_autoshippings);

            // Get ul container, and clear it out (to prevent stack)
            autoship_list_ul.html("");

            // Iterate through the items and add them to ul.
            $(data).each(function (index, active_autoship) {
                var idAuto = active_autoship['id_autoshipping'];
                var numProds = active_autoship["num_products"];
                var indexPlus = (index + 1);
                var li = document.createElement("li");
                var autoshipOrderTag = SHOP_ID == 9 || SHOP_ID == 12 ? __('autoship_order_ani') : __('autoship_order')
                li.setAttribute("idAutoship", idAuto);
                li.setAttribute('onclick', 'addItemToAutoshipping(' + idAuto + ', ' + indexPlus + ', ' + id_product + ', "' + ref + '", event)');
                li.innerHTML = "<p class='autoship-item--name'> " + autoshipOrderTag + " #" + indexPlus + "</p>" +
                    "<p class='autoship-item--data'><span>" + numProds + " " + __('products') + " </span> | <span> " + __('every') + " " + active_autoship["frequency"] + " " + __('weeks') + "</span></p>";

                $(autoship_list_ul).append(li);
            });

            setTimeout(function () {
                this_autoship_list_wrapper.addClass("is-open");
            }, 900);

            var closeOnScroll = function (e) {
                window.requestAnimationFrame(function () {
                    closeAddToAutoshippingBox();
                    window.removeEventListener('scroll', closeOnScroll, false);
                });
            }
            window.addEventListener('scroll', closeOnScroll, false);
        }
    );
}

/**
 *
 * @param {*} data_to_add
 */
function addItemToAutoshipping(id_autoshipping, numAS, id_product, ref, event) {
    ref = $(".variation-selector .variation-selected").attr("rel") ? $(".variation-selector .variation-selected").attr("rel") : ref;
    var qty = parseInt($('#product-quantity-mp').val()) ? parseInt($('#product-quantity-mp').val()) : 1;

    var product_variation = $(".variation-selected .variation-name").text();
    var productTitleSel;
    (!MOBILE) ? productTitleSel = '.prod__box--prod-name--title a' : productTitleSel = '.prod__box--prod-name--mobile_title';
    var prod_name_list_prods = $(event.currentTarget).parent().parent().parent().parent().find(productTitleSel).text();
    var product_name = prod_name_list_prods ? prod_name_list_prods : $(".product-name").text() + " " + product_variation;

    var spt = {
        as: numAS,
        name: __('product') + ": " + product_name,
        qty: __('quantity') + ": " + (parseInt($('#product-quantity-mp').val()) ? parseInt($('#product-quantity-mp').val()) : 1),
    };

    var itemAddedTag = (SHOP_ID == 9 || SHOP_ID == 12) ? __('item_added_to_autoship_ani') : __('item_added_to_autoship');

    AutoShip.insertAutoshipItem(id_autoshipping, ref, qty).then(function (result) {
        closeAddToAutoshippingBox();
        $.post('/modules/user/loadContentModal',
            {template: 'user_added_autoship', question: itemAddedTag, small_text: spt},
            function (result) {
                contentModal(result);
                $('.data-wrapper').addClass('modal-goto-autoship');
            }
        );
    });
}


function selectSendAutoshipNow() {
    var tag1; //Autoship TAGS per Shop
    switch (SHOP_ID) {
        case '9':
            tag1 = __('autoship_send-now_title_ani');
            tag2 = __('autoship_send_now_ani');
            break;

        default:  // default --> Miscota, Petness...
            tag1 = __('autoship_send-now_title');
            tag2 = __('autoship_send_now');
    }

    $.post('/modules/user/loadContentModal',
        {
            template: 'user_confirm--autoshipNow',
            question: tag1,
            small_text: __('autoship_send-now_subtitle'),
            confirm_tag: tag2
        },
        function (result) {
            contentModal(result);
            $('.data-wrapper').addClass('user big-modal autoship--send-now');

            $('#confirm-action').click(function () {
                var modalBox = $(".popUpContainer-data .autoship--send-now");
                var selected_autoships = [];

                modalBox.find(".autoship.is-selected").each(function (i, element) {
                    selected_autoships.push({
                        id_autoshipping: element.getAttribute("id_autoshipping")
                    });
                });

                sendNowMulti(selected_autoships);

                $('#cancel-action').click();


            });
            loadAutoShipList();
        }
    );
}


/**
 * Used to send now multiple autoshippings.
 *
 * @param {*} array_idAutoshippings
 */
function sendNowMulti(array_idAutoshippings) {
    switch (SHOP_ID) {
        case '9':
            tag1 = __('ask_send_autoship_ani');
            break;

        default:  // default --> Miscota, Petness...
            tag1 = __('ask_send_autoship');
    }

    $.post('/modules/user/loadContentModal',
        {template: 'user_confirm', question: tag1, small_text: __('ask_send_autoship_text')},
        function (result) {
            contentModal(result);

            $('#confirm-action').click(function () {
                var loadingDiv = ContentLoading();
                $.post('/order_autoship_form/sendNowAutoshippings',
                    {idAutoshipping: array_idAutoshippings},
                    function (result) {
                        $('#cancel-action').click();
                        if (!result) {
                            document.location.reload();
                            return;
                        }
                        // MIS-3934 : Creo que siempre llega un array, pero por si acaso retorno lo que haya si [0] no existe
                        const resultValue = result[0] ? result[0] : result;
                        if (resultValue.result.error) {
                            contentLoadingKO(loadingDiv, resultValue.result.error);
                            return false;
                        }
                        contentLoadingOK(loadingDiv, __('changes_saved'));
                    }, 'json');
            });
        }
    );

}

/**
 * Basically loads the structure and functionalities of send now modal selector.
 */
function loadAutoShipList() {
    var this_autoship_list_wrapper = $('.modal-extended-content');
    var autoship_list_ul = $(this_autoship_list_wrapper).find("ul");
    var modalBox = $(".popUpContainer-data .autoship--send-now");
    var sendNowBtn = modalBox.find(".modal-actions #confirm-action");
    var loadingDiv = ContentLoading(autoship_list_ul);
    var tag1; //Autoship TAGS per Shop
    switch (SHOP_ID) {
        case '9':
            tag1 = __('autoship_order_ani');
            break;
        default:
            tag1 = __('autoship_order'); // default --> Miscota, Petness...
    }


    // Start a promise to time processes
    $.post('/user/getLoggedAutoships',
        {wp: true},
        function (active_autoshippings_with_items) {

            $(loadingDiv).remove();
            // Get ul container, and clear it out (to prevent stack)
            autoship_list_ul.html("");

            // Iterate through the items and add them to ul.
            $(JSON.parse(active_autoshippings_with_items)).each(function (index, active_autoship) {
                var idAuto = active_autoship['id_autoshipping'];
                var items = active_autoship.items;
                var indexPlus = (index + 1);
                var articles = "";
                var li = document.createElement("li");

                /* Set attributes of new LI  */
                li.setAttribute("idAutoship", idAuto);
                li.classList.add("user-box");
                li.classList.add("order");
                li.classList.add("autoship");
                li.classList.add("active");
                li.setAttribute('id_autoshipping', idAuto);
                li.setAttribute('key', indexPlus);
                if (index != 0) li.classList.add("is-closed");

                /*li.setAttribute('onClick', `addItemToAutoshipping(${idAuto}, ${indexPlus}, ${id_product}, '${ref}', event)`);*/

                /* Build up the article structure loop */
                $(items).each(function (i, item) {
                    articles += "<article class='order--single-item " + item.url_cat + "' datacat='" + item.url_cat + "'>" +
                        "<div class='image-wrapper'><img src='" + item.thumb + "' title='" + item.title + "' alt='" + item.title + "'></div>" +
                        "<div class='product-quantity'>" +
                        "<div class='input-wrapper'>" +
                        "<input type='number' id='autoship-item-qty' class='noarrows' name='frequency' value='" + item.quantity + "' min='1' max='99' step='1' pattern='[0-9]'>" +
                        "</div>" +
                        "</div>" +
                        "<a title='" + item.title + "'><span class='product-name'>" + item.title + "</span> <span class='product-variation'>" + item.title_ext + "</span></a>" +
                        "<span class='order-item--price'>" + item.price + "</span>" +
                        "</article>";
                });

                /* build up the whole container and its articles */
                li.innerHTML = "<div class='user-box--header'>" +
                    "<div class='header-trigger' idao_ref=''>" +
                    "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 64 64'><path data-name='layer1' fill='none' stroke='#202020' stroke-miterlimit='10' stroke-width='2' d='M20 26l11.994 14L44 26'></path></svg>" +
                    "</div>" +
                    "<div class='header-main'>" +
                    "<div class='order-state'>" +
                    "<span class='selected-icon icon2-check-1'></span>" +
                    "<div class='order-data'>" +
                    "<span class='data-title autoship--order'>" + tag1 + "<span class='text-light'> #" + indexPlus + "</span></span>" +
                    "<p class='data-value'><span class='autoship-number-items'>" + items.length + " " + __('products') + "</span></p>" +
                    "</div>" +
                    "</div>" +
                    "<div class='order-resume'>" +
                    "<div class='order-data frequency'>" +
                    "<span class='data-title'>" + __('frequency') + "</span>" +
                    "<p class='data-value'>" + active_autoship.frequency + "</p>" +
                    "</div>" +
                    "<div class='order-data total-amount'>" +
                    "<span class='data-title'>" + __('total_estimated') + "</span>" +
                    "<p class='data-value'>" + active_autoship.total_price + "</p>" +
                    "</div>" +
                    "<div class='order-data address'>" +
                    "<span class='data-title'>" + __('shipping_address') + "</span>" +
                    "<p class='data-value mb8'>" +
                    "<span id='address_address_1'>" + active_autoship.address_addr + "</span>" +
                    "<span id='address_cp_city_1'>" + active_autoship.address_cp + " " + active_autoship.address_city + "</span>" +
                    "</p> </div></div></div> </div>" +
                    "<div class='user-box--content'>" +
                    "<div class='order--items'>" +
                    articles +
                    "</div>" +
                    "</div>";

                /* Add evvent linked to this specific LI element only by usage of let. */
                $(li).click(function (event) {
                    /* IF TRIGGER IS THE OPEN AND CLOSE BTN DO NOTHING */
                    if (event.target == $(li).find(".header-trigger")) return false;
                    /* only 1 active at time, as asked by bj */
                    modalBox.find(".autoship.is-selected").removeClass("is-selected");
                    /* CHECK OR UNCHECK */
                    if ($(li).hasClass("is-selected")) {
                        $(li).removeClass("is-selected");
                    } else {
                        $(li).addClass("is-selected");
                    }
                    /* IF THERE IS ANY SELECTED ITEM, UNLOCK SEND NOW BTN */
                    if (modalBox.find(".autoship.is-selected").length >= 1) {
                        sendNowBtn.removeClass("disabled");
                    } else {
                        sendNowBtn.addClass("disabled");
                    }
                });

                /* similar as the previous use case, on click the btn to open, add/remove class */
                $(li).find(".header-trigger").click(function () {
                    if ($(li).hasClass("is-closed")) {
                        $(li).removeClass("is-closed");
                    } else {
                        $(li).addClass("is-closed");
                    }

                });

                $(autoship_list_ul).append(li);

            });
        });
}

/* ------------- ### END Autoship ### -------------- */
/* ------------------------------------------------- */


/*function blockAffiliates() {
    const blockedUtms = ['abastsocial', 'belboon', 'bracco', 'cliccaprezzi', 'clickpoint', 'criteo', 'fact-finder', 'ilpiubasso', 'vienscomparer', 'achetezfacile', 'acheter-moins-cher', 'become', 'bestshopping', 'cherchons', 'ciao', 'clicca-prezzi', 'comparadordepreciosonline', 'daisycon-affiliation', 'dooyoo', 'FBBoosketProds', 'geizhals', 'idl', 'infobuy', 'kelkoo', 'kuantokusta', 'leguide', 'nextag', 'otiendas', 'precos', 'preis', 'preisvergleich', 'pricerunner', 'prijsvergelijk', 'rockbottom', 'shopalike', 'shopall', 'shopmania', 'shoppydoo', 'sociomantic', 'touslesprix', 'trovaprezzi', 'trovaprezzo', 'trovit', 'twenga', 'xucunet', 'cart_recovery', 'MGM', 'Recompra', 'Cupon', 'Purgatorio', 'Recordatorio_Transf', 'Opinion', 'Pedido_envio', 'Stock'];
    if (window.location.hash) {
        let hash = window.location.hash.substring(1);
        if (blockedUtms.some(utm => hash.match(`${utm}.*`))) {
            setCookie('BlockAffPixel', '1', null);
        }
    }
}*/

function initHyDrawer() {
    const HyDrawer = hyDrawer.HyDrawer;
    const ua = navigator.userAgent.toLowerCase();
    const isSafari = ua.indexOf('safari') > 0 && ua.indexOf('chrome') < 0;
    const isMobileSafari = isSafari && ua.indexOf('mobile') > 0;

    window.drawerL = new HyDrawer(window.drawerLeft, {
        range: isMobileSafari ? [30, 45] : [0, 40],
        threshold: isSafari ? 0 : 10,
        preventDefault: true,
        mouseEvents: true,
        align: 'left',
    });

    window.drawerR = new HyDrawer(window.drawerRight, {
        range: isMobileSafari ? [30, 45] : [0, 40],
        threshold: isSafari ? 0 : 10,
        preventDefault: true,
        mouseEvents: false,
        align: 'right',
        persistent: true,
    });

    window.drawerL.showNav = function (e) {
        e.preventDefault();
        window.drawerL["persistent"] = false;
        window.drawerR["opened"] = false;
        if (USER_LOGGED) {
            window.drawerU["opened"] = false;
        }
        window.drawerL.toggle();
    }

    window.drawerR.showCart = function (e) {
        e.preventDefault();
        window.drawerL["opened"] = false;
        if (USER_LOGGED) {
            window.drawerU["opened"] = false;
        }
        window.drawerR.toggle();
        window.drawerL["persistent"] = true;
    }

    window.navTrigger.addEventListener('click', e => {
        window.drawerL.showNav(e);
    });
    window.cartTrigger.addEventListener('click', e => {
        window.drawerR.showCart(e)
    });

    document.querySelector('.custom--hy-drawer-scrim_right').addEventListener('touchstart', e => {
        window.drawerR.close();
        if (USER_LOGGED) {
            window.drawerU.close();
        }
        window.drawerL["persistent"] = false;
        fixBodyScroll(false);
    });

    window.drawerLeft.addEventListener('hy-drawer-prepare', e => {
        window.drawerR["opened"] = false;
        if (USER_LOGGED) {
            window.drawerU["opened"] = false;
        }
    });

    /* Check if panel drawer LEFT is open or closed when a transition end (and the panel state has changed) */
    window.drawerLeft.addEventListener('hy-drawer-transitioned', e => {
        /* console.log('drawerLEFT trans to', e.detail); */
        if (window.drawerL['opened'] == true && (window.drawerR['opened'] == false || window.drawerU['opened'] == false)) {
            $('body').addClass('nav-is-open');
            fixBodyScroll(true);
        } else {
            fixBodyScroll(false);
            $('body').removeClass('nav-is-open');
        }
    });

    /* Check if panel drawer RIGHT is open or closed when a transition end (and the panel state has changed) */
    window.drawerRight.addEventListener('hy-drawer-transitioned', e => {
        /* console.log('drawerR trans to', e.detail); */
        if (window.drawerR['opened'] == true && (window.drawerL['opened'] == false || window.drawerU['opened'] == false)) {
            $('body').addClass('cart-is-open');
            fixBodyScroll(true);
        } else {
            fixBodyScroll(false);
            $('body').removeClass('cart-is-open');
        }
    });

    document.querySelector('.float-main-menu').style.display = 'block';
    document.querySelector('.float-cart').style.display = 'block';

    if (USER_LOGGED) {
        window.drawerU = new HyDrawer(window.drawerUser, {
            range: isMobileSafari ? [30, 45] : [0, 40],
            threshold: isSafari ? 0 : 10,
            preventDefault: true,
            mouseEvents: false,
            align: 'right',
            persistent: true,
        });

        window.userTrigger.addEventListener('click', function (e) {
            e.preventDefault();
            window.drawerL["opened"] = false;
            window.drawerR["opened"] = false;
            window.drawerU.toggle();
            window.drawerL["persistent"] = true;
        });

        /* Check if panel drawer USER is open or closed when a transition end (and the panel state has changed) */
        window.drawerUser.addEventListener('hy-drawer-transitioned', function (e) {
            /* console.log('drawerU trans to', e.detail); */
            if (window.drawerU['opened'] == true && (window.drawerL['opened'] == false || window.drawerR['opened'] == false)) {
                $('body').addClass('user-is-open');
                fixBodyScroll(true);
            } else {
                fixBodyScroll(false);
                $('body').removeClass('user-is-open');
            }
        });

        document.querySelector('.float-user').style.display = 'block';
    }

    if ($('#js-open-brands-menu').length) {
        document.querySelector('#js-brands-search-input').addEventListener('touchstart', () => {
            document.querySelector('#js-brands-search-input').focus();
        })
    }
}

/**
 * smoothScrollTo
 *
 * Smoothly scrolls to the target element, with optional reference, offset, and speed control.
 *
 * @param {string} targetSelector - Selector of the target element to scroll to.
 * @param {string|HTMLElement|null} referenceSelector - Optional reference element (can be a selector, a DOM element, or `this`).
 * @param {number} [offset=0] - Additional scroll offset.
 * @param {number} [speed=1] - Scroll speed multiplier (higher value means faster scroll).
 */
function smoothScrollTo(targetSelector, referenceSelector = null, offset = 0, speed = 1) {
    const scrollAdjustment = 110; // Adjustment for smooth scrolling
    let targetElement;
    try {
        targetElement = document.querySelector(targetSelector);
        if (!targetElement) {
            return false;
        }
    } catch(e) {
        if (DEV_MODE) {
            console.error(e.message);
        }
        return false;
    }

    const targetOffset = targetElement.getBoundingClientRect().top + window.scrollY + offset;
    const finalScroll = targetOffset - scrollAdjustment;
    const start = window.scrollY;
    const scrollDistance = finalScroll - start;
    const documentHeight = document.documentElement.scrollHeight;
    const windowHeight = window.innerHeight;
    const maxScroll = documentHeight - windowHeight;
    const clampedFinalScroll = Math.max(0, Math.min(finalScroll, maxScroll));
    const clampedScrollDistance = clampedFinalScroll - start;

    const minDuration = 100;   // Minimum duration in milliseconds
    const maxDuration = 600;  // Maximum duration in milliseconds

    // Calculate the duration of the animation based on the total distance of scrolling
    const distanceRatio = Math.abs(scrollDistance) / documentHeight;
    const duration = Math.max(
        minDuration / speed,
        Math.min(maxDuration / speed, (minDuration + distanceRatio * (maxDuration - minDuration)) / speed)
    );

    // Function of easing "ease-out" for a smoother animation
    function easeOutQuad(progress) {
        return 1 - (1 - progress) * (1 - progress);
    }

    const startTime = performance.now();
    function animateScroll(currentTime) {
        const elapsedTime = currentTime - startTime;
        const progress = Math.min(elapsedTime / duration, 1);
        const easingProgress = easeOutQuad(progress);
        const scrollY = start + (clampedScrollDistance * easingProgress);
        window.scrollTo(0, scrollY);

        if (progress < 1) {
            requestAnimationFrame(animateScroll);
        }
    }
    requestAnimationFrame(animateScroll);
    return true;
}

/**
 * doInitialSmoothScroll
 *
 * Performs smooth scroll to the #anchor-id element based on the Url hash.
 * TODO: Seems that doesnt work properly... Test before use
 */

function doInitialSmoothScroll() {
    const locationHash = getUrlHash();
    const idExistInDOM = document.querySelector(`[id="${locationHash}"]`);
    if (locationHash && idExistInDOM) {
        smoothScrollTo(`#${locationHash}`);
    }
}

/**
 * initSmoothScrollEvents
 *
 * Initializes smooth scroll events for links with the `data-toggle="smooth-scroll"` attribute.
 * On click, it prevents the default navigation and performs a smooth scroll to the anchor link element (`#id_element`),
 * adjusting the position and speed based on the `data-smooth-offset` and `data-smooth-speed` attributes.
 *
 * Usage in the <a> element:
 * - `href=/#anchor-id` : Anchor id of the targetElement
 * - `data-toggle="smooth-scroll"` : Attribute to initialize the smoothScroll
 * - `data-smooth-offset="20"` : Additional scroll offset in pixels.
 * - `data-smooth-speed` : Multiplier for scroll speed (higher value means faster scroll).
 */
function initSmoothScrollEvents() {
    const smoothLinks = document.querySelectorAll('a[data-toggle="smooth-scroll"]');
    if (!smoothLinks.length) {
        return;
    }
    // Delay de seguridad para dar tiempo a que antes se ejecuten otros eventListeners.
    // p. ej.: El targetElement debe estar visible para que getBoundingClientRect() obtenga datos, y funcione correctamente el smoothScrollTo.
    const securityDelay = 5; // ms
    smoothLinks.forEach(link => {
        link.addEventListener('click', function (event) {
            if (link.hash) {
                // Remover query params y hash para una comparación de URL limpia.
                const cleanLinkHref = link.href.split('#')[0].split('?')[0];
                const cleanWindowHref = window.location.href.split('#')[0].split('?')[0];

                let linkTargetIsSamePage = cleanLinkHref === cleanWindowHref;
                if (linkTargetIsSamePage) {
                    event.preventDefault();
                }
                const offset = parseInt(link.dataset.smoothOffset, 10) || 0;
                const speed = parseFloat(link.dataset.smoothSpeed) || 1;
                _debounceFn(smoothScrollTo, securityDelay)(link.hash, link, offset, speed);
            }
        });
    });
}

function initBackToTopButton() {
    let scrollTimer;
    const backTopButton = document.getElementById('back-top');
    if (!backTopButton) {
        return;
    }
    const showBackTopElement = document.getElementById('show-back-top-btn');

    window.addEventListener('scroll', () => {
        if (scrollTimer) {
            clearTimeout(scrollTimer);
        }
        scrollTimer = setTimeout(() => {
            backTopButton.style.display = isInViewport(showBackTopElement, {
                aboveViewportAsVisible: true
            }) ? 'block' : 'none';
        }, 250);

    }, {passive: true});
}

function disableRadioAutocomplete() {
    document.querySelectorAll('input[type="radio"]').forEach(function(radio) {
        radio.setAttribute('autocomplete', 'off');
    });
}

// Show Pet Tips module at home & thankyou.
function initPetTips() {
    // Only Miscota Spain at the moment.
    if (!(SHOP_ID == 1 && COUNTRY == 195)) {
        return;
    }
    const petTips = document.querySelector('#pet-tips-module');
    const petTipsWrapper = document.querySelector('#pet-tips-wrapper');

    // Move module from bottom.html to main content, to bypass Redis Cache.
    if (petTips && petTipsWrapper) {
        petTipsWrapper.appendChild(petTips);
        petTips.classList.remove('hidden');
    }
}


/**
 * Lazy Load - verlok - Andrea Verlicchi
 * https://github.com/verlok/lazyload
 * 10.6.0
 *
 * Append to function revealElement this lines:
 if (settings.appear)
 settings.appear.call(element);
 */
var _extends = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
    }
    return e
}, _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e
} : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
};
!function (e, t) {
    "object" === ("undefined" == typeof exports ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : e.LazyLoad = t()
}(this, function () {
    "use strict";
    var c = "data-", i = function (e, t) {
            return e.getAttribute(c + t)
        }, s = function (e) {
            return e.filter(function (e) {
                return !i(e, "was-processed")
            })
        }, o = function (e, t) {
            var n, r = "LazyLoad::Initialized", s = new e(t);
            try {
                n = new CustomEvent(r, {detail: {instance: s}})
            } catch (e) {
                (n = document.createEvent("CustomEvent")).initCustomEvent(r, !1, !1, {instance: s})
            }
            window.dispatchEvent(n)
        }, l = function (e, t) {
            var n = t.data_src, r = t.data_srcset, s = e.tagName, o = i(e, n);
            if ("IMG" === s) {
                !function (e, t) {
                    var n = t.data_srcset, r = e.parentNode;
                    if (r && "PICTURE" === r.tagName) for (var s, o = 0; s = r.children[o]; o += 1) if ("SOURCE" === s.tagName) {
                        var a = i(s, n);
                        a && s.setAttribute("srcset", a)
                    }
                }(e, t);
                var a = i(e, r);
                return a && e.setAttribute("srcset", a), void (o && e.setAttribute("src", o))
            }
            "IFRAME" !== s ? o && (e.style.backgroundImage = 'url("' + o + '")') : o && e.setAttribute("src", o)
        }, e = "undefined" != typeof window, n = e && "IntersectionObserver" in window,
        a = e && "classList" in document.createElement("p"), u = function (e, t) {
            a ? e.classList.add(t) : e.className += (e.className ? " " : "") + t
        }, d = function (e, t) {
            e && e(t)
        }, f = "load", v = "error", _ = function (e, t, n) {
            e.removeEventListener(f, t), e.removeEventListener(v, n)
        }, m = function (e, t, n) {
            var r, s, o = e.target;
            r = o, s = n.class_loading, a ? r.classList.remove(s) : r.className = r.className.replace(new RegExp("(^|\\s+)" + s + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, ""), u(o, t ? n.class_loaded : n.class_error), d(t ? n.callback_load : n.callback_error, o)
        }, p = function (e, t) {
            var n, r, s, o, a, i;
            d(t.callback_enter, e), -1 < ["IMG", "IFRAME"].indexOf(e.tagName) && (r = t, s = function e(t) {
                m(t, !0, r), _(n, e, o)
            }, o = function e(t) {
                m(t, !1, r), _(n, s, e)
            }, (n = e).addEventListener(f, s), n.addEventListener(v, o), u(e, t.class_loading)), l(e, t), a = "was-processed", i = !0, e.setAttribute(c + a, i), d(t.callback_set, e), t.appear && t.appear.call(e)
        }, t = function (e, t) {
            var n;
            this._settings = (n = {
                elements_selector: "img",
                container: document,
                threshold: 300,
                data_src: "src",
                data_srcset: "srcset",
                class_loading: "loading",
                class_loaded: "loaded",
                class_error: "error",
                callback_load: null,
                callback_error: null,
                callback_set: null,
                callback_enter: null
            }, _extends({}, n, e)), this._setObserver(), this.update(t)
        };
    t.prototype = {
        _setObserver: function () {
            var r = this;
            if (n) {
                var e = this._settings,
                    t = {root: e.container === document ? null : e.container, rootMargin: e.threshold + "px"};
                this._observer = new IntersectionObserver(function (e) {
                    e.forEach(function (e) {
                        if ((n = e).isIntersecting || 0 < n.intersectionRatio) {
                            var t = e.target;
                            p(t, r._settings), r._observer.unobserve(t)
                        }
                        var n
                    }), r._elements = s(r._elements)
                }, t)
            }
        }, update: function (e) {
            var t = this, n = this._settings, r = e || n.container.querySelectorAll(n.elements_selector);
            this._elements = s(Array.prototype.slice.call(r)), this._observer ? this._elements.forEach(function (e) {
                t._observer.observe(e)
            }) : (this._elements.forEach(function (e) {
                p(e, n)
            }), this._elements = s(this._elements))
        }, destroy: function () {
            var t = this;
            this._observer && (s(this._elements).forEach(function (e) {
                t._observer.unobserve(e)
            }), this._observer = null), this._elements = null, this._settings = null
        }
    };
    var r = window.lazyLoadOptions;
    return e && r && function (e, t) {
        if (t.length) for (var n, r = 0; n = t[r]; r += 1) o(e, n); else o(e, t)
    }(t, r), t
});

/*!
 * clipboard.js v1.5.16
 * https://zenorocha.github.io/clipboard.js
 *
 * Licensed MIT © Zeno Rocha
 */
!function (e) {
    if ("object" == typeof exports && "undefined" != typeof module) module.exports = e(); else if ("function" == typeof define && define.amd) define([], e); else {
        var t;
        t = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, t.Clipboard = e()
    }
}(function () {
    var e, t, n;
    return function e(t, n, i) {
        function o(a, c) {
            if (!n[a]) {
                if (!t[a]) {
                    var l = "function" == typeof require && require;
                    if (!c && l) return l(a, !0);
                    if (r) return r(a, !0);
                    var s = new Error("Cannot find module '" + a + "'");
                    throw s.code = "MODULE_NOT_FOUND", s
                }
                var u = n[a] = {exports: {}};
                t[a][0].call(u.exports, function (e) {
                    var n = t[a][1][e];
                    return o(n ? n : e)
                }, u, u.exports, e, t, n, i)
            }
            return n[a].exports
        }

        for (var r = "function" == typeof require && require, a = 0; a < i.length; a++) o(i[a]);
        return o
    }({
        1: [function (e, t, n) {
            function i(e, t) {
                for (; e && e.nodeType !== o;) {
                    if (e.matches(t)) return e;
                    e = e.parentNode
                }
            }

            var o = 9;
            if (Element && !Element.prototype.matches) {
                var r = Element.prototype;
                r.matches = r.matchesSelector || r.mozMatchesSelector || r.msMatchesSelector || r.oMatchesSelector || r.webkitMatchesSelector
            }
            t.exports = i
        }, {}], 2: [function (e, t, n) {
            function i(e, t, n, i, r) {
                var a = o.apply(this, arguments);
                return e.addEventListener(n, a, r), {
                    destroy: function () {
                        e.removeEventListener(n, a, r)
                    }
                }
            }

            function o(e, t, n, i) {
                return function (n) {
                    n.delegateTarget = r(n.target, t), n.delegateTarget && i.call(e, n)
                }
            }

            var r = e("./closest");
            t.exports = i
        }, {"./closest": 1}], 3: [function (e, t, n) {
            n.node = function (e) {
                return void 0 !== e && e instanceof HTMLElement && 1 === e.nodeType
            }, n.nodeList = function (e) {
                var t = Object.prototype.toString.call(e);
                return void 0 !== e && ("[object NodeList]" === t || "[object HTMLCollection]" === t) && "length" in e && (0 === e.length || n.node(e[0]))
            }, n.string = function (e) {
                return "string" == typeof e || e instanceof String
            }, n.fn = function (e) {
                var t = Object.prototype.toString.call(e);
                return "[object Function]" === t
            }
        }, {}], 4: [function (e, t, n) {
            function i(e, t, n) {
                if (!e && !t && !n) throw new Error("Missing required arguments");
                if (!c.string(t)) throw new TypeError("Second argument must be a String");
                if (!c.fn(n)) throw new TypeError("Third argument must be a Function");
                if (c.node(e)) return o(e, t, n);
                if (c.nodeList(e)) return r(e, t, n);
                if (c.string(e)) return a(e, t, n);
                throw new TypeError("First argument must be a String, HTMLElement, HTMLCollection, or NodeList")
            }

            function o(e, t, n) {
                return e.addEventListener(t, n), {
                    destroy: function () {
                        e.removeEventListener(t, n)
                    }
                }
            }

            function r(e, t, n) {
                return Array.prototype.forEach.call(e, function (e) {
                    e.addEventListener(t, n)
                }), {
                    destroy: function () {
                        Array.prototype.forEach.call(e, function (e) {
                            e.removeEventListener(t, n)
                        })
                    }
                }
            }

            function a(e, t, n) {
                return l(document.body, e, t, n)
            }

            var c = e("./is"), l = e("delegate");
            t.exports = i
        }, {"./is": 3, delegate: 2}], 5: [function (e, t, n) {
            function i(e) {
                var t;
                if ("SELECT" === e.nodeName) e.focus(), t = e.value; else if ("INPUT" === e.nodeName || "TEXTAREA" === e.nodeName) e.focus(), e.setSelectionRange(0, e.value.length), t = e.value; else {
                    e.hasAttribute("contenteditable") && e.focus();
                    var n = window.getSelection(), i = document.createRange();
                    i.selectNodeContents(e), n.removeAllRanges(), n.addRange(i), t = n.toString()
                }
                return t
            }

            t.exports = i
        }, {}], 6: [function (e, t, n) {
            function i() {
            }

            i.prototype = {
                on: function (e, t, n) {
                    var i = this.e || (this.e = {});
                    return (i[e] || (i[e] = [])).push({fn: t, ctx: n}), this
                }, once: function (e, t, n) {
                    function i() {
                        o.off(e, i), t.apply(n, arguments)
                    }

                    var o = this;
                    return i._ = t, this.on(e, i, n)
                }, emit: function (e) {
                    var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), i = 0,
                        o = n.length;
                    for (i; i < o; i++) n[i].fn.apply(n[i].ctx, t);
                    return this
                }, off: function (e, t) {
                    var n = this.e || (this.e = {}), i = n[e], o = [];
                    if (i && t) for (var r = 0, a = i.length; r < a; r++) i[r].fn !== t && i[r].fn._ !== t && o.push(i[r]);
                    return o.length ? n[e] = o : delete n[e], this
                }
            }, t.exports = i
        }, {}], 7: [function (t, n, i) {
            !function (o, r) {
                if ("function" == typeof e && e.amd) e(["module", "select"], r); else if ("undefined" != typeof i) r(n, t("select")); else {
                    var a = {exports: {}};
                    r(a, o.select), o.clipboardAction = a.exports
                }
            }(this, function (e, t) {
                "use strict";

                function n(e) {
                    return e && e.__esModule ? e : {default: e}
                }

                function i(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }

                var o = n(t), r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
                    return typeof e
                } : function (e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                }, a = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }

                    return function (t, n, i) {
                        return n && e(t.prototype, n), i && e(t, i), t
                    }
                }(), c = function () {
                    function e(t) {
                        i(this, e), this.resolveOptions(t), this.initSelection()
                    }

                    return a(e, [{
                        key: "resolveOptions", value: function e() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            this.action = t.action, this.emitter = t.emitter, this.target = t.target, this.text = t.text, this.trigger = t.trigger, this.selectedText = ""
                        }
                    }, {
                        key: "initSelection", value: function e() {
                            this.text ? this.selectFake() : this.target && this.selectTarget()
                        }
                    }, {
                        key: "selectFake", value: function e() {
                            var t = this, n = "rtl" == document.documentElement.getAttribute("dir");
                            this.removeFake(), this.fakeHandlerCallback = function () {
                                return t.removeFake()
                            }, this.fakeHandler = document.body.addEventListener("click", this.fakeHandlerCallback) || !0, this.fakeElem = document.createElement("textarea"), this.fakeElem.style.fontSize = "12pt", this.fakeElem.style.border = "0", this.fakeElem.style.padding = "0", this.fakeElem.style.margin = "0", this.fakeElem.style.position = "absolute", this.fakeElem.style[n ? "right" : "left"] = "-9999px";
                            var i = window.pageYOffset || document.documentElement.scrollTop;
                            this.fakeElem.addEventListener("focus", window.scrollTo(0, i)), this.fakeElem.style.top = i + "px", this.fakeElem.setAttribute("readonly", ""), this.fakeElem.value = this.text, document.body.appendChild(this.fakeElem), this.selectedText = (0, o.default)(this.fakeElem), this.copyText()
                        }
                    }, {
                        key: "removeFake", value: function e() {
                            this.fakeHandler && (document.body.removeEventListener("click", this.fakeHandlerCallback), this.fakeHandler = null, this.fakeHandlerCallback = null), this.fakeElem && (document.body.removeChild(this.fakeElem), this.fakeElem = null)
                        }
                    }, {
                        key: "selectTarget", value: function e() {
                            this.selectedText = (0, o.default)(this.target), this.copyText()
                        }
                    }, {
                        key: "copyText", value: function e() {
                            var t = void 0;
                            try {
                                t = document.execCommand(this.action)
                            } catch (e) {
                                t = !1
                            }
                            this.handleResult(t)
                        }
                    }, {
                        key: "handleResult", value: function e(t) {
                            this.emitter.emit(t ? "success" : "error", {
                                action: this.action,
                                text: this.selectedText,
                                trigger: this.trigger,
                                clearSelection: this.clearSelection.bind(this)
                            })
                        }
                    }, {
                        key: "clearSelection", value: function e() {
                            this.target && this.target.blur(), window.getSelection().removeAllRanges()
                        }
                    }, {
                        key: "destroy", value: function e() {
                            this.removeFake()
                        }
                    }, {
                        key: "action", set: function e() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "copy";
                            if (this._action = t, "copy" !== this._action && "cut" !== this._action) throw new Error('Invalid "action" value, use either "copy" or "cut"')
                        }, get: function e() {
                            return this._action
                        }
                    }, {
                        key: "target", set: function e(t) {
                            if (void 0 !== t) {
                                if (!t || "object" !== ("undefined" == typeof t ? "undefined" : r(t)) || 1 !== t.nodeType) throw new Error('Invalid "target" value, use a valid Element');
                                if ("copy" === this.action && t.hasAttribute("disabled")) throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                                if ("cut" === this.action && (t.hasAttribute("readonly") || t.hasAttribute("disabled"))) throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                                this._target = t
                            }
                        }, get: function e() {
                            return this._target
                        }
                    }]), e
                }();
                e.exports = c
            })
        }, {select: 5}], 8: [function (t, n, i) {
            !function (o, r) {
                if ("function" == typeof e && e.amd) e(["module", "./clipboard-action", "tiny-emitter", "good-listener"], r); else if ("undefined" != typeof i) r(n, t("./clipboard-action"), t("tiny-emitter"), t("good-listener")); else {
                    var a = {exports: {}};
                    r(a, o.clipboardAction, o.tinyEmitter, o.goodListener), o.clipboard = a.exports
                }
            }(this, function (e, t, n, i) {
                "use strict";

                function o(e) {
                    return e && e.__esModule ? e : {default: e}
                }

                function r(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
                }

                function a(e, t) {
                    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return !t || "object" != typeof t && "function" != typeof t ? e : t
                }

                function c(e, t) {
                    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                    e.prototype = Object.create(t && t.prototype, {
                        constructor: {
                            value: e,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
                }

                function l(e, t) {
                    var n = "data-clipboard-" + e;
                    if (t.hasAttribute(n)) return t.getAttribute(n)
                }

                var s = o(t), u = o(n), f = o(i), d = function () {
                    function e(e, t) {
                        for (var n = 0; n < t.length; n++) {
                            var i = t[n];
                            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
                        }
                    }

                    return function (t, n, i) {
                        return n && e(t.prototype, n), i && e(t, i), t
                    }
                }(), h = function (e) {
                    function t(e, n) {
                        r(this, t);
                        var i = a(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this));
                        return i.resolveOptions(n), i.listenClick(e), i
                    }

                    return c(t, e), d(t, [{
                        key: "resolveOptions", value: function e() {
                            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                            this.action = "function" == typeof t.action ? t.action : this.defaultAction, this.target = "function" == typeof t.target ? t.target : this.defaultTarget, this.text = "function" == typeof t.text ? t.text : this.defaultText
                        }
                    }, {
                        key: "listenClick", value: function e(t) {
                            var n = this;
                            this.listener = (0, f.default)(t, "click", function (e) {
                                return n.onClick(e)
                            })
                        }
                    }, {
                        key: "onClick", value: function e(t) {
                            var n = t.delegateTarget || t.currentTarget;
                            this.clipboardAction && (this.clipboardAction = null), this.clipboardAction = new s.default({
                                action: this.action(n),
                                target: this.target(n),
                                text: this.text(n),
                                trigger: n,
                                emitter: this
                            })
                        }
                    }, {
                        key: "defaultAction", value: function e(t) {
                            return l("action", t)
                        }
                    }, {
                        key: "defaultTarget", value: function e(t) {
                            var n = l("target", t);
                            if (n) return document.querySelector(n)
                        }
                    }, {
                        key: "defaultText", value: function e(t) {
                            return l("text", t)
                        }
                    }, {
                        key: "destroy", value: function e() {
                            this.listener.destroy(), this.clipboardAction && (this.clipboardAction.destroy(), this.clipboardAction = null)
                        }
                    }]), t
                }(u.default);
                e.exports = h
            })
        }, {"./clipboard-action": 7, "good-listener": 4, "tiny-emitter": 6}]
    }, {}, [8])(8)
});


/**
 * Tabslet | tabs jQuery plugin
 *
 * @copyright Copyright 2015, Dimitris Krestos
 * @license   Apache License, Version 2.0 (http://www.opensource.org/licenses/apache2.0.php)
 * @link      http://vdw.staytuned.gr
 * @version   v1.7.3
 */
!function ($, window, undefined) {
    "use strict";
    $.fn.tabslet = function (options) {
        var defaults = {
            tabs: !1,
            contents: !1,
            mouseevent: "click",
            activeclass: "active",
            attribute: "href",
            animation: !1,
            autorotate: !1,
            deeplinking: !1,
            pauseonhover: !0,
            delay: 2e3,
            active: 1,
            container: !1,
            controls: {prev: ".prev", next: ".next"}
        }, options = $.extend(defaults, options);
        return this.each(function () {
            function deep_link() {
                var t = [];
                elements.find("a").each(function () {
                    t.push($(this).attr($this.opts.attribute))
                });
                var e = $.inArray(location.hash, t);
                return e > -1 ? e + 1 : $this.data("active") || options.active
            }

            var $this = $(this), _cache_li = [], _cache_div = [],
                _container = options.container ? $(options.container) : $this,
                _tabs = options.contents ? $(options.contents) : _container.find("> div");
            _tabs.each(function () {
                _cache_div.push($(this).css("display"))
            });
            var elements = options.tabs ? $(options.tabs) : $this.find("> ul > li"), i = options.active - 1;
            if (!$this.data("tabslet-init")) {
                $this.data("tabslet-init", !0), $this.opts = [], $.map(["mouseevent", "activeclass", "attribute", "animation", "autorotate", "deeplinking", "pauseonhover", "delay", "container"], function (t, e) {
                    $this.opts[t] = $this.data(t) || options[t]
                }), $this.opts.active = $this.opts.deeplinking ? deep_link() : $this.data("active") || options.active, _tabs.hide(), $this.opts.active && (_tabs.eq($this.opts.active - 1).show(), elements.eq($this.opts.active - 1).addClass(options.activeclass));
                var fn = eval(function (t, e) {
                    var s = e ? elements.find("a[" + $this.opts.attribute + '="' + e + '"]').parent() : $(this);
                    s.trigger("_before"), elements.removeClass(options.activeclass), s.addClass(options.activeclass), _tabs.hide(), i = elements.index(s);
                    var o = e || s.find("a").attr($this.opts.attribute);
                    return $this.opts.deeplinking && (location.hash = o), $this.opts.animation ? _container.find(o).animate({opacity: "show"}, "slow", function () {
                        s.trigger("_after", o)
                    }) : (_container.find(o).show(), s.trigger("_after", o)), !1
                }), init = elements[$this.opts.mouseevent](fn), t, forward = function () {
                    i = ++i % elements.length, "hover" == $this.opts.mouseevent ? elements.eq(i).trigger("mouseover") : elements.eq(i).click(), $this.opts.autorotate && (clearTimeout(t), t = setTimeout(forward, $this.opts.delay), $this.mouseover(function () {
                        $this.opts.pauseonhover && clearTimeout(t)
                    }))
                };
                $this.opts.autorotate && (t = setTimeout(forward, $this.opts.delay), $this.hover(function () {
                    $this.opts.pauseonhover && clearTimeout(t)
                }, function () {
                    t = setTimeout(forward, $this.opts.delay)
                }), $this.opts.pauseonhover && $this.bind("mouseleave", function () {
                    clearTimeout(t), t = setTimeout(forward, $this.opts.delay)
                }));
                var move = function (t) {
                    "forward" == t && (i = ++i % elements.length), "backward" == t && (i = --i % elements.length), elements.eq(i).click()
                };
                $this.find(options.controls.next).click(function () {
                    move("forward")
                }), $this.find(options.controls.prev).click(function () {
                    move("backward")
                }), $this.bind("show", function (t, e) {
                    fn(t, e)
                }), $this.bind("next", function () {
                    move("forward")
                }), $this.bind("prev", function () {
                    move("backward")
                }), $this.bind("destroy", function () {
                    $(this).removeData(), elements.each(function (t) {
                        $(this).removeClass(options.activeclass)
                    }), _tabs.each(function (t) {
                        $(this).removeAttr("style").css("display", _cache_div[t])
                    })
                })
            }
        })
    }, $(document).ready(function () {
        $('[data-toggle="tabslet"]').tabslet()
    })
}(jQuery);


/**
 *  DRAGGABLE VANILLA JS --------------------------------------
 * Makes an element draggable!
 * Customized from: https://gist.github.com/remarkablemark/5002d27442600510d454a5aeba370579
 * @param (element) = element CLASS or ID
 * initialize with ID    -->  makeDraggable(document.getElementById('element_ID'));
 * initialize with CLASS -->  makeDraggable(document.getElementsByClassName('element_CLASS')[0]);
 * --------------------------------------------------------- */

function makeDraggable(element) {
    var isMouseDown = false;
    // initial mouse X and Y for `mousedown`
    var mouseX;
    var mouseY;
    // element X and Y before and after move
    var elementX = 0;
    var elementY = 0;
    // mouse button down over the element
    element.addEventListener('mousedown', onMouseDown);

    /**
     * Listens to `mousedown` event.
     * @param {Object} event - The event.
     */
    function onMouseDown(event) {
        //console.log('botón:' + event.button);
        var target = $(event.target);
        if (target.is('.data-content input, button, textarea') || event.button != 0) { /* We detect if click is not over an input or button element, OR with center or right click. If not, then move/drag the element. */

        } else {
            mouseX = event.clientX;
            mouseY = event.clientY;
            isMouseDown = true;
        }
    }

    // mouse button released
    element.addEventListener('mouseup', onMouseUp);

    /**
     * Listens to `mouseup` event.
     * @param {Object} event - The event.
     */
    function onMouseUp(event) {
        isMouseDown = false;
        elementX = parseInt(element.style.left) || 0;
        elementY = parseInt(element.style.top) || 0;
    }

    // need to attach to the entire document
    // in order to take full width and height
    // this ensures the element keeps up with the mouse
    document.addEventListener('mousemove', onMouseMove);

    /**
     * Listens to `mousemove` event.
     * @param {Object} event - The event.
     */
    function onMouseMove(event) {
        if (!isMouseDown) return;
        var deltaX = event.clientX - mouseX;
        var deltaY = event.clientY - mouseY;
        element.style.left = elementX + deltaX + 'px';
        element.style.top = elementY + deltaY + 'px';
    }

    element.classList.remove('process-draggable');
}

/* END Draggable ----------------------------------------------- */

/**
 * SVG Symbols Splash! *******
 * The symbolArray parameter must be an array of svg symbols present in the DOM, such as: ['#heart_line', '#heart_full'].
 * parameter multiplier must be an integer number between 1 - 5. If false, default value is 2.
 * by borx
 */
function splashSymbols(symbolArray, multiplier, minX = -100, maxX = 100, minY = -150, maxY = 100) {
    var symbolArray = typeof symbolArray == 'object' ? symbolArray : false;
    var symbolsOk = 0;

    for (let i = 0; i < symbolArray.length; i++) {
        if ($(symbolArray[i]).length) symbolsOk++;
    }

    if (symbolArray == false || symbolArray.length != symbolsOk) {
        console.log('Wrong or missing parameters!');
        return false; // stop if wrong or missing parameters
    }

    var multiplier = typeof multiplier == 'number' && multiplier > 0 ? multiplier : 2,
        particles = 12 + (multiplier * 20), // Change with care. Great values may freeze the browser.
        $wrapper = $('.splash-wrapper');

    // create symbols div container
    var symbolsDiv = document.createElement('div');
    symbolsDiv.classList.add('symbols-wrapper');
    $wrapper.append(symbolsDiv);

    for (let i = 0; i <= particles; i++) {
        var randomSymbol = Math.floor(getRandom(0, symbolArray.length));

        // setting the x, y random end position for each symbol (to use with reverse direction css animation!)
        var x = getRandom(minX, maxX),
            y = getRandom(minY, maxY),
            deg = getRandom(-60, 60) + 'deg',
            scale = getRandom(.1, 3),
            symbolID = symbolArray[randomSymbol];

        // creating new symbols by cloning from DOM
        var newSymbol = document.querySelector(symbolID).cloneNode(true);
        newSymbol.classList.add('splash-symbol');
        newSymbol.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) scale(' + scale + ') rotate(' + deg + ')';
        newSymbol.style.animationDelay = '0.' + i + 's';

        // append new symbol to DOM on each iteration
        symbolsDiv.append(newSymbol);

        if (i == particles) { // delete at the end
            $(newSymbol).one('webkitAnimationEnd oanimationend msAnimationEnd animationend', function () {
                let timer = setTimeout(function () { // set timer when css animation is finished
                    symbolsDiv.remove(); // remove particles
                    window.clearTimeout(timer); // clear timer
                }, 3000);
            });
        }
    }
}
